/**
 * door-conf2-update.js — Shopify door configurator UI add-ons.
 * Casing picker, custom select dropdowns, seal-kit / door-sweeps / priming price sync.
 * Loaded by door-configurator-snippet.liquid after door-conf2.js.
 */
(function () {
    var SVG_NS = 'http://www.w3.org/2000/svg';

    function all(selector, root) {
        try {
            return Array.prototype.slice.call((root || document).querySelectorAll(selector) || []);
        } catch (e) {
            return [];
        }
    }

    function clearElement(el) {
        if (!el) return;
        while (el.firstChild) el.removeChild(el.firstChild);
    }

    // --- Dp start 15-07 ---
    function normalizeForBacksetMatch(s) {
        return String(s == null ? '' : s)
            .toLowerCase()
            .replace(/_inch/g, '')
            .replace(/inch/g, '')
            .replace(/"/g, '')
            .replace(/[^a-z0-9]/g, '')
            .trim();
    }

    function resolveLandingHardwareBacksetAllow(cardEl) {
        var allowListRaw = '';
        if (cardEl) {
            allowListRaw = cardEl.getAttribute('data-hardware-backset')
                || cardEl.getAttribute('data-backset-allow')
                || cardEl.getAttribute('data-hardware-backset-allow')
                || cardEl.getAttribute('data-backset')
                || '';
            if (!allowListRaw) {
                var root = cardEl.closest ? cardEl.closest('[data-landing-hardware-config="1"]') : null;
                if (root) {
                    allowListRaw = root.getAttribute('data-hardware-backset')
                        || root.getAttribute('data-backset-allow')
                        || root.getAttribute('data-hardware-backset-allow')
                        || '';
                }
            }
        }
        if (!allowListRaw) {
            allowListRaw = window.__landingHardwareBackset
                || window.__landingHardwareBacksetAllow
                || '';
        }
        if (!allowListRaw && cardEl) {
            var productId = cardEl.getAttribute('data-product-id') || cardEl.getAttribute('data-choice-value') || '';
            if (productId) {
                try {
                    var products = [];
                    if (typeof window.DoorConf2Hardware !== 'undefined'
                        && typeof window.DoorConf2Hardware.readRecommendedHardwareProducts === 'function') {
                        products = window.DoorConf2Hardware.readRecommendedHardwareProducts();
                    }
                    if (products && products.length) {
                        for (var i = 0; i < products.length; i++) {
                            var p = products[i];
                            if (p && (String(p.id) === String(productId) || String(p.handle) === String(productId))) {
                                allowListRaw = p.hardware_backset || p.backset_allow || p.hardware_backset_allow || p.backsetItems || p.backset || p.Door_Backset || '';
                                break;
                            }
                        }
                    }
                } catch (eHwBs) { }
            }
        }
        return allowListRaw ? String(allowListRaw) : '';
    }

    function filterBacksetSelectElement(selectEl, cardEl) {
        if (!selectEl) return;
        var allowListRaw = resolveLandingHardwareBacksetAllow(cardEl);
        if (!allowListRaw) return;

        var rawList = String(allowListRaw).split(',').map(function (item) {
            return normalizeForBacksetMatch(item);
        }).filter(Boolean);
        if (!rawList.length) return;

        if (!selectEl._originalOptions) {
            selectEl._originalOptions = Array.from(selectEl.options).map(function (opt) {
                return { value: opt.value, text: opt.textContent, selected: opt.selected };
            });
        }

        var originalVal = selectEl.value;
        var filteredOptions = selectEl._originalOptions.filter(function (opt) {
            var normVal = normalizeForBacksetMatch(opt.value);
            var normText = normalizeForBacksetMatch(opt.text);
            return rawList.indexOf(normVal) !== -1 || rawList.indexOf(normText) !== -1;
        });

        if (!filteredOptions.length) return;

        selectEl.innerHTML = '';
        var newSelectedValue = '';
        filteredOptions.forEach(function (opt) {
            var newOpt = document.createElement('option');
            newOpt.value = opt.value;
            newOpt.textContent = opt.text;
            selectEl.appendChild(newOpt);
            if (opt.value === originalVal) {
                newSelectedValue = opt.value;
            }
        });

        if (newSelectedValue) {
            selectEl.value = newSelectedValue;
        } else {
            selectEl.value = filteredOptions[0].value;
        }

        // Rebuild custom dropdown when native options changed after enhancement.
        var linked = selectEl.nextElementSibling;
        if (linked && linked.classList && linked.classList.contains('door-div-select')) {
            try { rebuildDoorDivSelectOptions(selectEl, linked); } catch (eRebuild) {
                try { enhanceDoorSelectWithDivDropdown(selectEl); } catch (eEnh) { }
            }
        }
    }
    // --- Dp end 15-07 ---

    function commitCasingPickerImageSrc(img, src) {
        var s = String(src || '').trim();
        if (!img || !s) return;
        if (img.getAttribute('data-door-casing-thumb-loaded') === '1' && img.getAttribute('src') === s) return;
        img.setAttribute('data-door-casing-thumb-src', s);
        img.setAttribute('data-door-casing-thumb-loaded', '1');
        img.removeAttribute('data-door-casing-thumb-deferred');
        img.src = s;
    }

    function deferCasingPickerImage(img, src) {
        var s = String(src || '').trim();
        if (!img || !s) return;
        img.setAttribute('data-door-casing-thumb-deferred', '1');
        img.setAttribute('data-door-casing-thumb-src', s);
        img.loading = 'lazy';
        img.decoding = 'async';
    }

    function hydrateCasingPickerImages(scope) {
        var root = scope || document;
        root.querySelectorAll('img[data-door-casing-thumb-deferred="1"]').forEach(function (img) {
            var s = img.getAttribute('data-door-casing-thumb-src');
            if (!s) return;
            commitCasingPickerImageSrc(img, s);
        });
    }

    function bindCasingAccordionImageHydrate() {
        if (window.__doorCasingThumbBound) return;
        window.__doorCasingThumbBound = true;
        document.addEventListener('click', function (e) {
            var btn = e.target && e.target.closest && e.target.closest('.door-post-lockset-casing-options .door-accordion-header');
            if (!btn) return;
            setTimeout(function () {
                var body = btn.nextElementSibling;
                if (body && body.classList.contains('door-accordion-body--open')) {
                    hydrateCasingPickerImages(body);
                }
            }, 0);
        }, true);
    }

    function setCasingPriceRowText(priceRow, priceTxt) {
        clearElement(priceRow);
        var span = document.createElement('span');
        span.setAttribute('data-casing-price', '');
        if (priceTxt) {
            span.textContent = priceTxt;
            priceRow.appendChild(span);
            priceRow.appendChild(document.createTextNode(' as configured'));
        } else {
            priceRow.appendChild(span);
        }
    }

    function createSvgEl(tag, attrs) {
        var el = document.createElementNS(SVG_NS, tag);
        if (attrs) {
            Object.keys(attrs).forEach(function (key) {
                el.setAttribute(key, attrs[key]);
            });
        }
        return el;
    }

    function appendChevronDownIcon(container) {
        var svg = createSvgEl('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            'aria-hidden': 'true'
        });
        svg.appendChild(createSvgEl('path', {
            d: 'M4 6l4 4 4-4',
            stroke: 'currentColor',
            'stroke-width': '1.5',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
        }));
        container.appendChild(svg);
    }

    function appendRemoveCasingButtonContent(button) {
        button.appendChild(document.createTextNode('Remove '));
        var svg = createSvgEl('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none'
        });
        svg.appendChild(createSvgEl('path', {
            d: 'M10.6667 4.00065V3.46732C10.6667 2.72058 10.6667 2.34721 10.5213 2.062C10.3935 1.81111 10.1895 1.60714 9.93865 1.47931C9.65344 1.33398 9.28007 1.33398 8.53333 1.33398H7.46667C6.71993 1.33398 6.34656 1.33398 6.06135 1.47931C5.81046 1.60714 5.60649 1.81111 5.47866 2.062C5.33333 2.34721 5.33333 2.72058 5.33333 3.46732V4.00065M6.66667 7.66732V11.0007M9.33333 7.66732V11.0007M2 4.00065H14M12.6667 4.00065V11.4673C12.6667 12.5874 12.6667 13.1475 12.4487 13.5753C12.2569 13.9516 11.951 14.2576 11.5746 14.4493C11.1468 14.6673 10.5868 14.6673 9.46667 14.6673H6.53333C5.41323 14.6673 4.85318 14.6673 4.42535 14.4493C4.04903 14.2576 3.74307 13.9516 3.55132 13.5753C3.33333 13.1475 3.33333 12.5874 3.33333 11.4673V4.00065',
            stroke: 'currentColor',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
        }));
        button.appendChild(svg);
    }

    function isConfiguratorTooltipBtn(btn) {
        if (!btn || !btn.classList) return false;
        return btn.classList.contains('inserts-tooltip-btn');
    }

    function isCustomConfiguratorDrawerBtn(btn) {
        if (!btn || !btn.classList) return false;
        return btn.classList.contains('door-edge-profile-btn')
            || btn.classList.contains('door-panel-profile-btn')
            || btn.classList.contains('door-panel-unit-design-btn')
            || btn.classList.contains('door-lockset-prep-btn');
    }

    function getTriggerText(el) {
        return String(el && el.textContent || '').trim().toLowerCase();
    }

    function drawerHaystack(ctx) {
        if (!ctx) return '';
        return String((ctx.drawerUid || '') + ' ' + (ctx.modalId || '') + ' ' + (ctx.triggerText || '') + ' ' + (ctx.modalTitle || '')).toLowerCase();
    }

    function contextMatchesKeywords(ctx, includes, excludes) {
        var hay = drawerHaystack(ctx);
        if (includes && includes.length) {
            var ok = false;
            for (var i = 0; i < includes.length; i++) {
                if (hay.indexOf(String(includes[i]).toLowerCase()) !== -1) {
                    ok = true;
                    break;
                }
            }
            if (!ok) return false;
        }
        if (excludes && excludes.length) {
            for (var j = 0; j < excludes.length; j++) {
                if (hay.indexOf(String(excludes[j]).toLowerCase()) !== -1) return false;
            }
        }
        return true;
    }

    function listThemeWoodDrawerTriggers() {
        return all('button[data-wood-drawer-open][aria-controls]').filter(function (btn) {
            return !isCustomConfiguratorDrawerBtn(btn);
        });
    }

    function buildWoodSpeciesDrawerContextFromTrigger(btn) {
        if (!btn || !btn.getAttribute) return null;
        var ac = String(btn.getAttribute('aria-controls') || '').trim();
        if (!ac) return null;
        var modal = document.getElementById(ac);
        if (!modal) return null;
        var root = modal.closest('.wood-species-snippet');
        if (root) return buildWoodSpeciesDrawerContext(root);
        var ctx = {
            type: 'wood-species',
            root: null,
            modal: modal,
            panel: modal.querySelector('.wood-species-modal__panel'),
            trigger: btn,
            drawerUid: '',
            modalId: modal.id || '',
            triggerText: getTriggerText(btn)
        };
        ctx.modalTitle = getWoodSpeciesModalTitle(ctx);
        return ctx;
    }

    function findWoodSpeciesDrawerByKeywords(includes, excludes) {
        var contexts = listWoodSpeciesDrawerContexts();
        for (var i = 0; i < contexts.length; i++) {
            if (contextMatchesKeywords(contexts[i], includes, excludes)) return contexts[i];
        }
        var triggers = listThemeWoodDrawerTriggers();
        for (var j = 0; j < triggers.length; j++) {
            var ctxFromBtn = buildWoodSpeciesDrawerContextFromTrigger(triggers[j]);
            if (ctxFromBtn && contextMatchesKeywords(ctxFromBtn, includes, excludes)) return ctxFromBtn;
        }
        return null;
    }

    function resolveStormGlassDrawerContext() {
        return findWoodSpeciesDrawerContext({ token: 'select_storm_glass' })
            || findWoodSpeciesDrawerContext({ token: 'storm_glass' })
            || findWoodSpeciesDrawerByKeywords(
                ['storm glass', 'glass type', 'glass options', 'about glass'],
                ['screen type', 'screen insert', 'edge profile', 'stile', 'rail', 'door setup', 'wood species', 'panel profile', 'lockset']
            )
            || findWoodSpeciesDrawerByKeywords(
                ['storm', 'glass'],
                ['screen', 'stile', 'rail', 'door setup', 'wood species', 'panel profile', 'lockset', 'edge profile info']
            )
            || findWoodDrawerByAriaToken('select_storm_glass')
            || findWoodDrawerByAriaToken('storm_glass')
            || (function () {
                var edgeContexts = listWoodSpeciesDrawerContexts().filter(function (ctx) {
                    var hay = drawerHaystack(ctx);
                    if (hay.indexOf('edge_profile') === -1 && hay.indexOf('edge-profile') === -1) return false;
                    if (hay.indexOf('edge_profile_info') !== -1) return false;
                    return contextMatchesKeywords(ctx, ['glass', 'storm'], ['stile', 'rail', 'door setup', 'screen type', 'screen insert']);
                });
                return edgeContexts.length ? edgeContexts[0] : null;
            })();
    }

    function resolvePanelProfileDrawerContext() {
        return findWoodSpeciesDrawerContext({ token: 'panel_profile' })
            || findWoodSpeciesDrawerByKeywords(
                ['panel profile', 'panel profiles', 'panel unit design', 'panel unit'],
                ['lockset', 'glass', 'storm', 'screen', 'wood species', 'edge profile', 'stile', 'rail', 'door setup']
            )
            || findWoodDrawerByAriaToken('panel_profile');
    }

    function resolveLocksetPrepDrawerContext() {
        return findWoodSpeciesDrawerContext({ token: 'lockset_prep' })
            || findWoodSpeciesDrawerContext({ token: 'lockset-prep' })
            || findWoodSpeciesDrawerByKeywords(
                ['lockset prep', 'lockset preparation', 'lock prep', 'about lockset'],
                ['panel profile', 'glass', 'storm', 'screen', 'wood species', 'edge profile', 'stile', 'rail', 'door setup']
            )
            || findWoodDrawerByAriaToken('lockset_prep')
            || findWoodDrawerByAriaToken('lockset-prep')
            || findWoodDrawerByAriaToken('lockset', ['panel_profile', 'select_screen', 'select_storm_glass', 'wood_species']);
    }

    function haystackHasToken(haystack, token) {
        return String(haystack || '').indexOf(String(token || '').toLowerCase()) !== -1;
    }

    function haystackHasAnyToken(haystack, tokens) {
        for (var i = 0; i < tokens.length; i++) {
            if (haystackHasToken(haystack, tokens[i])) return true;
        }
        return false;
    }

    function openThemeSidebarModalDirect(modal, panel) {
        if (!modal) return false;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        if (panel && panel.focus) {
            try { panel.focus(); } catch (eFocus) { }
        }
        return true;
    }

    function openThemeDrawerContext(ctx) {
        if (!ctx || !ctx.modal) return false;
        if (ctx.trigger) {
            try {
                ctx.trigger.click();
                return true;
            } catch (eThemeClick) { }
        }
        return openThemeSidebarModalDirect(ctx.modal, ctx.panel);
    }

    function getThemeDrawerModalId(ctx) {
        return ctx && ctx.modal && ctx.modal.id ? ctx.modal.id : '';
    }

    function getWoodSpeciesModalTitle(ctx) {
        if (!ctx || !ctx.modal) return '';
        var titleEl = ctx.modal.querySelector('.wood-species-modal__title, [id*="wood-species-title"], .common-sidebar-header h5');
        return String(titleEl && titleEl.textContent || '').trim().toLowerCase();
    }

    function buildWoodSpeciesDrawerContext(root) {
        if (!root) return null;
        var modal = root.querySelector('.wood-species-modal[id]');
        if (!modal) return null;
        var trigger = root.querySelector('[data-wood-drawer-open]');
        var ctx = {
            type: 'wood-species',
            root: root,
            modal: modal,
            panel: root.querySelector('.wood-species-modal__panel'),
            trigger: trigger,
            drawerUid: root.getAttribute('data-drawer-id') || '',
            modalId: modal.id || '',
            triggerText: getTriggerText(trigger)
        };
        ctx.modalTitle = getWoodSpeciesModalTitle(ctx);
        return ctx;
    }

    function listWoodSpeciesDrawerContexts() {
        return all('.wood-species-snippet[data-drawer-id]').map(buildWoodSpeciesDrawerContext).filter(Boolean);
    }

    function findWoodSpeciesDrawerContext(spec) {
        spec = spec || {};
        var token = String(spec.token || '').toLowerCase();
        var excludeTokens = spec.excludeTokens || [];
        var contexts = listWoodSpeciesDrawerContexts();
        var matched = contexts.filter(function (ctx) {
            var hay = drawerHaystack(ctx);
            if (token && !haystackHasToken(hay, token)) return false;
            for (var i = 0; i < excludeTokens.length; i++) {
                if (haystackHasToken(hay, excludeTokens[i])) return false;
            }
            if (spec.triggerTextIncludes && spec.triggerTextIncludes.length) {
                var incOk = false;
                for (var j = 0; j < spec.triggerTextIncludes.length; j++) {
                    if (hay.indexOf(String(spec.triggerTextIncludes[j]).toLowerCase()) !== -1) {
                        incOk = true;
                        break;
                    }
                }
                if (!incOk) return false;
            }
            if (spec.triggerTextExcludes && spec.triggerTextExcludes.length) {
                for (var k = 0; k < spec.triggerTextExcludes.length; k++) {
                    if (hay.indexOf(String(spec.triggerTextExcludes[k]).toLowerCase()) !== -1) return false;
                }
            }
            return true;
        });
        if (spec.preferTriggerText && matched.length > 1) {
            var pref = String(spec.preferTriggerText).toLowerCase();
            var prefMatched = matched.filter(function (ctx) {
                return ctx.triggerText.indexOf(pref) !== -1;
            });
            if (prefMatched.length) matched = prefMatched;
        }
        if (matched.length) return matched[0];
        if (!token) return null;
        var modal = document.querySelector('.wood-species-modal[id*="' + token.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]');
        if (!modal) return null;
        var rootFromModal = modal.closest('.wood-species-snippet');
        if (rootFromModal) return buildWoodSpeciesDrawerContext(rootFromModal);
        var triggerFromModal = document.querySelector('button[aria-controls="' + String(modal.id || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]');
        var ctxFromModal = {
            type: 'wood-species',
            root: rootFromModal,
            modal: modal,
            panel: modal.querySelector('.wood-species-modal__panel'),
            trigger: triggerFromModal,
            drawerUid: '',
            modalId: modal.id || '',
            triggerText: getTriggerText(triggerFromModal)
        };
        ctxFromModal.modalTitle = getWoodSpeciesModalTitle(ctxFromModal);
        return ctxFromModal;
    }

    function findWoodSpeciesDrawerByTriggerText(textIncludes, textExcludes) {
        var inc = Array.isArray(textIncludes) ? textIncludes : [textIncludes];
        var exc = Array.isArray(textExcludes) ? textExcludes : (textExcludes ? [textExcludes] : []);
        return findWoodSpeciesDrawerContext({
            triggerTextIncludes: inc,
            triggerTextExcludes: exc
        });
    }

    function findWoodDrawerByAriaToken(token, excludeTokens) {
        var t = String(token || '').toLowerCase();
        if (!t) return null;
        var btns = all('button.wood-species-open-btn[aria-controls], button[aria-controls][data-wood-drawer-open]');
        for (var i = 0; i < btns.length; i++) {
            var b = btns[i];
            if (isCustomConfiguratorDrawerBtn(b)) continue;
            var ac = String(b.getAttribute('aria-controls') || '').toLowerCase();
            if (ac.indexOf(t) === -1) continue;
            if (excludeTokens && excludeTokens.length) {
                var skip = false;
                for (var j = 0; j < excludeTokens.length; j++) {
                    if (ac.indexOf(String(excludeTokens[j]).toLowerCase()) !== -1) {
                        skip = true;
                        break;
                    }
                }
                if (skip) continue;
            }
            var modal = document.getElementById(b.getAttribute('aria-controls') || '');
            if (!modal) continue;
            return {
                type: 'wood-species',
                root: modal.closest('.wood-species-snippet'),
                modal: modal,
                panel: modal.querySelector('.wood-species-modal__panel'),
                trigger: b,
                drawerUid: '',
                modalId: modal.id || '',
                triggerText: getTriggerText(b),
                modalTitle: getWoodSpeciesModalTitle({ modal: modal })
            };
        }
        return findWoodSpeciesDrawerContext({ token: token, excludeTokens: excludeTokens || [] });
    }

    function getWoodSpeciesDrawerAriaControlsContains(token, excludeTokens) {
        var ctx = findWoodDrawerByAriaToken(token, excludeTokens);
        return getThemeDrawerModalId(ctx);
    }

    function getInsertsInfoDrawerModal() {
        return document.querySelector('.inserts-info-snippet .inserts-info-modal[id]')
            || document.querySelector('.inserts-info-modal[id*="inserts_info_drawer"]')
            || document.querySelector('.inserts-info-modal[id*="inserts-info-drawer"]')
            || document.querySelector('[id*="inserts-info-drawer"][role="dialog"]')
            || document.querySelector('[id*="inserts_info_drawer"][role="dialog"]');
    }

    function findInsertsDrawerContext() {
        var modal = getInsertsInfoDrawerModal();
        if (!modal) return null;
        var root = modal.closest('.inserts-info-snippet');
        var trigger = root ? root.querySelector('[data-inserts-drawer-open]:not(.inserts-tooltip-btn)') : null;
        if (!trigger) {
            trigger = document.querySelector('#door-configurator-options [data-inserts-drawer-open]:not(.inserts-tooltip-btn)')
                || document.querySelector('[data-inserts-drawer-open]:not(.inserts-tooltip-btn)');
        }
        return {
            type: 'inserts',
            root: root,
            modal: modal,
            panel: modal.querySelector('.inserts-info-modal__panel'),
            trigger: trigger,
            modalId: modal.id || ''
        };
    }

    function getInsertsInfoDrawerAriaControls() {
        var ctx = findInsertsDrawerContext();
        if (ctx && ctx.modalId) return ctx.modalId;
        var themeBtn = document.querySelector('button.inserts-info-open-btn[aria-controls]');
        if (themeBtn && themeBtn.getAttribute && !isConfiguratorTooltipBtn(themeBtn)) {
            return themeBtn.getAttribute('aria-controls') || '';
        }
        var any = all('button[aria-controls], a[aria-controls]').filter(function (el) {
            if (isConfiguratorTooltipBtn(el)) return false;
            var ac = String(el && el.getAttribute ? el.getAttribute('aria-controls') : '');
            return ac.indexOf('inserts_info_drawer') !== -1 || ac.indexOf('inserts-info-drawer') !== -1;
        });
        if (any.length) return any[0].getAttribute('aria-controls') || '';
        return '';
    }

    function resolveInsertsDrawerId(sourceBtn) {
        var ctx = findInsertsDrawerContext();
        if (ctx && ctx.modalId) return ctx.modalId;
        if (sourceBtn && sourceBtn.getAttribute) {
            var fromBtn = String(sourceBtn.getAttribute('aria-controls') || '').trim();
            if (fromBtn && document.getElementById(fromBtn)) return fromBtn;
        }
        return getInsertsInfoDrawerAriaControls();
    }

    function openInsertsInfoDrawer(sourceBtn) {
        var ctx = findInsertsDrawerContext();
        if (ctx) return openThemeDrawerContext(ctx);
        var drawerId = resolveInsertsDrawerId(sourceBtn);
        var modal = drawerId ? document.getElementById(drawerId) : null;
        if (!modal) return false;
        return openThemeSidebarModalDirect(modal, modal.querySelector('.inserts-info-modal__panel'));
    }

    window.__openInsertsInfoDrawer = openInsertsInfoDrawer;

    function findMeasureGuideDrawerContext() {
        var root = document.querySelector('.measure-guide-snippet[data-drawer-id]');
        if (root) {
            var modalInRoot = root.querySelector('.measure-guide-modal[id]');
            if (modalInRoot) {
                return {
                    type: 'measure-guide',
                    root: root,
                    modal: modalInRoot,
                    panel: root.querySelector('.measure-guide-modal__panel'),
                    trigger: root.querySelector('[data-measure-drawer-open]'),
                    modalId: modalInRoot.id || ''
                };
            }
        }
        var modal = document.querySelector('.measure-guide-modal[id*="measure_guide_drawer"], .measure-guide-modal[id*="measure-guide-drawer"]');
        if (!modal) return null;
        var rootFromModal = modal.closest('.measure-guide-snippet');
        var trigger = rootFromModal
            ? rootFromModal.querySelector('[data-measure-drawer-open]')
            : document.querySelector('button.measure-guide-open-btn[aria-controls="' + String(modal.id || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]');
        return {
            type: 'measure-guide',
            root: rootFromModal,
            modal: modal,
            panel: modal.querySelector('.measure-guide-modal__panel'),
            trigger: trigger,
            modalId: modal.id || ''
        };
    }

    function getMeasureGuideDrawerAriaControls() {
        return getThemeDrawerModalId(findMeasureGuideDrawerContext());
    }

    function openMeasureGuideDrawer() {
        var ctx = findMeasureGuideDrawerContext();
        if (ctx) return openThemeDrawerContext(ctx);
        var btns = all('button.measure-guide-open-btn[data-measure-drawer-open], button.measure-guide-open-btn, [data-measure-drawer-open]');
        for (var i = 0; i < btns.length; i++) {
            if (btns[i]) {
                btns[i].click();
                return true;
            }
        }
        return false;
    }

    function getWoodSpeciesModalDrawerId() {
        return getThemeDrawerModalId(findWoodSpeciesDrawerContext({
            token: 'wood_species',
            excludeTokens: ['edge_profile', 'select_screen', 'select_storm_glass', 'panel_profile', 'lockset_prep', 'lockset-prep']
        })) || getWoodSpeciesDrawerAriaControlsContains('wood_species_modal', ['edge_profile', 'select_screen', 'select_storm_glass', 'panel_profile', 'lockset']);
    }

    function openWoodSpeciesDrawer() {
        var ctx = findWoodSpeciesDrawerContext({
            token: 'wood_species',
            excludeTokens: ['edge_profile', 'select_screen', 'select_storm_glass', 'panel_profile', 'lockset_prep', 'lockset-prep']
        }) || findWoodSpeciesDrawerByTriggerText(['wood species'], ['edge profile', 'screen', 'storm', 'panel', 'lockset']);
        return openThemeDrawerContext(ctx);
    }

    function getScreenTypesDrawerAriaControls() {
        return getThemeDrawerModalId(findWoodSpeciesDrawerContext({ token: 'select_screen' }))
            || getWoodSpeciesDrawerAriaControlsContains('select_screen');
    }

    function openScreenTypesDrawer() {
        return openThemeDrawerContext(findWoodSpeciesDrawerContext({ token: 'select_screen' }));
    }

    function getStormGlassDrawerAriaControls() {
        return getThemeDrawerModalId(resolveStormGlassDrawerContext());
    }

    function openStormGlassDrawer() {
        return openThemeDrawerContext(resolveStormGlassDrawerContext());
    }

    function getEdgeProfileDrawerAriaControls() {
        return getThemeDrawerModalId(findWoodSpeciesDrawerContext({
            token: 'edge_profile',
            excludeTokens: ['edge_profile_info', 'select_storm_glass', 'select_screen', 'wood_species'],
            triggerTextExcludes: ['door setup']
        })) || getWoodSpeciesDrawerAriaControlsContains('edge_profile', ['edge_profile_info', 'select_storm_glass', 'select_screen', 'wood_species']);
    }

    function openEdgeProfileDrawer() {
        var ctx = findWoodSpeciesDrawerContext({
            token: 'edge_profile',
            excludeTokens: ['edge_profile_info', 'select_storm_glass', 'select_screen', 'wood_species'],
            triggerTextExcludes: ['door setup']
        }) || findWoodSpeciesDrawerByTriggerText(['edge profile', 'stile and rail'], ['door setup']);
        return openThemeDrawerContext(ctx);
    }

    function getDoorSetupDrawerAriaControls() {
        var ctx = findWoodSpeciesDrawerByTriggerText(['door setup'], [])
            || findWoodSpeciesDrawerContext({
                token: 'edge_profile',
                excludeTokens: ['edge_profile_info', 'select_storm_glass', 'select_screen', 'wood_species'],
                triggerTextIncludes: ['door setup']
            });
        return getThemeDrawerModalId(ctx);
    }

    function openDoorSetupDrawer() {
        var ctx = findWoodSpeciesDrawerByTriggerText(['door setup'], [])
            || findWoodSpeciesDrawerContext({
                token: 'edge_profile',
                excludeTokens: ['edge_profile_info', 'select_storm_glass', 'select_screen', 'wood_species'],
                triggerTextIncludes: ['door setup']
            });
        return openThemeDrawerContext(ctx);
    }

    function getPanelProfileDrawerAriaControls() {
        return getThemeDrawerModalId(resolvePanelProfileDrawerContext());
    }

    function openPanelProfileDrawer() {
        return openThemeDrawerContext(resolvePanelProfileDrawerContext());
    }

    function getLocksetPrepDrawerAriaControls() {
        return getThemeDrawerModalId(resolveLocksetPrepDrawerContext());
    }

    function openLocksetPrepDrawer() {
        return openThemeDrawerContext(resolveLocksetPrepDrawerContext());
    }

    window.__openWoodSpeciesDrawer = openWoodSpeciesDrawer;
    window.__getWoodSpeciesModalDrawerId = getWoodSpeciesModalDrawerId;
    window.__openMeasureGuideDrawer = openMeasureGuideDrawer;
    window.__openScreenTypesDrawer = openScreenTypesDrawer;
    window.__openStormGlassDrawer = openStormGlassDrawer;
    window.__openEdgeProfileDrawer = openEdgeProfileDrawer;
    window.__openDoorSetupDrawer = openDoorSetupDrawer;
    window.__openPanelProfileDrawer = openPanelProfileDrawer;
    window.__openLocksetPrepDrawer = openLocksetPrepDrawer;

    function bindWoodDrawerTipButtons() {
        if (window.__doorWoodDrawerTipBound) return;
        window.__doorWoodDrawerTipBound = true;
        document.addEventListener('click', function (e) {
            var btn = e.target && e.target.closest ? e.target.closest('button[data-wood-drawer-tip]') : null;
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();
            openWoodSpeciesDrawer();
        }, true);
    }

    function bindInsertsDrawerTipButtons() {
        if (window.__doorInsertsDrawerTipBound) return;
        window.__doorInsertsDrawerTipBound = true;
        document.addEventListener('click', function (e) {
            var btn = e.target && e.target.closest ? e.target.closest('button[data-inserts-drawer-open]') : null;
            if (!btn) return;
            e.preventDefault();
            e.stopPropagation();
            openInsertsInfoDrawer(btn);
        }, true);
    }

    function bindConfiguratorAboutDrawerButtons() {
        if (window.__doorConfiguratorAboutDrawerBound) return;
        window.__doorConfiguratorAboutDrawerBound = true;
        document.addEventListener('click', function (e) {
            var btn = e.target && e.target.closest ? e.target.closest('button') : null;
            if (!btn) return;

            if (btn.classList && btn.classList.contains('door-lockset-prep-btn')) {
                e.preventDefault();
                e.stopPropagation();
                var locksetId = getLocksetPrepDrawerAriaControls();
                if (locksetId) btn.setAttribute('aria-controls', locksetId);
                openLocksetPrepDrawer();
                return;
            }

            if (btn.classList && (btn.classList.contains('door-panel-profile-btn') || btn.classList.contains('door-panel-unit-design-btn'))) {
                e.preventDefault();
                e.stopPropagation();
                var panelId = getPanelProfileDrawerAriaControls();
                if (panelId) btn.setAttribute('aria-controls', panelId);
                openPanelProfileDrawer();
                return;
            }

            if (btn.classList && btn.classList.contains('inserts-tooltip-btn') && !btn.hasAttribute('data-inserts-drawer-open')) {
                var txt = getTriggerText(btn);
                if (txt.indexOf('glass type') !== -1) {
                    e.preventDefault();
                    e.stopPropagation();
                    var stormId = getStormGlassDrawerAriaControls();
                    if (stormId) btn.setAttribute('aria-controls', stormId);
                    openStormGlassDrawer();
                }
            }
        }, true);
    }

    function bindConfiguratorDrawerAriaObserver() {
        if (window.__doorDrawerAriaObserverBound) return;
        var root = document.getElementById('door-configurator-options');
        if (!root) return;
        window.__doorDrawerAriaObserverBound = true;
        var observer = new MutationObserver(function () {
            if (window.__doorDrawerAriaPatchTimer) clearTimeout(window.__doorDrawerAriaPatchTimer);
            window.__doorDrawerAriaPatchTimer = setTimeout(function () {
                window.__doorDrawerAriaPatchTimer = null;
                patchAriaControls();
            }, 50);
        });
        observer.observe(root, { childList: true, subtree: true });
    }

    function hideThemeDrawerTriggers() {
        try {
            all('button.measure-guide-open-btn, button.inserts-info-open-btn').forEach(function (btn) {
                if (!btn || !btn.classList) return;
                btn.classList.add('door-theme-drawer-trigger-hidden');
                btn.setAttribute('aria-hidden', 'true');
                btn.style.setProperty('display', 'none', 'important');
            });
            all('button.wood-species-open-btn').forEach(function (btn) {
                if (!btn || !btn.classList || isCustomConfiguratorDrawerBtn(btn)) return;
                btn.classList.add('door-theme-drawer-trigger-hidden');
                btn.setAttribute('aria-hidden', 'true');
                btn.style.setProperty('display', 'none', 'important');
            });
        } catch (e) { }
    }

    function patchAriaControls() {
        try {
            var insertsId = getInsertsInfoDrawerAriaControls();
            if (insertsId) {
                all('button.inserts-tooltip-btn[data-inserts-drawer-open], button.inserts-tooltip-btn[aria-controls], button.inserts-tooltip-btn:not([aria-controls])').forEach(function (b) {
                    if (!b || !b.setAttribute) return;
                    if (getTriggerText(b).indexOf('insert') !== -1) {
                        b.setAttribute('aria-controls', insertsId);
                    }
                });
            }

            var woodId = getWoodSpeciesModalDrawerId();
            if (woodId) {
                all('button.inserts-tooltip-btn[data-wood-drawer-tip]').forEach(function (b) {
                    if (!b || !b.setAttribute) return;
                    b.setAttribute('aria-controls', woodId);
                });
            }

            var screenId = getScreenTypesDrawerAriaControls();
            if (screenId) {
                all('button.inserts-tooltip-btn, button.wood-species-open-btn.door-screen-types-btn').forEach(function (b) {
                    if (!b || !b.setAttribute) return;
                    if (getTriggerText(b).indexOf('screen type') !== -1) {
                        b.setAttribute('aria-controls', screenId);
                    }
                });
            }

            var stormId = getStormGlassDrawerAriaControls();
            if (stormId) {
                all('button.inserts-tooltip-btn').forEach(function (b) {
                    if (!b || !b.setAttribute) return;
                    if (getTriggerText(b).indexOf('glass type') !== -1) {
                        b.setAttribute('aria-controls', stormId);
                    }
                });
            }

            var edgeId = getEdgeProfileDrawerAriaControls();
            if (edgeId) {
                all('button.wood-species-open-btn.door-edge-profile-btn').forEach(function (b) {
                    if (!b || !b.setAttribute) return;
                    b.setAttribute('aria-controls', edgeId);
                });
            }

            var panelId = getPanelProfileDrawerAriaControls();
            if (panelId) {
                all('button.door-panel-profile-btn, button.door-panel-unit-design-btn').forEach(function (b) {
                    if (!b || !b.setAttribute) return;
                    b.setAttribute('aria-controls', panelId);
                });
            }

            var locksetId = getLocksetPrepDrawerAriaControls();
            if (locksetId) {
                all('button.door-lockset-prep-btn').forEach(function (b) {
                    if (!b || !b.setAttribute) return;
                    b.setAttribute('aria-controls', locksetId);
                });
            }
        } catch (e) { }
        hideThemeDrawerTriggers();
    }

    function readJsonScriptArray(id) {
        var el = document.getElementById(id);
        if (!el) return [];
        var raw = String(el.textContent || '').trim();
        if (!raw) return [];
        try {
            var parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    }

    function readJsonScriptObject(id) {
        var el = document.getElementById(id);
        if (!el) return {};
        var raw = String(el.textContent || '').trim();
        if (!raw) return {};
        try {
            var parsed = JSON.parse(raw);
            return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
        } catch (e) {
            return {};
        }
    }

    function casingDisplayLabel(p) {
        var title = String((p && p.title) || 'Casing');
        var sku = String((p && p.sku) || '').trim();
        // Dp start 31-07
        // return sku ? title + ' / ' + sku : title;
        return title;
        // Dp end 31-07
    }

    function isBadLengthToken(s) {
        var t = String(s == null ? '' : s).trim();
        return !t || t === 'MetaobjectListDrop' || t === 'MetaobjectDrop';
    }

    function resolveCasingLengthOptions(product) {
        if (!product) return [];
        var fromLiquid = Array.isArray(product.length_options) ? product.length_options : [];
        var good = fromLiquid.filter(function (lo) {
            if (!lo) return false;
            var v = lo.value != null ? String(lo.value) : '';
            var l = lo.label != null ? String(lo.label) : '';
            return !isBadLengthToken(v) || !isBadLengthToken(l);
        }).map(function (lo) {
            return {
                value: String(lo.value != null && !isBadLengthToken(lo.value) ? lo.value : lo.label || ''),
                label: String(lo.label != null && !isBadLengthToken(lo.label) ? lo.label : lo.value || '')
            };
        }).filter(function (lo) {
            return lo.value || lo.label;
        });
        if (good.length) return good;

        var catalog = readJsonScriptArray('door-millwork-length-catalog');
        if (!catalog.length) return [];

        var byHandle = {};
        var byId = {};
        catalog.forEach(function (entry) {
            if (!entry) return;
            var h = String(entry.handle || '').trim();
            var id = entry.id != null ? String(entry.id) : '';
            if (h) byHandle[h] = entry;
            if (id) byId[id] = entry;
        });

        function entryToOption(e, fallback) {
            if (!e) return null;
            var val = String(e.value != null && !isBadLengthToken(e.value) ? e.value : e.label || fallback || '');
            var lab = String(e.label != null && !isBadLengthToken(e.label) ? e.label : e.value || fallback || '');
            return val || lab ? { value: val || lab, label: lab || val } : null;
        }

        var handles = Array.isArray(product.length_handles) ? product.length_handles : [];
        var resolved = handles.map(function (h) {
            return entryToOption(byHandle[String(h || '').trim()], h);
        }).filter(Boolean);
        if (resolved.length) return resolved;

        var ids = Array.isArray(product.length_ids) ? product.length_ids : [];
        return ids.map(function (id) {
            return entryToOption(byId[String(id)], id);
        }).filter(Boolean);
    }

    function writeCasingSelectionStore(selection) {
        var jsonEl = document.getElementById('door-casing-selection-json');
        if (jsonEl) {
            try { jsonEl.textContent = selection ? JSON.stringify(selection) : 'null'; } catch (e) { }
        }
        var hidden = document.querySelector('input[data-casing-selection-input]');
        if (hidden) {
            hidden.value = selection ? String(selection.product_id || '') : '';
            try {
                hidden.dispatchEvent(new Event('change', { bubbles: true }));
            } catch (e) { }
        }
        try { window.__doorCasingSelection = selection || null; } catch (eWin) { }
    }

    function readCasingSelectionStore() {
        if (window.__doorCasingSelection && typeof window.__doorCasingSelection === 'object') {
            return window.__doorCasingSelection;
        }
        var jsonEl = document.getElementById('door-casing-selection-json');
        if (!jsonEl || !jsonEl.textContent) return null;
        try {
            var parsed = JSON.parse(jsonEl.textContent.trim());
            if (!parsed || typeof parsed !== 'object') return null;
            return parsed;
        } catch (eRead) {
            return null;
        }
    }

    function buildCasingSelection(product, lengthValue, lengthLabel, qty) {
        if (!product) return null;
        var q = parseInt(qty, 10);
        if (isNaN(q) || q < 1) q = 1;
        var lenOpts = resolveCasingLengthOptions(product);
        if ((!lenOpts || !lenOpts.length) && product) {
            var existingStore = readCasingSelectionStore();
            if (existingStore && String(existingStore.product_id) === String(product.id) && Array.isArray(existingStore.length_options)) {
                lenOpts = existingStore.length_options;
            }
        }
        return {
            product_id: String(product.id || ''),
            handle: String(product.handle || ''),
            title: String(product.title || 'Casing'),
            url: String(product.url || ''),
            variant_id: String(product.variant_id || ''),
            sku: String(product.sku || ''),
            image: String(product.image || ''),
            price_cents: Number(product.price_cents || 0),
            price_formatted: String(product.price_formatted || ''),
            length_value: String(lengthValue || ''),
            length_label: String(lengthLabel || lengthValue || ''),
            qty: q,
            length_options: lenOpts && lenOpts.length ? lenOpts : null
        };
    }

    function renderCasingProducts() {
        var products = readJsonScriptArray('door-recommended-casing-products');
        if (!products.length) return false;

        var casingAccordion = document.querySelector('.door-option-accordion.door-post-lockset-casing-options[data-option-id="casing_options"]');
        if (!casingAccordion) return null;
        var inner = casingAccordion.querySelector('.door-accordion-body-inner');
        if (!inner) return null;
        if (inner.querySelector('[data-casing-root="1"]')) return true;

        all('.door-option-wrap[data-option-id^="casing_dummy_"]', inner).forEach(function (d) {
            try { d.remove(); } catch (e) { }
        });

        var root = document.createElement('div');
        root.className = 'door-hardware-options-grid-wrap';
        root.setAttribute('data-casing-root', '1');
        root.setAttribute('data-casing-grid', '1');

        var intro = document.createElement('p');
        intro.className = 'door-suggested-hardware-intro';
        intro.textContent = 'Add matching door frame casing to help your door fit perfectly into your home.';

        var layout = document.createElement('div');
        layout.className = 'door-hardware-options-layout';
        layout.setAttribute('data-casing-layout', '1');

        var detailList = document.createElement('div');
        detailList.className = 'door-hardware-options-detail';
        detailList.setAttribute('data-casing-detail', '1');
        detailList.hidden = true;

        var pickerGrid = document.createElement('div');
        pickerGrid.className = 'door-hardware-options-picker-grid common-check-options door-hardware-options-cards';
        pickerGrid.setAttribute('data-casing-picker-grid', '1');

        layout.appendChild(detailList);
        layout.appendChild(pickerGrid);

        var jsonStore = document.createElement('div');
        jsonStore.id = 'door-casing-selection-json';
        jsonStore.hidden = true;
        jsonStore.setAttribute('data-json-store', '1');
        jsonStore.textContent = 'null';

        var hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.setAttribute('data-casing-selection-input', '1');
        hiddenInput.setAttribute('data-option-id', 'casing_options');
        hiddenInput.name = 'attributes[Casing]';
        hiddenInput.value = '';

        function showBrowse() {
            pickerGrid.hidden = false;
            detailList.hidden = true;
            clearElement(detailList);
            detailList.classList.remove('door-hardware-options-detail--open');
            writeCasingSelectionStore(null);
        }

        function renderSelectedDetail(product) {
            if (!product) return;
            clearElement(detailList);

            var article = document.createElement('article');
            article.className = 'door-suggested-hardware-card common-check-option door-hardware-option-card door-suggested-hardware-card--added';
            article.setAttribute('data-choice-value', String(product.id));
            article.setAttribute('data-product-id', String(product.id));

            var casingCheck = document.createElement('input');
            casingCheck.type = 'checkbox';
            casingCheck.className = 'door-suggested-hardware-card__radio';
            casingCheck.name = 'attributes[Casing][]';
            casingCheck.value = String(product.id);
            casingCheck.setAttribute('data-option-id', 'casing_options');
            casingCheck.setAttribute('data-casing-selection-checkbox', '1');
            casingCheck.checked = true;
            casingCheck.style.position = 'absolute';
            casingCheck.style.opacity = '0';
            casingCheck.style.pointerEvents = 'none';
            article.appendChild(casingCheck);

            var cardLayout = document.createElement('div');
            cardLayout.className = 'door-suggested-hardware-card__layout';

            var media = document.createElement('div');
            media.className = 'door-suggested-hardware-card__media';
            if (product.image) {
                var img = document.createElement('img');
                img.className = 'common-check-option-image';
                img.src = String(product.image);
                img.loading = 'lazy';
                img.alt = casingDisplayLabel(product);
                media.appendChild(img);
            } else {
                var ph = document.createElement('span');
                ph.className = 'common-check-option-image door-hardware-picker-image--placeholder';
                ph.setAttribute('role', 'img');
                ph.setAttribute('aria-label', casingDisplayLabel(product));
                media.appendChild(ph);
            }
            var mediaTextWrap = document.createElement('div');
            mediaTextWrap.className = 'common-check-option-text';
            var mediaTitle = document.createElement('span');
            mediaTitle.className = 'common-check-option-label';
            mediaTitle.textContent = casingDisplayLabel(product);
            mediaTextWrap.appendChild(mediaTitle);
            media.appendChild(mediaTextWrap);

            var details = document.createElement('div');
            details.className = 'door-suggested-hardware-card__details';

            var lengthRow = document.createElement('div');
            lengthRow.className = 'door-suggested-hardware-card__function';
            var lengthLbl = document.createElement('span');
            lengthLbl.className = 'door-suggested-hardware-card__function-label';
            lengthLbl.textContent = 'Length';
            var lengthSel = document.createElement('select');
            lengthSel.className = 'door-input-select door-suggested-hardware-card__function-select door-suggested-hardware-function';
            lengthSel.setAttribute('data-casing-length-select', '1');
            lengthSel.setAttribute('data-option-id', 'casing_length');
            lengthSel.setAttribute('aria-label', 'Length');

            var lengthOpts = resolveCasingLengthOptions(product);
            if (!lengthOpts.length) {
                var emptyOp = document.createElement('option');
                emptyOp.value = '';
                emptyOp.textContent = '—';
                lengthSel.appendChild(emptyOp);
            } else {
                var appendedAny = false;
                lengthOpts.forEach(function (lo) {
                    if (!lo) return;
                    var op = document.createElement('option');
                    var rawVal = lo.value != null ? String(lo.value) : '';
                    var rawLab = lo.label != null ? String(lo.label) : '';
                    if (isBadLengthToken(rawVal) && isBadLengthToken(rawLab)) return;
                    if (isBadLengthToken(rawVal)) rawVal = '';
                    if (isBadLengthToken(rawLab)) rawLab = '';
                    if (!rawVal && !rawLab) return;
                    op.value = rawVal || rawLab;
                    op.textContent = rawLab || rawVal;
                    lengthSel.appendChild(op);
                    appendedAny = true;
                });
                if (!appendedAny) {
                    var emptyOp2 = document.createElement('option');
                    emptyOp2.value = '';
                    emptyOp2.textContent = '—';
                    lengthSel.appendChild(emptyOp2);
                }
            }

            lengthRow.appendChild(lengthLbl);
            lengthRow.appendChild(lengthSel);
            details.appendChild(lengthRow);

            var footer = document.createElement('div');
            footer.className = 'door-suggested-hardware-card__footer';

            var priceRow = document.createElement('p');
            priceRow.className = 'door-suggested-hardware-card__price';
            // --- Dp start 14-07  ---
            priceRow.style.display = 'none';
            // --- Dp end 14-07  ---
            setCasingPriceRowText(priceRow, String(product.price_formatted || '').trim());

            var actions = document.createElement('div');
            actions.className = 'door-suggested-hardware-card__actions';

            var qtyWrap = document.createElement('div');
            qtyWrap.className = 'door-suggested-hardware-qty-wrap select-mdiv common-qty qty-small';
            var qtyLabel = document.createElement('label');
            qtyLabel.className = 'qty-label';
            qtyLabel.textContent = 'QTY';
            var qtyBlock = document.createElement('div');
            qtyBlock.className = 'qty-block';
            var qtyInner = document.createElement('div');
            qtyInner.className = 'qty-wrapper';
            var minusBtn = document.createElement('button');
            minusBtn.type = 'button';
            minusBtn.className = 'qty-btn minus';
            minusBtn.setAttribute('aria-label', 'Decrease quantity');
            minusBtn.textContent = '-';
            var qtyInput = document.createElement('input');
            qtyInput.type = 'number';
            qtyInput.name = 'quantity';
            qtyInput.min = '1';
            qtyInput.max = '99';
            qtyInput.value = '1';
            qtyInput.inputMode = 'numeric';
            qtyInput.setAttribute('aria-label', 'Quantity');
            var plusBtn = document.createElement('button');
            plusBtn.type = 'button';
            plusBtn.className = 'qty-btn plus';
            plusBtn.setAttribute('aria-label', 'Increase quantity');
            plusBtn.textContent = '+';
            qtyInner.appendChild(minusBtn);
            qtyInner.appendChild(qtyInput);
            qtyInner.appendChild(plusBtn);
            qtyBlock.appendChild(qtyInner);
            qtyWrap.appendChild(qtyLabel);
            qtyWrap.appendChild(qtyBlock);

            var removeBtn = document.createElement('button');
            removeBtn.type = 'button';
            removeBtn.className = 'door-suggested-hardware-remove-btn btn-woodDust common-btn common-remove-btn btn-small';
            removeBtn.setAttribute('aria-label', 'Remove casing');
            appendRemoveCasingButtonContent(removeBtn);

            actions.appendChild(qtyWrap);
            actions.appendChild(removeBtn);
            footer.appendChild(priceRow);
            footer.appendChild(actions);
            details.appendChild(footer);
            cardLayout.appendChild(media);
            cardLayout.appendChild(details);
            article.appendChild(cardLayout);
            detailList.appendChild(article);

            function syncSelection() {
                var idx = lengthSel.selectedIndex >= 0 ? lengthSel.selectedIndex : 0;
                var op = lengthSel.options[idx];
                var lenVal = op ? String(op.value || '') : '';
                var lenLbl = op ? String(op.textContent || '').trim() : '';
                writeCasingSelectionStore(buildCasingSelection(product, lenVal, lenLbl, qtyInput.value));
            }

            minusBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1));
                syncSelection();
            });
            plusBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                qtyInput.value = String(Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1));
                syncSelection();
            });
            qtyInput.addEventListener('change', syncSelection);
            qtyInput.addEventListener('input', syncSelection);
            lengthSel.addEventListener('change', syncSelection);
            removeBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                showBrowse();
            });

            if (lengthSel.getAttribute('data-door-div-select') !== '1') {
                enhanceDoorSelectWithDivDropdown(lengthSel);
            }

            pickerGrid.hidden = true;
            detailList.hidden = false;
            detailList.classList.add('door-hardware-options-detail--open');
            syncSelection();
        }

        products.forEach(function (p) {
            if (!p || !p.id) return;
            var card = document.createElement('label');
            card.className = 'common-check-option door-hardware-picker-option';
            card.setAttribute('data-choice-value', String(p.id));
            card.setAttribute('data-product-id', String(p.id));

            var check = document.createElement('input');
            check.type = 'checkbox';
            check.className = 'door-hardware-picker-checkbox';
            check.name = 'attributes[Casing Picker][]';
            check.value = String(p.id);
            check.setAttribute('data-casing-picker-checkbox', '1');
            check.setAttribute('data-option-id', 'casing_options');
            check.style.position = 'absolute';
            check.style.opacity = '0';
            check.style.pointerEvents = 'none';
            card.appendChild(check);

            if (p.image) {
                var pickImg = document.createElement('img');
                pickImg.className = 'common-check-option-image';
                deferCasingPickerImage(pickImg, String(p.image));
                pickImg.alt = casingDisplayLabel(p);
                card.appendChild(pickImg);
            } else {
                var pickPh = document.createElement('span');
                pickPh.className = 'common-check-option-image door-hardware-picker-image--placeholder';
                pickPh.setAttribute('role', 'img');
                pickPh.setAttribute('aria-label', casingDisplayLabel(p));
                card.appendChild(pickPh);
            }

            var textWrap = document.createElement('div');
            textWrap.className = 'common-check-option-text';
            var pickTitle = document.createElement('span');
            pickTitle.className = 'common-check-option-label';
            pickTitle.textContent = casingDisplayLabel(p);
            textWrap.appendChild(pickTitle);
            card.appendChild(textWrap);

            card.addEventListener('click', function (e) {
                e.preventDefault();
                renderSelectedDetail(p);
            });
            pickerGrid.appendChild(card);
        });

        if (!pickerGrid.children.length) return false;

        root.appendChild(intro);
        root.appendChild(layout);
        root.appendChild(jsonStore);
        root.appendChild(hiddenInput);

        clearElement(inner);
        inner.appendChild(root);
        bindCasingAccordionImageHydrate();
        return true;
    }

    function bootCasingProducts() {
        var tries = 0;
        var maxTries = 30;
        (function loop() {
            tries++;
            var done = renderCasingProducts();
            if (done === true || done === false) return;
            if (tries >= maxTries) return;
            setTimeout(loop, 250);
        })();
    }

    function findCasingProductCard(root, productId) {
        if (!root || !productId) return null;
        var cards = all('.door-hardware-picker-option[data-product-id]', root);
        for (var i = 0; i < cards.length; i++) {
            if (String(cards[i].getAttribute('data-product-id')) === String(productId)) return cards[i];
        }
        return null;
    }

    function setCasingLengthSelectFromSaved(lenSel, lengthValue, lengthLabel) {
        if (!lenSel) return false;
        var wantVal = String(lengthValue == null ? '' : lengthValue);
        var wantLab = String(lengthLabel == null ? '' : lengthLabel);
        var i, op, matched = -1;
        for (i = 0; i < lenSel.options.length; i++) {
            op = lenSel.options[i];
            if (!op) continue;
            if (wantVal !== '' && String(op.value) === wantVal) { matched = i; break; }
        }
        if (matched === -1 && wantLab !== '') {
            for (i = 0; i < lenSel.options.length; i++) {
                op = lenSel.options[i];
                if (!op) continue;
                if (String(op.textContent || '').trim() === wantLab) { matched = i; break; }
            }
        }
        if (matched === -1) return false;
        lenSel.selectedIndex = matched;
        lenSel.value = String(lenSel.options[matched].value);
        dispatchSelectChange(lenSel);
        var dw = lenSel.nextElementSibling;
        if (dw && dw.classList && dw.classList.contains('door-div-select')) {
            syncDoorDivSelectFromNative(lenSel, dw);
        }
        return true;
    }

    // Pre-select the saved casing product (+ length + qty) when editing a saved
    // configuration. Reuses the existing card-click flow so all listeners stay intact.
    function applyCasingRestoreToDom() {
        var pending = window.__doorSavedCasingRestore;
        if (!pending || pending.__applied) return true;
        var root = document.querySelector('[data-casing-root="1"]');
        if (!root) return false;
        var pid = String(pending.product_id || '');
        if (!pid) { pending.__applied = true; return true; }
        var card = findCasingProductCard(root, pid);
        if (!card) return false;
        try { card.click(); } catch (eClick) { return false; }
        var detail = root.querySelector('[data-casing-detail="1"]');
        if (detail) {
            var lenSel = detail.querySelector('select[data-casing-length-select]');
            if (lenSel) setCasingLengthSelectFromSaved(lenSel, pending.length_value, pending.length_label);
            var qtyInp = detail.querySelector('input[name="quantity"]');
            if (qtyInp && pending.qty) {
                qtyInp.value = String(pending.qty);
                dispatchSelectChange(qtyInp);
            }
        }
        pending.__applied = true;
        return true;
    }

    function restoreCasingSelection(list) {
        var row = Array.isArray(list) ? (list.length ? list[0] : null) : list;
        if (!row || typeof row !== 'object') return;
        var productId = String(row.product_id || row.id || row.productId || '');
        if (!productId) return;
        window.__doorSavedCasingRestore = {
            product_id: productId,
            length_value: String(row.length_value || row.length || ''),
            length_label: String(row.length_label || row.length_value || row.length || ''),
            qty: parseInt(row.qty || row.quantity || 1, 10) || 1,
            __applied: false
        };
        var tries = 0;
        (function loop() {
            tries++;
            // Keep retrying until the recommended-casing JSON is injected and the saved
            // card is found. renderCasingProducts() returning false just means "no
            // products yet" on this pass, so do NOT bail early or the picker grid (the
            // "normal" view) would stay visible instead of the saved selected detail.
            try { renderCasingProducts(); } catch (eR) { }
            var done = false;
            try { done = applyCasingRestoreToDom(); } catch (eApply) { done = false; }
            if (done) return;
            if (tries >= 40) return;
            setTimeout(loop, 250);
        })();
    }

    function findCasingProductInCatalog(productId) {
        if (!productId) return null;
        var products = readJsonScriptArray('door-recommended-casing-products');
        for (var i = 0; i < products.length; i++) {
            if (products[i] && String(products[i].id) === String(productId)) return products[i];
        }
        return null;
    }

    function buildCasingSelectionFromDom() {
        var detail = document.querySelector('[data-casing-detail="1"]');
        if (!detail || detail.hidden) return null;
        var block = detail.querySelector('.door-suggested-hardware-card--added, article[data-product-id]');
        if (!block) return null;
        var productId = String(block.getAttribute('data-product-id') || block.getAttribute('data-choice-value') || '');
        if (!productId) return null;

        var product = findCasingProductInCatalog(productId);
        if (!product) {
            var titleEl = block.querySelector('.common-check-option-label');
            var imgEl = block.querySelector('.common-check-option-image, img');
            product = {
                id: productId,
                title: titleEl ? String(titleEl.textContent || '').trim() : 'Casing',
                image: imgEl ? String(imgEl.getAttribute('src') || '') : ''
            };
        }

        var lenSel = detail.querySelector('select[data-casing-length-select]');
        var lenVal = '';
        var lenLbl = '';
        if (lenSel && lenSel.options && lenSel.options.length) {
            var idx = lenSel.selectedIndex >= 0 ? lenSel.selectedIndex : 0;
            var op = lenSel.options[idx];
            if (op) {
                lenVal = String(op.value || '');
                lenLbl = String(op.textContent || '').trim();
            }
        }

        var qtyInput = detail.querySelector('input[name="quantity"]');
        return buildCasingSelection(product, lenVal, lenLbl, qtyInput ? qtyInput.value : 1);
    }

    function syncCasingSelectionFromDom() {
        var row = buildCasingSelectionFromDom();
        if (row && row.product_id) {
            writeCasingSelectionStore(row);
            return row;
        }
        return readCasingSelectionStore();
    }

    function getCasingSelectionsForConfig() {
        var row = syncCasingSelectionFromDom();
        return row && row.product_id ? [row] : [];
    }

    function normMillworkMatchToken(s) {
        return String(s == null ? '' : s).toLowerCase().replace(/[\s_\-]+/g, ' ').trim();
    }

    function millworkSummaryLabelMatches(label, candidates) {
        var lab = normMillworkMatchToken(label);
        if (!lab) return false;
        for (var i = 0; i < candidates.length; i++) {
            var c = normMillworkMatchToken(candidates[i]);
            if (!c) continue;
            if (lab === c) return true;
            if (lab.indexOf(c) !== -1 || c.indexOf(lab) !== -1) return true;
        }
        return false;
    }

    function readSavedMillworkField(opts, keyCandidates, labelCandidates) {
        if (!opts || typeof opts !== 'object') return '';
        var i, k, v, item, lab;
        keyCandidates = keyCandidates || [];
        labelCandidates = labelCandidates || [];
        for (i = 0; i < keyCandidates.length; i++) {
            k = keyCandidates[i];
            if (!k || !Object.prototype.hasOwnProperty.call(opts, k)) continue;
            v = opts[k];
            if (v == null || v === '') continue;
            if (!Array.isArray(v)) return String(v).trim();
        }
        if (opts._line_item_properties && typeof opts._line_item_properties === 'object') {
            for (lab in opts._line_item_properties) {
                if (!Object.prototype.hasOwnProperty.call(opts._line_item_properties, lab)) continue;
                if (!millworkSummaryLabelMatches(lab, labelCandidates)) continue;
                v = opts._line_item_properties[lab];
                if (v != null && String(v).trim() !== '') return String(v).trim();
            }
        }
        if (Array.isArray(opts._selected_summary)) {
            for (i = 0; i < opts._selected_summary.length; i++) {
                item = opts._selected_summary[i];
                if (!item || typeof item !== 'object') continue;
                if (!millworkSummaryLabelMatches(item.label, labelCandidates)) continue;
                v = String(item.value || '').trim();
                if (v) return v;
            }
        }
        return '';
    }

    function parseSimpleFraction(s) {
        s = String(s == null ? '' : s).trim();
        if (!s) return null;
        var m = s.match(/^(\d+)\s+(\d+)\s*\/\s*(\d+)$/);
        if (m) return parseInt(m[1], 10) + parseInt(m[2], 10) / parseInt(m[3], 10);
        m = s.match(/^(\d+)\s*\/\s*(\d+)$/);
        if (m) return parseInt(m[1], 10) / parseInt(m[2], 10);
        return null;
    }

    function findLinkedDoorDivSelect(sel) {
        if (!sel) return null;
        var dw = sel.nextElementSibling;
        if (dw && dw.classList && dw.classList.contains('door-div-select')) return dw;
        return null;
    }

    function doorDivSelectValuesMatch(a, b) {
        var sa = String(a == null ? '' : a).trim();
        var sb = String(b == null ? '' : b).trim();
        if (sa === sb) return true;
        if (!sa || !sb) return false;
        // --- Dp start 15-07 ---
        // Pure numeric compare only (e.g. millwork 0.375). Do not treat
        // "2_inch" / "2 3/8_inch" as equal just because parseFloat starts at 2.
        var pureNum = /^-?\d+(\.\d+)?$/;
        if (pureNum.test(sa) && pureNum.test(sb) && !isNaN(parseFloat(sa)) && !isNaN(parseFloat(sb))) {
            return Math.abs(parseFloat(sa) - parseFloat(sb)) < 0.000001;
        }
        // --- Dp end 15-07 ---
        return normMillworkMatchToken(sa) === normMillworkMatchToken(sb);
    }

    var MILLWORK_THICKNESS_STORAGE_TO_LABEL = {
        '0': '0',
        '0.0625': '1/16',
        '0.125': '1/8',
        '0.25': '1/4',
        '0.5': '1/2',
        '0.1875': '3/16',
        '0.375': '3/8',
        '0.75': '3/4',
        '0.3125': '5/16',
        '0.625': '5/8',
        '0.4375': '7/16',
        '0.875': '7/8',
        '0.5625': '9/16',
        '0.6875': '11/16',
        '0.8125': '13/16',
        '0.9375': '15/16'
    };

    function millworkThicknessStorageForValue(raw) {
        raw = String(raw == null ? '' : raw).trim();
        if (!raw) return { value: '', label: '' };
        var key, label;
        for (key in MILLWORK_THICKNESS_STORAGE_TO_LABEL) {
            if (!Object.prototype.hasOwnProperty.call(MILLWORK_THICKNESS_STORAGE_TO_LABEL, key)) continue;
            label = MILLWORK_THICKNESS_STORAGE_TO_LABEL[key];
            if (raw === key || raw === label || doorDivSelectValuesMatch(raw, key)) {
                return { value: key, label: label };
            }
        }
        var dec = parseSimpleFraction(raw);
        if (dec === null && !isNaN(parseFloat(raw))) dec = parseFloat(raw);
        if (dec !== null) {
            for (key in MILLWORK_THICKNESS_STORAGE_TO_LABEL) {
                if (!Object.prototype.hasOwnProperty.call(MILLWORK_THICKNESS_STORAGE_TO_LABEL, key)) continue;
                if (doorDivSelectValuesMatch(String(dec), key)) {
                    return { value: key, label: MILLWORK_THICKNESS_STORAGE_TO_LABEL[key] };
                }
            }
            return { value: String(dec), label: raw };
        }
        return { value: raw, label: raw };
    }

    function resolveMillworkThicknessForSelect(savedRaw, sel) {
        savedRaw = String(savedRaw == null ? '' : savedRaw).trim();
        if (!savedRaw) return { value: '', label: '' };
        var i, op, opVal, opLab;
        if (sel) {
            var divWrap = findLinkedDoorDivSelect(sel);
            if (divWrap) {
                var items = divWrap.querySelectorAll('.door-div-select__item');
                var j, item, dv, dl;
                for (j = 0; j < items.length; j++) {
                    item = items[j];
                    if (!item) continue;
                    dv = String(item.getAttribute('data-value') || '');
                    dl = String(item.textContent || '').trim();
                    if (savedRaw === dv || savedRaw === dl || doorDivSelectValuesMatch(savedRaw, dv) || doorDivSelectValuesMatch(savedRaw, dl)) {
                        return { value: dv, label: dl };
                    }
                }
            }
            for (i = 0; i < sel.options.length; i++) {
                op = sel.options[i];
                if (!op) continue;
                opVal = String(op.value || '');
                opLab = String(op.textContent || '').trim();
                if (savedRaw === opVal || savedRaw === opLab) {
                    return { value: opVal, label: opLab };
                }
            }
            var dec = parseSimpleFraction(savedRaw);
            if (dec === null && !isNaN(parseFloat(savedRaw))) dec = parseFloat(savedRaw);
            if (dec !== null) {
                for (i = 0; i < sel.options.length; i++) {
                    op = sel.options[i];
                    if (!op) continue;
                    opVal = String(op.value || '');
                    if (opVal !== '' && !isNaN(parseFloat(opVal)) && Math.abs(parseFloat(opVal) - dec) < 0.000001) {
                        return { value: opVal, label: String(op.textContent || '').trim() };
                    }
                }
                return { value: String(dec), label: savedRaw };
            }
        }
        return millworkThicknessStorageForValue(savedRaw);
    }

    function readSavedMillworkThickness(opts) {
        if (!opts || typeof opts !== 'object') return { value: '', label: '' };
        var thickSel = document.querySelector('[data-millwork-custom-thickness-select]');
        var keyVal = (opts.custom_thickness != null && String(opts.custom_thickness).trim() !== '')
            ? String(opts.custom_thickness).trim()
            : '';
        var summaryVal = readSavedMillworkField(
            { _selected_summary: opts._selected_summary, _line_item_properties: opts._line_item_properties },
            [],
            ['custom thickness', 'thickness']
        );
        if (!keyVal && !summaryVal) return { value: '', label: '' };
        if (!keyVal) return resolveMillworkThicknessForSelect(summaryVal, thickSel);
        if (!summaryVal) return resolveMillworkThicknessForSelect(keyVal, thickSel);
        var keyResolved = resolveMillworkThicknessForSelect(keyVal, thickSel);
        var sumResolved = resolveMillworkThicknessForSelect(summaryVal, thickSel);
        if (sumResolved.value && keyResolved.value && sumResolved.value !== keyResolved.value) {
            return sumResolved;
        }
        return keyResolved;
    }

    function setMillworkSelectFromSaved(sel, savedValue, savedLabel) {
        if (!sel) return false;
        var wantVal = String(savedValue == null ? '' : savedValue).trim();
        var wantLab = String(savedLabel == null ? '' : savedLabel).trim();
        if (!wantVal && !wantLab) return false;
        if (!wantLab) wantLab = wantVal;

        if (sel.getAttribute('data-door-div-select') !== '1') {
            try { enhanceDoorSelectWithDivDropdown(sel); } catch (eEnh) { }
        }
        var divWrap = findLinkedDoorDivSelect(sel);

        var matched = -1;
        var matchedNativeValue = '';
        var i, op, opVal, opLab;
        var wantValNorm = normMillworkMatchToken(wantVal);
        var wantLabNorm = normMillworkMatchToken(wantLab);

        for (i = 0; i < sel.options.length; i++) {
            op = sel.options[i];
            if (!op) continue;
            opVal = String(op.value || '');
            opLab = String(op.textContent || '').trim();
            if (wantVal !== '' && doorDivSelectValuesMatch(wantVal, opVal)) { matched = i; matchedNativeValue = opVal; break; }
            if (wantLab !== '' && opLab === wantLab) { matched = i; matchedNativeValue = opVal; break; }
            if (wantValNorm && (normMillworkMatchToken(opVal) === wantValNorm || normMillworkMatchToken(opLab) === wantValNorm || normMillworkMatchToken(opLab) === wantLabNorm)) {
                matched = i;
                matchedNativeValue = opVal;
                break;
            }
            if (opVal !== '' && wantVal !== '' && !isNaN(parseFloat(opVal)) && !isNaN(parseFloat(wantVal))) {
                if (Math.abs(parseFloat(opVal) - parseFloat(wantVal)) < 0.000001) { matched = i; matchedNativeValue = opVal; break; }
            }
        }

        if (matched === -1 && divWrap) {
            var items = divWrap.querySelectorAll('.door-div-select__item');
            var j, item, dv, dl;
            for (j = 0; j < items.length; j++) {
                item = items[j];
                if (!item) continue;
                dv = String(item.getAttribute('data-value') || '');
                dl = String(item.textContent || '').trim();
                if (!(wantVal !== '' && (doorDivSelectValuesMatch(wantVal, dv) || doorDivSelectValuesMatch(wantVal, dl)))
                    && !(wantLab !== '' && (wantLab === dl || doorDivSelectValuesMatch(wantLab, dv)))) {
                    continue;
                }
                matchedNativeValue = dv;
                for (i = 0; i < sel.options.length; i++) {
                    op = sel.options[i];
                    if (!op) continue;
                    if (doorDivSelectValuesMatch(String(op.value || ''), dv)) {
                        matched = i;
                        matchedNativeValue = String(op.value || '');
                        break;
                    }
                }
                break;
            }
        }

        if (matched === -1 && !matchedNativeValue) return false;
        if (matched >= 0) {
            sel.selectedIndex = matched;
            sel.value = String(sel.options[matched].value);
        } else if (matchedNativeValue !== '') {
            sel.value = matchedNativeValue;
        }
        dispatchSelectChange(sel);
        if (divWrap) syncDoorDivSelectFromNative(sel, divWrap);
        return true;
    }

    function findMillworkWoodSelect() {
        return document.querySelector('select[data-millwork-wood-select]')
            || document.querySelector('[data-millwork-wood-select]');
    }

    function hasMillworkRestoreUi() {
        return !!(
            document.querySelector('[data-millwork-custom-length-select]')
            || document.querySelector('[data-millwork-length-select]')
            || document.querySelector('[data-millwork-baluster-length-select]')
            || document.querySelector('[data-millwork-custom-thickness-select]')
            || document.querySelector('[data-millwork-wood-select]')
            || document.querySelector('[data-millwork-custom-length-config="1"]')
        );
    }

    function setMillworkWoodFromSaved(woodVal) {
        if (!woodVal) return false;
        var woodSel = findMillworkWoodSelect();
        if (woodSel) return setMillworkSelectFromSaved(woodSel, woodVal, woodVal);
        // Do not force normal door `wood_type` radios — that fights edit-mode wood changes.
        return false;
    }

    function applyMillworkRestoreToDom(opts) {
        if (!opts || typeof opts !== 'object') return true;

        // Not a millwork product (or UI not present): done — do not treat door wood radios as millwork.
        if (!hasMillworkRestoreUi()) return true;

        var lengthVal = readSavedMillworkField(opts, ['custom_length', 'length', 'millwork_length'], ['custom length', 'millwork length']);
        var thickResolved = readSavedMillworkThickness(opts);
        var thickVal = thickResolved.value;
        var thickLab = thickResolved.label;
        // Prefer millwork-specific wood keys; fall back to wood_type only on real millwork UI.
        var woodVal = readSavedMillworkField(opts, ['millwork_wood', 'wood'], ['millwork wood', 'wood species'])
            || readSavedMillworkField(opts, ['wood_type'], ['wood']);

        var lengthSel = document.querySelector('[data-millwork-custom-length-select]')
            || document.querySelector('[data-millwork-length-select]')
            || document.querySelector('[data-millwork-baluster-length-select]');
        var thickSel = document.querySelector('[data-millwork-custom-thickness-select]');
        var woodSel = findMillworkWoodSelect();

        if (!lengthVal && !thickVal && !woodVal) return true;

        var pending = [];
        if (lengthVal) pending.push({ kind: 'select', sel: lengthSel, val: lengthVal });
        if (thickVal) pending.push({ kind: 'select', sel: thickSel, val: thickVal, lab: thickLab });
        if (woodVal && woodSel) pending.push({ kind: 'wood', val: woodVal });
        if (!pending.length) return true;

        var allOk = true;
        pending.forEach(function (p) {
            if (p.kind === 'wood') {
                if (!setMillworkWoodFromSaved(p.val)) allOk = false;
                return;
            }
            if (!p.sel) { allOk = false; return; }
            if (!setMillworkSelectFromSaved(p.sel, p.val, p.lab != null ? p.lab : p.val)) allOk = false;
        });
        return allOk;
    }

    function restoreMillworkSelectionsFromSaved(opts) {
        if (!opts || typeof opts !== 'object') return;
        // Normal doors have wood_type radios but no millwork UI — never start the retry loop.
        if (!hasMillworkRestoreUi()) return;
        var tries = 0;
        function resyncMillworkDoorDivSelects() {
            var thickSel = document.querySelector('[data-millwork-custom-thickness-select]');
            if (!thickSel) return;
            var divWrap = findLinkedDoorDivSelect(thickSel);
            if (!divWrap) return;
            syncDoorDivSelectFromNative(thickSel, divWrap);
        }
        (function loop() {
            tries++;
            try { bootMillworkLengthConfig(); } catch (eBoot) { }
            var done = false;
            try { done = applyMillworkRestoreToDom(opts); } catch (eApply) { done = false; }
            if (done) {
                try { resyncMillworkDoorDivSelects(); } catch (eResync) { }
                setTimeout(function () {
                    try { applyMillworkRestoreToDom(opts); } catch (eLate) { }
                    try { resyncMillworkDoorDivSelects(); } catch (eResync2) { }
                }, 0);
                return;
            }
            if (tries >= 40) return;
            setTimeout(loop, 250);
        })();
    }

    // Read the currently selected label/value from a millwork <select> (skips the
    // empty placeholder option so we never store a blank "Selected option").
    function millworkSelectedLabelValue(sel) {
        if (!sel || sel.tagName !== 'SELECT') return null;
        if (typeof sel.selectedIndex !== 'number' || sel.selectedIndex < 0) return null;
        var op = sel.options[sel.selectedIndex];
        if (!op) return null;
        var val = String(op.value == null ? '' : op.value).trim();
        if (val === '') return null;
        var lab = String(op.textContent || op.label || val).trim();
        return { value: val, label: lab || val };
    }

    // Millwork wood: prefer a dedicated millwork wood select; otherwise (only inside a
    // millwork/baluster/custom-length context) fall back to the wood_type select/radios,
    // which on those products represent the millwork wood species.
    function readCurrentMillworkWood(millworkContext) {
        var dedicated = document.querySelector('select[data-millwork-wood-select]');
        if (dedicated) {
            var lvd = millworkSelectedLabelValue(dedicated);
            if (lvd) return lvd;
        }
        if (!millworkContext) return null;
        var woodSel = document.querySelector('select[data-option-id="wood_type"]');
        if (woodSel) {
            var lv = millworkSelectedLabelValue(woodSel);
            if (lv) return lv;
        }
        var root = document.getElementById('door-configurator-options') || document;
        var checked = root.querySelector('input[type="radio"][data-option-id="wood_type"]:checked');
        if (checked) {
            var val = String(checked.value || '').trim();
            var card = checked.closest ? checked.closest('.common-check-option') : null;
            var lbl = card ? card.querySelector('.common-check-option-label, .common-check-option-text') : null;
            var lab = lbl ? String(lbl.textContent || '').trim() : '';
            if (val || lab) return { value: val || lab, label: lab || val };
        }
        return null;
    }

    // Capture the customer's current millwork selections (Wood / Length / Thickness) as
    // readable summary rows so door-config2.js can persist them into _selected_summary
    // and the admin (Saved carts) app can display / restore them. Returns [] when the
    // product has no millwork UI, so normal doors are never polluted.
    function getMillworkSummaryItemsForConfig() {
        var out = [];
        var lengthSel = document.querySelector('[data-millwork-custom-length-select]')
            || document.querySelector('[data-millwork-length-select]')
            || document.querySelector('[data-millwork-baluster-length-select]');
        var thickSel = document.querySelector('[data-millwork-custom-thickness-select]');
        var lengthCfg = document.querySelector('[data-millwork-custom-length-config="1"], [data-millwork-baluster-length-config="1"], [data-millwork-length-config="1"]');
        var dedicatedWood = document.querySelector('[data-millwork-wood-select]');
        var millworkContext = !!(lengthSel || thickSel || lengthCfg || dedicatedWood);
        if (!millworkContext) return out;

        var wood = readCurrentMillworkWood(millworkContext);
        if (wood) out.push({ label: 'Millwork Wood', value: wood.label || wood.value, image: '' });

        var lengthLV = millworkSelectedLabelValue(lengthSel);
        if (lengthLV) out.push({ label: 'Custom Length', value: lengthLV.label || lengthLV.value, image: '' });

        var thickLV = millworkSelectedLabelValue(thickSel);
        if (thickLV) out.push({ label: 'Thickness', value: thickLV.label || thickLV.value, image: '' });

        return out;
    }

    var LANDING_HARDWARE_RESTORE_FIELDS = [
        {
            summaryLabels: ['finish'],
            propLabel: 'Finish',
            schemaIds: ['finish'],
            valueKey: 'finish_value',
            labelKey: 'finish_label',
            firstValueKey: '__landingHardwareFirstFinish',
            firstLabelKey: '__landingHardwareFirstFinishLabel',
            selectSelector: null,
            isFinishSwatch: true
        },
        {
            summaryLabels: ['hardware function'],
            propLabel: 'Hardware Function',
            schemaIds: ['function', 'hardware_function'],
            valueKey: 'function_value',
            labelKey: 'function_label',
            firstValueKey: '__landingHardwareFirstFunction',
            selectSelector: 'select.door-suggested-hardware-function, select[data-hw-function-select]'
        },
        {
            summaryLabels: ['closer color'],
            propLabel: 'Closer Color',
            schemaIds: ['closer_color'],
            valueKey: 'closer_color_value',
            labelKey: 'closer_color_label',
            firstValueKey: '__landingHardwareFirstCloserColor',
            selectSelector: 'select.door-suggested-hardware-closer-color, select[data-hw-closer-color-select]'
        },
        {
            summaryLabels: ['door thickness', 'thickness'],
            propLabel: 'Door Thickness',
            schemaIds: ['door_thickness', 'thickness'],
            valueKey: 'thickness_value',
            labelKey: 'thickness_label',
            firstValueKey: '__landingHardwareFirstThickness',
            selectSelector: 'select.door-suggested-hardware-thickness, select[data-hw-thickness-select]'
        },
        {
            // Dp start 27-08 — storefront label is Hardware Swing Direction; dual-key with swing_direction_*
            summaryLabels: ['swing direction', 'hardware swing direction', 'choose swing direction'],
            propLabel: 'Hardware Swing Direction',
            schemaIds: ['swing_direction', 'hardware_swing_direction'],
            valueKey: 'swing_direction_value',
            labelKey: 'swing_direction_label',
            aliasValueKey: 'hardware_swing_direction_value',
            aliasLabelKey: 'hardware_swing_direction_label',
            firstValueKey: '__landingHardwareFirstSwingDirection',
            selectSelector: 'select.door-suggested-hardware-swing-direction, select[data-hw-swing-direction-select], select.door-suggested-hardware-card__swing-direction-select, .door-suggested-hardware-card__swing-direction select, select[data-option-id="hardware_swing_direction"]'
            // Dp end 27-08
        },
        {
            summaryLabels: ['door backset', 'backset'],
            propLabel: 'Hardware Backset',
            schemaIds: ['door_backset', 'backset'],
            valueKey: 'backset_value',
            labelKey: 'backset_label',
            firstValueKey: '__landingHardwareFirstBackset',
            selectSelector: 'select.door-suggested-hardware-backset, select[data-hw-backset-select]'
        },
        {
            summaryLabels: ['track length'],
            propLabel: 'Track Length',
            schemaIds: ['track_length', 'door_hanger_tracker_length'],
            valueKey: 'track_length_value',
            labelKey: 'track_length_label',
            firstValueKey: '__landingHardwareFirstTrackLength',
            selectSelector: 'select.door-suggested-hardware-track-length, select[data-hw-track-length-select]'
        },
        {
            summaryLabels: ['number of connected doors', 'connected doors'],
            propLabel: 'Number of Connected Doors',
            schemaIds: ['connected_doors', 'number_of_connected_doors'],
            valueKey: 'connected_doors_value',
            labelKey: 'connected_doors_label',
            firstValueKey: '__landingHardwareFirstConnectedDoors',
            selectSelector: 'select.door-suggested-hardware-connected-doors, select[data-hw-connected-doors-select]'
        },
        {
            summaryLabels: ['upper track length'],
            propLabel: 'Upper Track Length',
            schemaIds: ['upper_track_length'],
            valueKey: 'upper_track_length_value',
            labelKey: 'upper_track_length_label',
            firstValueKey: '__landingHardwareFirstUpperTrackLength',
            selectSelector: 'select.door-suggested-hardware-upper-track-length, select[data-hw-upper-track-length-select]'
        },
        {
            summaryLabels: ['max door size'],
            propLabel: 'Max Door Size',
            schemaIds: ['max_door_size'],
            valueKey: 'max_door_size_value',
            labelKey: 'max_door_size_label',
            firstValueKey: '__landingHardwareFirstMaxDoorSize',
            selectSelector: 'select.door-suggested-hardware-max-door-size, select[data-hw-max-door-size-select]'
        },
        {
            summaryLabels: ['carriage pack type'],
            propLabel: 'Carriage Pack Type',
            schemaIds: ['carriage_pack_type'],
            valueKey: 'carriage_pack_type_value',
            labelKey: 'carriage_pack_type_label',
            firstValueKey: '__landingHardwareFirstCarriagePackType',
            selectSelector: 'select.door-suggested-hardware-carriage-pack-type, select[data-hw-carriage-pack-type-select]'
        },
        {
            summaryLabels: ['strap hinge length'],
            propLabel: 'Strap Hinge Length',
            schemaIds: ['strap_hinge_length'],
            valueKey: 'strap_hinge_length_value',
            labelKey: 'strap_hinge_length_label',
            firstValueKey: '__landingHardwareFirstStrapHingeLength',
            selectSelector: 'select.door-suggested-hardware-strap-hinge-length, select[data-hw-strap-hinge-length-select]'
        }
    ];

    function readSavedOptionKeyValue(opts, keys) {
        if (!opts || !keys || !keys.length) return '';
        var i, k, v;
        for (i = 0; i < keys.length; i++) {
            k = keys[i];
            if (!k || !Object.prototype.hasOwnProperty.call(opts, k)) continue;
            v = opts[k];
            if (v == null || v === '') continue;
            if (!Array.isArray(v)) return String(v).trim();
        }
        return '';
    }

    // Dp start 27-08 — placeholder Select / Please select is not a stored hardware value
    function isUnselectedHardwareChoice(v) {
        var s = String(v == null ? '' : v).trim();
        if (!s) return true;
        return /^(select|please\s+select|not\s+selected|none|n\/a)$/i.test(s);
    }

    function applyLandingHardwareSwingAliases(row, val, lbl) {
        if (!row || typeof row !== 'object') return;
        var cleanVal = isUnselectedHardwareChoice(val) ? '' : String(val || '').trim();
        var cleanLbl = isUnselectedHardwareChoice(lbl) ? '' : String(lbl || '').trim();
        if (!cleanVal && !cleanLbl) {
            delete row.swing_direction_value;
            delete row.swing_direction_label;
            delete row.hardware_swing_direction_value;
            delete row.hardware_swing_direction_label;
            return;
        }
        var storeVal = cleanVal || cleanLbl;
        var storeLbl = cleanLbl || cleanVal;
        row.swing_direction_value = storeVal;
        row.swing_direction_label = storeLbl;
        row.hardware_swing_direction_value = storeVal;
        row.hardware_swing_direction_label = storeLbl;
    }

    // Dp start 27-08 — Hardware Swing Direction: find the live storefront select (landing hardware)
    var LANDING_HW_SWING_SELECT_SELECTOR = [
        'select.door-suggested-hardware-swing-direction',
        'select[data-hw-swing-direction-select]',
        'select.door-suggested-hardware-card__swing-direction-select',
        '.door-suggested-hardware-card__swing-direction select',
        'select[data-option-id="hardware_swing_direction"]'
    ].join(', ');

    function findLandingHardwareSwingSelect(root, card) {
        var sel = null;
        if (card && card.querySelector) {
            sel = card.querySelector(LANDING_HW_SWING_SELECT_SELECTOR);
        }
        if (!sel && card && card.closest) {
            var hwScope = card.closest('[data-landing-hardware-config="1"], [data-hardware-layout="1"], .door-post-lockset-hardware-options');
            if (hwScope && hwScope.querySelector) {
                sel = hwScope.querySelector(LANDING_HW_SWING_SELECT_SELECTOR);
            }
        }
        if (sel) return sel;
        var scope = card || root;
        if (!scope || !scope.querySelectorAll) return null;
        var labels = scope.querySelectorAll(
            'label, .door-suggested-hardware-card__hw-label, .door-suggested-hardware-card__swing-direction-label'
        );
        var i;
        for (i = 0; i < labels.length; i++) {
            var t = String(labels[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
            if (t.indexOf('swing direction') === -1) continue;
            var htmlFor = labels[i].getAttribute('for');
            if (htmlFor) {
                var byId = document.getElementById(htmlFor);
                if (byId && byId.tagName === 'SELECT') return byId;
            }
            var wrap = labels[i].parentElement;
            if (wrap && wrap.querySelector) {
                var inner = wrap.querySelector('select');
                if (inner) return inner;
            }
        }
        return null;
    }

    function readLandingHardwareSwingFromDom(root, card) {
        var val = '';
        var lbl = '';
        var sel = findLandingHardwareSwingSelect(root, card);
        if (sel && sel.options && sel.selectedIndex >= 0) {
            var op = sel.options[sel.selectedIndex];
            val = String((op && op.value) || sel.value || '').trim();
            lbl = String((op && (op.textContent || op.label)) || val).trim();
            // Empty option value + real label (Left Hand / In Left) must still persist
            if (!val && lbl && !isUnselectedHardwareChoice(lbl)) val = lbl;
        }
        if (isUnselectedHardwareChoice(val) && isUnselectedHardwareChoice(lbl) && card) {
            var aVal = String(card.getAttribute('data-hw-swing-direction-value') || '').trim();
            var aLbl = String(card.getAttribute('data-hw-swing-direction-label') || '').trim();
            if (!isUnselectedHardwareChoice(aVal) || !isUnselectedHardwareChoice(aLbl)) {
                val = aVal;
                lbl = aLbl || aVal;
            }
        }
        if (isUnselectedHardwareChoice(val) && isUnselectedHardwareChoice(lbl) && sel) {
            var near = sel.parentElement || sel;
            var selectedItem = near.querySelector
                ? near.querySelector('.door-div-select__item[aria-selected="true"]')
                : null;
            if (!selectedItem && sel.nextElementSibling && sel.nextElementSibling.querySelector) {
                selectedItem = sel.nextElementSibling.querySelector('.door-div-select__item[aria-selected="true"]');
            }
            if (selectedItem) {
                var itemTxt = String(selectedItem.textContent || '').trim();
                var itemVal = String(selectedItem.getAttribute('data-value') || '').trim();
                if (!isUnselectedHardwareChoice(itemTxt) || !isUnselectedHardwareChoice(itemVal)) {
                    val = itemVal || itemTxt;
                    lbl = itemTxt || itemVal;
                }
            }
            if (isUnselectedHardwareChoice(val) && isUnselectedHardwareChoice(lbl)) {
                var divLblEl = near.querySelector
                    ? near.querySelector('.door-div-select__label')
                    : null;
                var divTxt = divLblEl ? String(divLblEl.textContent || '').trim() : '';
                if (!isUnselectedHardwareChoice(divTxt)) {
                    val = divTxt;
                    lbl = divTxt;
                }
            }
        }
        if (isUnselectedHardwareChoice(val)) val = '';
        if (isUnselectedHardwareChoice(lbl)) lbl = '';
        return { value: val, label: lbl || val, select: sel };
    }
    // Dp end 27-08

    function readSavedLandingHardwareField(opts, fieldDef) {
        if (!opts || !fieldDef) return { value: '', label: '' };
        var hwRow = null;
        var hwList = opts._hardware_selections || opts.hardware_options;
        if (Array.isArray(hwList) && hwList[0] && typeof hwList[0] === 'object') {
            hwRow = hwList[0];
        }

        var rowVal = hwRow ? String(hwRow[fieldDef.valueKey] || '').trim() : '';
        var rowLbl = hwRow ? String(hwRow[fieldDef.labelKey] || '').trim() : '';
        // Dp start 27-08 — also read hardware_swing_direction_* / swing_direction_* aliases
        if ((!rowVal && !rowLbl) && fieldDef.aliasValueKey && hwRow) {
            rowVal = String(hwRow[fieldDef.aliasValueKey] || '').trim();
            rowLbl = String(hwRow[fieldDef.aliasLabelKey] || rowVal).trim();
        }
        if (isUnselectedHardwareChoice(rowVal)) rowVal = '';
        if (isUnselectedHardwareChoice(rowLbl)) rowLbl = '';
        // Dp end 27-08
        if (rowVal || rowLbl) {
            return {
                value: rowVal || rowLbl,
                label: rowLbl || rowVal
            };
        }

        var fromSaved = readSavedMillworkField(
            opts,
            [],
            (fieldDef.summaryLabels || []).concat(fieldDef.propLabel ? [fieldDef.propLabel] : [])
        );
        if (fromSaved && !isUnselectedHardwareChoice(fromSaved)) {
            return { value: fromSaved, label: fromSaved };
        }

        var schemaVal = readSavedOptionKeyValue(opts, fieldDef.schemaIds || []);
        if (schemaVal && !isUnselectedHardwareChoice(schemaVal)) {
            return { value: schemaVal, label: schemaVal };
        }

        return { value: '', label: '' };
    }

    function applyLandingHardwareSelectFromSaved(sel, saved) {
        if (!sel || !saved) return false;
        return setMillworkSelectFromSaved(sel, saved.value, saved.label);
    }

    // Normalize a finish token so admin-saved values (possibly a different value space)
    // still match the storefront swatch: lower-case, collapse to "_", drop trailing "_finish".
    function normLandingFinishToken(s) {
        return String(s == null ? '' : s)
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '_')
            .replace(/^_+|_+$/g, '')
            .replace(/_finish$/, '');
    }

    function applyLandingHardwareFinishSwatchFromSaved(card, saved) {
        if (!card || !saved) return false;
        var wantVal = String(saved.value || '').trim();
        var wantLab = String(saved.label || saved.value || '').trim();
        if (!wantVal && !wantLab) return false;
        var wantValN = normLandingFinishToken(wantVal);
        var wantLabN = normLandingFinishToken(wantLab);
        var matched = false;
        card.querySelectorAll('.door-suggested-hardware-swatch').forEach(function (sw) {
            if (matched) return;
            var fv = String(sw.getAttribute('data-finish-value') || '');
            var fl = String(sw.getAttribute('data-finish-label') || sw.getAttribute('title') || sw.getAttribute('aria-label') || '').trim();
            var fvN = normLandingFinishToken(fv);
            var flN = normLandingFinishToken(fl);
            var hit = (wantVal && (fv === wantVal || doorDivSelectValuesMatch(wantVal, fv)))
                || (wantLab && (fl === wantLab || doorDivSelectValuesMatch(wantLab, fl) || doorDivSelectValuesMatch(wantLab, fv)))
                || (wantValN && (fvN === wantValN || flN === wantValN))
                || (wantLabN && (flN === wantLabN || fvN === wantLabN));
            if (!hit) return;
            card.querySelectorAll('.door-suggested-hardware-swatch').forEach(function (s) {
                s.classList.remove('door-suggested-hardware-swatch--selected');
            });
            sw.classList.add('door-suggested-hardware-swatch--selected');
            // Only update a dedicated finish-label display element, never a swatch button
            // (all swatches carry data-finish-label, so guard against overwriting them).
            var finishLabel = card.querySelector('[data-finish-label]:not(.door-suggested-hardware-swatch)');
            if (finishLabel) finishLabel.textContent = fl || wantLab;
            card.setAttribute('data-hw-finish-value', fv || wantVal);
            card.setAttribute('data-hw-finish-label', fl || wantLab);
            window.__landingHardwareFirstFinish = fv || wantVal;
            window.__landingHardwareFirstFinishLabel = fl || wantLab;
            callLandingHardwareFinishImageUpdate(sw);
            matched = true;
        });
        return matched;
    }

    function applyLandingHardwareRestoreToDom(opts) {
        var root = document.querySelector('[data-landing-hardware-config="1"]');
        if (!root) return false;
        var card = root.querySelector('.door-suggested-hardware-card');
        if (!card) return false;
        var appliedAny = false;
        var pending = false;

        LANDING_HARDWARE_RESTORE_FIELDS.forEach(function (fieldDef) {
            var saved = readSavedLandingHardwareField(opts, fieldDef);
            if (!saved.value && !saved.label) return;
            if (fieldDef.firstValueKey) {
                window[fieldDef.firstValueKey] = saved.value || saved.label;
            }
            if (fieldDef.firstLabelKey) {
                window[fieldDef.firstLabelKey] = saved.label || saved.value;
            }
            if (fieldDef.isFinishSwatch) {
                if (applyLandingHardwareFinishSwatchFromSaved(card, saved)) {
                    appliedAny = true;
                }
                return;
            }
            if (!fieldDef.selectSelector) return;
            var sel = root.querySelector(fieldDef.selectSelector);
            if (!sel) {
                pending = true;
                return;
            }
            if (applyLandingHardwareSelectFromSaved(sel, saved)) {
                appliedAny = true;
            } else {
                pending = true;
            }
        });

        if (appliedAny) {
            try { bootLandingHardwareConfig(); } catch (eBootHw) { }
            try {
                if (card.getAttribute('data-hw-card-bound') !== '1') {
                    bindLandingHardwareCard(card);
                }
            } catch (eBindHw) { }
        }
        return appliedAny && !pending;
    }

    function restoreLandingHardwareSelectionsFromSaved(opts) {
        if (!opts || typeof opts !== 'object') return;
        if (!document.querySelector('[data-landing-hardware-config="1"]')) return;
        var tries = 0;
        (function loop() {
            tries++;
            try { bootLandingHardwareConfig(); } catch (eBoot) { }
            var done = false;
            try { done = applyLandingHardwareRestoreToDom(opts); } catch (eApply) { done = false; }
            if (done) {
                setTimeout(function () {
                    try { applyLandingHardwareRestoreToDom(opts); } catch (eLate) { }
                }, 0);
                return;
            }
            if (tries >= 40) return;
            setTimeout(loop, 250);
        })();
    }

    function captureLandingHardwareSummaryEntries(pushItem) {
        if (typeof pushItem !== 'function') return;
        var root = document.querySelector('[data-landing-hardware-config="1"]');
        if (!root) return;
        var card = root.querySelector('.door-suggested-hardware-card');
        if (!card) return;
        LANDING_HARDWARE_RESTORE_FIELDS.forEach(function (fieldDef) {
            if (!fieldDef || !fieldDef.propLabel) return;
            var val = '';
            var lbl = '';
            if (fieldDef.isFinishSwatch) {
                val = String(card.getAttribute('data-hw-finish-value') || '').trim();
                lbl = String(card.getAttribute('data-hw-finish-label') || '').trim();
            } else if (fieldDef.selectSelector) {
                // Dp start 27-08 — Hardware Swing Direction: live DOM (select / attrs / custom list)
                if (fieldDef.valueKey === 'swing_direction_value' || fieldDef.aliasValueKey === 'hardware_swing_direction_value') {
                    var swingCap = readLandingHardwareSwingFromDom(root, card);
                    val = swingCap.value;
                    lbl = swingCap.label;
                } else {
                    var sel = (card && card.querySelector(fieldDef.selectSelector))
                        || (root && root.querySelector(fieldDef.selectSelector));
                    if (sel && sel.selectedIndex >= 0) {
                        var op = sel.options[sel.selectedIndex];
                        val = String(sel.value || '').trim();
                        lbl = String((op && op.textContent) || val).trim();
                        if (window.DoorConf2Hardware && typeof window.DoorConf2Hardware.resolveHardwareSelectStoredPair === 'function') {
                            var fnPair = window.DoorConf2Hardware.resolveHardwareSelectStoredPair(sel);
                            if (fnPair.value || fnPair.label) {
                                val = fnPair.value;
                                lbl = fnPair.label;
                            }
                        }
                    }
                }
                // Dp end 27-08
            }
            // Dp start 27-08 — omit Select placeholder from summary
            if (isUnselectedHardwareChoice(val) && isUnselectedHardwareChoice(lbl)) return;
            // Dp end 27-08
            pushItem(fieldDef.propLabel, lbl || val);
        });
    }

    function mergeLandingHardwareIntoSelections(hwList) {
        var root = document.querySelector('[data-landing-hardware-config="1"]');
        if (!root) return Array.isArray(hwList) ? hwList : [];
        var card = root.querySelector('.door-suggested-hardware-card');
        if (!card) return Array.isArray(hwList) ? hwList : [];
        var list = Array.isArray(hwList) ? hwList.slice() : [];
        var row = (list[0] && typeof list[0] === 'object') ? Object.assign({}, list[0]) : {};
        if (!row.title) {
            var titleEl = card.querySelector('.door-suggested-hardware-card__title, .door-hw-product__title');
            row.title = titleEl ? String(titleEl.textContent || '').trim() : '';
        }
        if (!row.product_id) {
            row.product_id = String(card.getAttribute('data-product-id') || card.getAttribute('data-choice-value') || '').trim();
        }
        LANDING_HARDWARE_RESTORE_FIELDS.forEach(function (fieldDef) {
            if (!fieldDef || !fieldDef.valueKey || !fieldDef.labelKey) return;
            var val = '';
            var lbl = '';
            if (fieldDef.isFinishSwatch) {
                val = String(card.getAttribute('data-hw-finish-value') || '').trim();
                lbl = String(card.getAttribute('data-hw-finish-label') || '').trim();
            } else if (fieldDef.selectSelector) {
                // Dp start 27-08 — Hardware Swing Direction from live storefront dropdown
                if (fieldDef.valueKey === 'swing_direction_value' || fieldDef.aliasValueKey === 'hardware_swing_direction_value') {
                    var swingMerge = readLandingHardwareSwingFromDom(root, card);
                    val = swingMerge.value;
                    lbl = swingMerge.label;
                } else {
                    var sel = (card && card.querySelector(fieldDef.selectSelector))
                        || (root && root.querySelector(fieldDef.selectSelector));
                    if (sel && sel.selectedIndex >= 0) {
                        if (window.DoorConf2Hardware && typeof window.DoorConf2Hardware.resolveHardwareSelectStoredPair === 'function') {
                            var mergePair = window.DoorConf2Hardware.resolveHardwareSelectStoredPair(sel);
                            val = mergePair.value;
                            lbl = mergePair.label;
                        } else {
                            var op = sel.options[sel.selectedIndex];
                            val = String(sel.value || '').trim();
                            lbl = String((op && op.textContent) || val).trim();
                        }
                    }
                }
                // Dp end 27-08
            }
            // Dp start 27-08 — dual-write hardware swing keys; never persist Select
            if (fieldDef.valueKey === 'swing_direction_value' || fieldDef.aliasValueKey === 'hardware_swing_direction_value') {
                applyLandingHardwareSwingAliases(row, val, lbl);
                // Persist live option list for admin restore
                var swingSel = (swingMerge && swingMerge.select)
                    || findLandingHardwareSwingSelect(root, card)
                    || (card && card.querySelector(fieldDef.selectSelector));
                if (swingSel && swingSel.options) {
                    var swingOpts = [];
                    for (var si = 0; si < swingSel.options.length; si++) {
                        var sop = swingSel.options[si];
                        if (!sop) continue;
                        var sv = String(sop.value || '').trim();
                        var sl = String(sop.textContent || '').trim();
                        if (isUnselectedHardwareChoice(sv) && isUnselectedHardwareChoice(sl)) continue;
                        if (!sv && !sl) continue;
                        swingOpts.push({ value: sv || sl, label: sl || sv });
                    }
                    if (swingOpts.length) {
                        row.swing_direction_options = swingOpts;
                        row.hardware_swing_direction_options = swingOpts;
                    }
                }
                return;
            }
            if (isUnselectedHardwareChoice(val) && isUnselectedHardwareChoice(lbl)) {
                delete row[fieldDef.valueKey];
                delete row[fieldDef.labelKey];
                return;
            }
            // Dp end 27-08
            if (val || lbl) {
                row[fieldDef.valueKey] = val || lbl;
                row[fieldDef.labelKey] = lbl || val;
            }
        });
        if (list.length) {
            list[0] = row;
        } else if (row.title || row.product_id) {
            list = [row];
        }
        return list;
    }

    function mergeLandingHardwareSchemaKeys(cfg, hwList) {
        if (!cfg || typeof cfg !== 'object') return cfg;
        var row = Array.isArray(hwList) && hwList[0] && typeof hwList[0] === 'object' ? hwList[0] : null;
        if (!row) return cfg;
        LANDING_HARDWARE_RESTORE_FIELDS.forEach(function (fieldDef) {
            if (!fieldDef || !fieldDef.schemaIds || !fieldDef.valueKey) return;
            var val = String(row[fieldDef.valueKey] || row[fieldDef.aliasValueKey] || '').trim();
            // Dp start 27-08
            if (!val || isUnselectedHardwareChoice(val)) return;
            // Dp start 02-09 — hardware swing is not door Swing Direction; only write when product has the field
            if (fieldDef.valueKey === 'swing_direction_value' || fieldDef.aliasValueKey === 'hardware_swing_direction_value') {
                var hasHwSwing = Array.isArray(row.hardware_swing_direction_options || row.swing_direction_options)
                    && (row.hardware_swing_direction_options || row.swing_direction_options).length > 0;
                if (!hasHwSwing) return;
            }
            // Dp end 02-09
            fieldDef.schemaIds.forEach(function (sid) {
                if (!sid) return;
                // Dp start 02-09 — never mirror hardware swing onto door swing_direction schema key
                if ((fieldDef.valueKey === 'swing_direction_value' || fieldDef.aliasValueKey === 'hardware_swing_direction_value')
                    && sid === 'swing_direction') {
                    return;
                }
                // Dp end 02-09
                cfg[sid] = val;
            });
        });
        return cfg;
    }

    function buildLandingHardwareLineItemProperties() {
        var props = {};
        var root = document.querySelector('[data-landing-hardware-config="1"]');
        if (!root) return props;
        var card = root.querySelector('.door-suggested-hardware-card');
        if (!card) return props;
        LANDING_HARDWARE_RESTORE_FIELDS.forEach(function (fieldDef) {
            if (!fieldDef || !fieldDef.propLabel) return;
            var val = '';
            var lbl = '';
            if (fieldDef.isFinishSwatch) {
                val = String(card.getAttribute('data-hw-finish-value') || '').trim();
                lbl = String(card.getAttribute('data-hw-finish-label') || '').trim();
            } else if (fieldDef.selectSelector) {
                // Dp start 27-08 — Hardware Swing Direction from live storefront dropdown
                if (fieldDef.valueKey === 'swing_direction_value' || fieldDef.aliasValueKey === 'hardware_swing_direction_value') {
                    var swingProp = readLandingHardwareSwingFromDom(root, card);
                    val = swingProp.value;
                    lbl = swingProp.label;
                } else {
                    var sel = (card && card.querySelector(fieldDef.selectSelector))
                        || (root && root.querySelector(fieldDef.selectSelector));
                    if (sel && sel.selectedIndex >= 0) {
                        var op = sel.options[sel.selectedIndex];
                        val = String(sel.value || '').trim();
                        lbl = String((op && op.textContent) || val).trim();
                        if (window.DoorConf2Hardware && typeof window.DoorConf2Hardware.resolveHardwareSelectStoredPair === 'function') {
                            var fnPair = window.DoorConf2Hardware.resolveHardwareSelectStoredPair(sel);
                            if (fnPair.value || fnPair.label) {
                                val = fnPair.value;
                                lbl = fnPair.label;
                            }
                        }
                    }
                }
                // Dp end 27-08
            }
            // Dp start 27-08
            if (isUnselectedHardwareChoice(val) && isUnselectedHardwareChoice(lbl)) return;
            // Dp end 27-08
            props[fieldDef.propLabel] = lbl || val;
        });
        return props;
    }

    function getSelectOptionDisplayLabel(opt) {
        if (!opt) return '';
        var lbl = String(opt.textContent || opt.label || opt.value || '').trim();
        // --- Dp start ---
        if (lbl.indexOf('_inch') !== -1) {
            lbl = lbl.replace(/_inch/g, '');
        }
        // --- Dp end --
        return lbl;
    }

    function closeDoorDivSelect(divWrap) {
        if (!divWrap) return;
        divWrap.classList.remove('door-div-select--open');
        var btn = divWrap.querySelector('.door-div-select__btn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    function closeAllDoorDivSelects(exceptWrap) {
        all('.door-div-select--open').forEach(function (el) {
            if (exceptWrap && el === exceptWrap) return;
            closeDoorDivSelect(el);
        });
    }

    function syncDoorDivSelectFromNative(selectEl, divWrap) {
        if (!selectEl || !divWrap) return;
        var labelEl = divWrap.querySelector('.door-div-select__label');
        var list = divWrap.querySelector('.door-div-select__list');
        var val = String(selectEl.value || '');
        var opt = selectEl.options[selectEl.selectedIndex];
        if (!val && opt) val = String(opt.value || '');
        var text = '';
        if (opt) {
            text = getSelectOptionDisplayLabel(opt);
        }
        if (!text && list) {
            list.querySelectorAll('.door-div-select__item').forEach(function (item) {
                if (text) return;
                var dv = String(item.getAttribute('data-value') || '');
                if (doorDivSelectValuesMatch(dv, val)) {
                    text = String(item.textContent || '').trim();
                }
            });
        }
        var nextLabel = text || val;
        // Avoid rewriting DOM while open/hover — text/aria churn + CSS transition = blink.
        if (labelEl && String(labelEl.textContent || '') !== nextLabel) {
            labelEl.textContent = nextLabel;
        }
        if (list) {
            var selectedTxt = text || '';
            list.querySelectorAll('.door-div-select__item').forEach(function (item) {
                var dv = String(item.getAttribute('data-value') || '');
                var match = doorDivSelectValuesMatch(dv, val);
                // Dp start 27-08 — empty/duplicate values: match the visible option label
                if (!match && selectedTxt) {
                    var itemTxt = String(item.textContent || '').trim();
                    if (itemTxt && itemTxt === selectedTxt) match = true;
                }
                // Dp end 27-08
                var want = match ? 'true' : 'false';
                if (item.getAttribute('aria-selected') !== want) {
                    item.setAttribute('aria-selected', want);
                }
            });
        }
    }

    function doorDivSelectOptionSignature(selectEl) {
        if (!selectEl || !selectEl.options) return '';
        var parts = [];
        Array.from(selectEl.options).forEach(function (opt) {
            if (!opt || opt.disabled) return;
            parts.push(String(opt.value) + '=' + String(getSelectOptionDisplayLabel(opt) || opt.value));
        });
        return parts.join('|');
    }

    function dispatchSelectChange(selectEl) {
        if (!selectEl) return;
        try {
            selectEl.dispatchEvent(new Event('change', { bubbles: true }));
            selectEl.dispatchEvent(new Event('input', { bubbles: true }));
        } catch (eEv) {
            try {
                var ev = document.createEvent('HTMLEvents');
                ev.initEvent('change', true, false);
                selectEl.dispatchEvent(ev);
            } catch (eEv2) { }
        }
    }

    function countEnabledSelectOptions(selectEl) {
        if (!selectEl || !selectEl.options) return 0;
        var count = 0;
        Array.from(selectEl.options).forEach(function (opt) {
            if (!opt.disabled) count++;
        });
        return count;
    }

    function bindDoorDivSelectItemClick(selectEl, divWrap, item, opt, idx) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Dp start 27-08 — selectedIndex so empty/duplicate option values still stick (Hardware Swing Direction)
            if (typeof idx === 'number' && selectEl.options && selectEl.options[idx] === opt) {
                selectEl.selectedIndex = idx;
            } else {
                selectEl.value = String(opt.value);
            }
            if (selectEl.options[selectEl.selectedIndex] !== opt) {
                var oi;
                for (oi = 0; oi < selectEl.options.length; oi++) {
                    if (selectEl.options[oi] === opt) {
                        selectEl.selectedIndex = oi;
                        break;
                    }
                }
            }
            // Dp end 27-08
            dispatchSelectChange(selectEl);
            syncDoorDivSelectFromNative(selectEl, divWrap);
            closeDoorDivSelect(divWrap);
        });
        item.setAttribute('aria-selected', selectEl.selectedIndex === idx ? 'true' : 'false');
    }

    function rebuildDoorDivSelectOptions(selectEl, divWrap) {
        if (!selectEl || !divWrap) return;
        // Never tear down an open list — that is the thickness blink.
        if (divWrap.classList.contains('door-div-select--open')) return;
        var list = divWrap.querySelector('.door-div-select__list');
        if (!list) return;
        var nextSig = doorDivSelectOptionSignature(selectEl);
        if (divWrap.getAttribute('data-door-div-opt-sig') === nextSig
            && list.querySelectorAll('.door-div-select__item').length === countEnabledSelectOptions(selectEl)) {
            syncDoorDivSelectFromNative(selectEl, divWrap);
            return;
        }
        while (list.firstChild) list.removeChild(list.firstChild);
        Array.from(selectEl.options || []).forEach(function (opt, idx) {
            if (opt.disabled) return;
            var item = document.createElement('button');
            item.type = 'button';
            item.className = 'door-div-select__item';
            item.setAttribute('role', 'option');
            item.setAttribute('data-value', String(opt.value));
            item.textContent = getSelectOptionDisplayLabel(opt) || String(opt.value);
            bindDoorDivSelectItemClick(selectEl, divWrap, item, opt, idx);
            list.appendChild(item);
        });
        divWrap.setAttribute('data-door-div-opt-sig', nextSig);
        syncDoorDivSelectFromNative(selectEl, divWrap);
    }

    function shouldEnhanceDoorSelect(selectEl) {
        if (!selectEl || selectEl.tagName !== 'SELECT') return false;
        if (selectEl.disabled) return false;
        if (selectEl.getAttribute('data-door-div-select-skip') === '1') return false;
        if (selectEl.closest('template')) return false;
        return true;
    }

    function enhanceAllDoorConfiguratorSelects(root) {
        var scope = root || document.getElementById('door-configurator');
        if (!scope || !scope.querySelectorAll) return;
        if (window.__doorDivSelectEnhancing) return;
        window.__doorDivSelectEnhancing = true;
        try {
            all('select', scope).forEach(function (sel) {
                if (shouldEnhanceDoorSelect(sel)) enhanceDoorSelectWithDivDropdown(sel);
            });
            patchAriaControls();
        } finally {
            window.__doorDivSelectEnhancing = false;
        }
    }

    function mutationIntroducesSelect(mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var m = mutations[i];
            if (m.type !== 'childList' || !m.addedNodes || !m.addedNodes.length) continue;
            var t = m.target;
            if (t && t.closest && t.closest('.door-div-select')) continue;
            for (var n = 0; n < m.addedNodes.length; n++) {
                var node = m.addedNodes[n];
                if (!node || node.nodeType !== 1) continue;
                if (node.tagName === 'SELECT') return true;
                if (node.querySelector && node.querySelector('select')) return true;
            }
        }
        return false;
    }

    function bindDoorDivSelectMutationObserver() {
        if (window.__doorDivSelectMutationBound) return;
        var obsRoot = document.getElementById('door-configurator');
        if (!obsRoot) return;
        window.__doorDivSelectMutationBound = true;
        var observer = new MutationObserver(function (mutations) {
            if (window.__doorDivSelectEnhancing) return;
            // Price/label DOM churn must not re-enhance every select (blinks open thickness list).
            if (!mutationIntroducesSelect(mutations)) return;
            if (window.__doorDivSelectEnhanceTimer) clearTimeout(window.__doorDivSelectEnhanceTimer);
            window.__doorDivSelectEnhanceTimer = setTimeout(function () {
                window.__doorDivSelectEnhanceTimer = null;
                enhanceAllDoorConfiguratorSelects(obsRoot);
            }, 120);
        });
        observer.observe(obsRoot, { childList: true, subtree: true });
    }

    function bootDoorDivSelectEnhancement() {
        enhanceAllDoorConfiguratorSelects(document.getElementById('door-configurator'));
    }

    function enhanceDoorSelectWithDivDropdown(selectEl) {
        if (!selectEl || selectEl.tagName !== 'SELECT') return null;
        if (selectEl.getAttribute('data-door-div-select') === '1') {
            var linked = selectEl.nextElementSibling;
            if (linked && linked.classList && linked.classList.contains('door-div-select')) {
                // Leave an open dropdown alone — caller can sync after close/change.
                if (linked.classList.contains('door-div-select--open')) return linked;
                var existingItems = linked.querySelectorAll('.door-div-select__item').length;
                var optionCount = countEnabledSelectOptions(selectEl);
                var sig = doorDivSelectOptionSignature(selectEl);
                if (existingItems !== optionCount || linked.getAttribute('data-door-div-opt-sig') !== sig) {
                    rebuildDoorDivSelectOptions(selectEl, linked);
                } else {
                    syncDoorDivSelectFromNative(selectEl, linked);
                }
                return linked;
            }
            return null;
        }

        var existing = selectEl.nextElementSibling;
        if (existing && existing.classList && existing.classList.contains('door-div-select')) {
            selectEl.setAttribute('data-door-div-select', '1');
            selectEl.classList.add('door-native-select--enhanced');
            if (existing.classList.contains('door-div-select--open')) return existing;
            var existingCount = existing.querySelectorAll('.door-div-select__item').length;
            var enabledCount = countEnabledSelectOptions(selectEl);
            var existingSig = doorDivSelectOptionSignature(selectEl);
            if (existingCount !== enabledCount || existing.getAttribute('data-door-div-opt-sig') !== existingSig) {
                rebuildDoorDivSelectOptions(selectEl, existing);
            } else {
                syncDoorDivSelectFromNative(selectEl, existing);
            }
            return existing;
        }

        selectEl.classList.add('door-native-select--enhanced');
        selectEl.setAttribute('data-door-div-select', '1');

        var divWrap = document.createElement('div');
        divWrap.className = 'door-div-select';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'door-div-select__btn';
        btn.setAttribute('aria-haspopup', 'listbox');
        btn.setAttribute('aria-expanded', 'false');
        if (selectEl.id) {
            var assocLabel = document.querySelector('label[for="' + selectEl.id + '"]');
            if (assocLabel && assocLabel.id) btn.setAttribute('aria-labelledby', assocLabel.id);
        }

        var labelSpan = document.createElement('span');
        labelSpan.className = 'door-div-select__label';
        btn.appendChild(labelSpan);

        var iconSpan = document.createElement('span');
        iconSpan.className = 'door-div-select__icon';
        appendChevronDownIcon(iconSpan);
        btn.appendChild(iconSpan);

        var list = document.createElement('div');
        list.className = 'door-div-select__list';
        list.setAttribute('role', 'listbox');

        Array.from(selectEl.options || []).forEach(function (opt, idx) {
            if (opt.disabled) return;
            var item = document.createElement('button');
            item.type = 'button';
            item.className = 'door-div-select__item';
            item.setAttribute('role', 'option');
            item.setAttribute('data-value', String(opt.value));
            item.textContent = getSelectOptionDisplayLabel(opt) || String(opt.value);
            bindDoorDivSelectItemClick(selectEl, divWrap, item, opt, idx);
            list.appendChild(item);
        });
        divWrap.setAttribute('data-door-div-opt-sig', doorDivSelectOptionSignature(selectEl));

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var willOpen = !divWrap.classList.contains('door-div-select--open');
            closeAllDoorDivSelects(willOpen ? divWrap : null);
            divWrap.classList.toggle('door-div-select--open', willOpen);
            btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

            // === NAYA CODE: Jab dropdown open ho, toh selected item ko scroll karke upar laye ===
            if (willOpen) {
                scrollSelectedDoorDivOptionIntoView(divWrap);
            }
        });

        selectEl.addEventListener('change', function () {
            syncDoorDivSelectFromNative(selectEl, divWrap);
        });

        divWrap.appendChild(btn);
        divWrap.appendChild(list);
        selectEl.insertAdjacentElement('afterend', divWrap);
        syncDoorDivSelectFromNative(selectEl, divWrap);

        if (!window.__doorDivSelectOutsideBound) {
            window.__doorDivSelectOutsideBound = true;
            document.addEventListener('click', function (e) {
                if (e.target.closest && e.target.closest('.door-div-select')) return;
                closeAllDoorDivSelects();
            });
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') closeAllDoorDivSelects();
            });
        }

        return divWrap;
    }

    function ensurePropertyInput(form, key, value) {
        if (!form) return;
        var name = 'properties[' + key + ']';
        var el = form.querySelector('input[name="' + name + '"]');
        if (!el) {
            el = document.createElement('input');
            el.type = 'hidden';
            el.name = name;
            form.appendChild(el);
        }
        el.value = String(value == null ? '' : value);
    }

    function isLandingHwImageUrl(src) {
        return !!(src && src !== '#' && /^(\/\/|https?:\/\/)/i.test(String(src)));
    }

    // Landing hardware: data-finish-image="#" (or missing) → default product hero image.
    function updateLandingProductMediaFromSwatch(swatchEl) {
        // Dp start 12-08
        // Temporary condition: stop changing image of landing-product-media-image on click of finish swatch in door-suggested-hardware-card__finish for hardware collection products
        return;
        // Dp end 12-08
        var mediaEl = document.getElementById('landing-product-media-image');
        if (!mediaEl || !swatchEl) return;
        var dataImg = String(swatchEl.getAttribute('data-finish-image') || '').trim();
        var defSrc = String(mediaEl.getAttribute('data-landing-product-default-image') || '').trim();
        var defAlt = String(mediaEl.getAttribute('data-landing-product-default-alt') || '').trim();
        var finishLabel = String(
            swatchEl.getAttribute('data-finish-label')
            || swatchEl.getAttribute('title')
            || swatchEl.getAttribute('aria-label')
            || ''
        ).trim();
        if (!dataImg || dataImg === '#') {
            if (defSrc) mediaEl.setAttribute('src', defSrc);
            if (defAlt) mediaEl.setAttribute('alt', defAlt);
            return;
        }
        if (isLandingHwImageUrl(dataImg)) {
            mediaEl.setAttribute('src', dataImg);
            if (finishLabel) mediaEl.setAttribute('alt', finishLabel);
        }
    }

    function callLandingHardwareFinishImageUpdate(swatchEl) {
        // Dp start 12-08
        // Temporary condition: prevent triggering image updates for hardware finish swatches
        return;
        // Dp end 12-08
        try { updateLandingProductMediaFromSwatch(swatchEl); } catch (eHwLandImg) { }
    }

    // Dp start 12-08
    // Protect landing-product-media-image from any attribute or property src modifications on hardware finish swatch selection.
    (function () {
        function protectLandingProductImage() {
            var mediaEl = document.getElementById('landing-product-media-image');
            if (!mediaEl || mediaEl.getAttribute('data-dp-img-protected') === '1') return;
            mediaEl.setAttribute('data-dp-img-protected', '1');

            var nativeSetAttribute = mediaEl.setAttribute;
            mediaEl.setAttribute = function (name, value) {
                if (String(name).toLowerCase() === 'src') {
                    // Temporary condition: block changing src attribute on landing-product-media-image for hardware collection products
                    return;
                }
                return nativeSetAttribute.apply(this, arguments);
            };

            try {
                var desc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
                if (desc && desc.set) {
                    Object.defineProperty(mediaEl, 'src', {
                        get: function () {
                            return desc.get.call(this);
                        },
                        set: function (val) {
                            // Temporary condition: block setting src property on landing-product-media-image for hardware collection products
                            return;
                        },
                        configurable: true,
                        enumerable: true
                    });
                }
            } catch (eImgProp) { }
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', protectLandingProductImage);
        } else {
            protectLandingProductImage();
        }
        setTimeout(protectLandingProductImage, 50);
        setTimeout(protectLandingProductImage, 300);
        setTimeout(protectLandingProductImage, 1000);
    })();
    // Dp end 12-08

    // Dp start 17-08 — hide Closer Color Silver only for HC-100
    function hideCloserSilverOptionForSpecificSku(selectEl, cardEl) {
        if (!selectEl) return;
        var sku = (cardEl && cardEl.getAttribute && cardEl.getAttribute('data-hw-product-sku')) || '';
        if (!sku) {
            var cfg = document.getElementById('landing-product-configurator');
            if (cfg) sku = cfg.getAttribute('data-product-sku') || '';
        }
        var skuKey = String(sku || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (skuKey !== 'HC100') return;
        var opts = selectEl.options ? Array.prototype.slice.call(selectEl.options) : [];
        opts.forEach(function (opt) {
            var txt = String((opt && (opt.value || '')) + ' ' + ((opt && opt.textContent) || '')).toLowerCase();
            if (txt.indexOf('silver') !== -1 && opt.parentNode) opt.parentNode.removeChild(opt);
        });
        if (selectEl.selectedIndex < 0 && selectEl.options && selectEl.options.length) {
            selectEl.selectedIndex = 0;
        }
    }
    // Dp end 17-08

    function bindLandingHardwareFinishMedia(card) {
        if (!card) return;
        card.querySelectorAll('.door-suggested-hardware-swatch').forEach(function (sw) {
            if (sw.getAttribute('data-hw-finish-media-bound') === '1') return;
            sw.setAttribute('data-hw-finish-media-bound', '1');
            sw.addEventListener('click', function () {
                callLandingHardwareFinishImageUpdate(sw);
            });
        });
        var selected = card.querySelector('.door-suggested-hardware-swatch--selected')
            || card.querySelector('.door-suggested-hardware-swatch');
        if (selected) callLandingHardwareFinishImageUpdate(selected);
    }

    function bindLandingHardwareCard(card) {
        if (!card || card.getAttribute('data-hw-card-bound') === '1') return;
        card.setAttribute('data-hw-card-bound', '1');

        var root = card.closest('[data-landing-hardware-config="1"]');
        /* MERGE: hardware_pocket_door_kit max_door_size filter — start */
        try { hydrateLandingMaxDoorSizeAllowAttrs(root, card); } catch (eHydrateCard) { }
        /* MERGE: hardware_pocket_door_kit max_door_size filter — end */
        if (root && root.getAttribute('data-hw-swatch-init') === '1') {
            var fnSelectOnly = card.querySelector('select.door-suggested-hardware-function, select[data-hw-function-select]');
            if (fnSelectOnly && fnSelectOnly.getAttribute('data-door-div-select') !== '1') {
                enhanceDoorSelectWithDivDropdown(fnSelectOnly);
            }
            var ccSelectOnly = card.querySelector('select.door-suggested-hardware-closer-color, select[data-hw-closer-color-select]');
            if (ccSelectOnly && ccSelectOnly.getAttribute('data-door-div-select') !== '1') {
                // Dp start 17-08
                hideCloserSilverOptionForSpecificSku(ccSelectOnly, card);
                // Dp end 17-08
                enhanceDoorSelectWithDivDropdown(ccSelectOnly);
            }
            var thickSelectOnly = card.querySelector('select.door-suggested-hardware-thickness, select[data-hw-thickness-select]');
            if (thickSelectOnly && thickSelectOnly.getAttribute('data-door-div-select') !== '1') {
                enhanceDoorSelectWithDivDropdown(thickSelectOnly);
            }
            var sdSelectOnly = findLandingHardwareSwingSelect(root, card)
                || card.querySelector('select.door-suggested-hardware-swing-direction, select[data-hw-swing-direction-select]');
            if (sdSelectOnly) {
                // Dp start 27-08 — still sync swing attrs when liquid already initialized swatches
                if (sdSelectOnly.getAttribute('data-door-div-select') !== '1') {
                    enhanceDoorSelectWithDivDropdown(sdSelectOnly);
                }
                if (sdSelectOnly.getAttribute('data-hw-swing-change-bound') !== '1') {
                    sdSelectOnly.setAttribute('data-hw-swing-change-bound', '1');
                    sdSelectOnly.addEventListener('change', function () {
                        var opt = sdSelectOnly.options[sdSelectOnly.selectedIndex];
                        var sv = opt ? String(opt.value || '').trim() : '';
                        var sl = opt ? String(opt.textContent || '').trim() : '';
                        if (!sv && sl && !isUnselectedHardwareChoice(sl)) sv = sl;
                        if (isUnselectedHardwareChoice(sv) && isUnselectedHardwareChoice(sl)) {
                            card.setAttribute('data-hw-swing-direction-value', '');
                            card.setAttribute('data-hw-swing-direction-label', '');
                        } else {
                            card.setAttribute('data-hw-swing-direction-value', sv);
                            card.setAttribute('data-hw-swing-direction-label', sl || sv);
                        }
                    });
                }
                // Sync current selection once
                (function () {
                    var opt = sdSelectOnly.options[sdSelectOnly.selectedIndex];
                    var sv = opt ? String(opt.value || '').trim() : '';
                    var sl = opt ? String(opt.textContent || '').trim() : '';
                    if (!sv && sl && !isUnselectedHardwareChoice(sl)) sv = sl;
                    if (isUnselectedHardwareChoice(sv) && isUnselectedHardwareChoice(sl)) {
                        card.setAttribute('data-hw-swing-direction-value', '');
                        card.setAttribute('data-hw-swing-direction-label', '');
                    } else {
                        card.setAttribute('data-hw-swing-direction-value', sv);
                        card.setAttribute('data-hw-swing-direction-label', sl || sv);
                    }
                })();
                // Dp end 27-08
            }
            var bsSelectOnly = card.querySelector('select.door-suggested-hardware-backset, select[data-hw-backset-select]');
            if (bsSelectOnly) {
                // --- Dp start 15-07 ---
                filterBacksetSelectElement(bsSelectOnly, card);
                // --- Dp end 15-07 ---
                if (bsSelectOnly.getAttribute('data-door-div-select') !== '1') {
                    enhanceDoorSelectWithDivDropdown(bsSelectOnly);
                }
                // Sync Door Backset attrs when liquid already initialized swatches (parity with swing)
                if (bsSelectOnly.getAttribute('data-hw-backset-change-bound') !== '1') {
                    bsSelectOnly.setAttribute('data-hw-backset-change-bound', '1');
                    bsSelectOnly.addEventListener('change', function () {
                        var opt = bsSelectOnly.options[bsSelectOnly.selectedIndex];
                        var bv = opt ? String(opt.value || '').trim() : '';
                        var bl = opt ? String(opt.textContent || '').trim() : '';
                        if (!bv && bl && !isUnselectedHardwareChoice(bl)) bv = bl;
                        if (isUnselectedHardwareChoice(bv) && isUnselectedHardwareChoice(bl)) {
                            card.setAttribute('data-hw-backset-value', '');
                            card.setAttribute('data-hw-backset-label', '');
                        } else {
                            card.setAttribute('data-hw-backset-value', bv);
                            card.setAttribute('data-hw-backset-label', bl || bv);
                        }
                    });
                }
                (function () {
                    var opt = bsSelectOnly.options[bsSelectOnly.selectedIndex];
                    var bv = opt ? String(opt.value || '').trim() : '';
                    var bl = opt ? String(opt.textContent || '').trim() : '';
                    if (!bv && bl && !isUnselectedHardwareChoice(bl)) bv = bl;
                    if (isUnselectedHardwareChoice(bv) && isUnselectedHardwareChoice(bl)) {
                        card.setAttribute('data-hw-backset-value', '');
                        card.setAttribute('data-hw-backset-label', '');
                    } else {
                        card.setAttribute('data-hw-backset-value', bv);
                        card.setAttribute('data-hw-backset-label', bl || bv);
                    }
                })();
            }
            var tlSelectOnly = card.querySelector('select.door-suggested-hardware-track-length, select[data-hw-track-length-select]');
            if (tlSelectOnly && tlSelectOnly.getAttribute('data-door-div-select') !== '1') {
                enhanceDoorSelectWithDivDropdown(tlSelectOnly);
            }
            var cdSelectOnly = card.querySelector('select.door-suggested-hardware-connected-doors, select[data-hw-connected-doors-select]');
            if (cdSelectOnly && cdSelectOnly.getAttribute('data-door-div-select') !== '1') {
                enhanceDoorSelectWithDivDropdown(cdSelectOnly);
            }
            var utlSelectOnly = card.querySelector('select.door-suggested-hardware-upper-track-length, select[data-hw-upper-track-length-select]');
            if (utlSelectOnly && utlSelectOnly.getAttribute('data-door-div-select') !== '1') {
                enhanceDoorSelectWithDivDropdown(utlSelectOnly);
            }
            var mdsSelectOnly = card.querySelector('select.door-suggested-hardware-max-door-size, select[data-hw-max-door-size-select]');
            if (mdsSelectOnly) {
                if (mdsSelectOnly.getAttribute('data-door-div-select') !== '1') {
                    enhanceDoorSelectWithDivDropdown(mdsSelectOnly);
                }
            }
            var cptSelectOnly = card.querySelector('select.door-suggested-hardware-carriage-pack-type, select[data-hw-carriage-pack-type-select]');
            if (cptSelectOnly && cptSelectOnly.getAttribute('data-door-div-select') !== '1') {
                enhanceDoorSelectWithDivDropdown(cptSelectOnly);
            }
            var shlSelectOnly = card.querySelector('select.door-suggested-hardware-strap-hinge-length, select[data-hw-strap-hinge-length-select]');
            if (shlSelectOnly && shlSelectOnly.getAttribute('data-door-div-select') !== '1') {
                enhanceDoorSelectWithDivDropdown(shlSelectOnly);
            }
            bindLandingHardwareFinishMedia(card);
            return;
        }

        var finishLabel = card.querySelector('[data-finish-label]');
        var forms = all('form.millwork-form');

        function syncFunctionAttrs() {
            var fnSelect = card.querySelector('select.door-suggested-hardware-function, select[data-hw-function-select]');
            if (!fnSelect || fnSelect.selectedIndex < 0) return;
            var opt = fnSelect.options[fnSelect.selectedIndex];
            if (!opt) return;
            card.setAttribute('data-hw-function-value', String(opt.value || ''));
            card.setAttribute('data-hw-function-label', String(opt.textContent || '').trim());
        }

        function syncCloserColorAttrs() {
            var ccSelect = card.querySelector('select.door-suggested-hardware-closer-color, select[data-hw-closer-color-select]');
            if (!ccSelect || ccSelect.selectedIndex < 0) return;
            var opt = ccSelect.options[ccSelect.selectedIndex];
            if (!opt) return;
            card.setAttribute('data-hw-closer-color-value', String(opt.value || ''));
            card.setAttribute('data-hw-closer-color-label', String(opt.textContent || '').trim());
        }

        function syncThicknessAttrs() {
            var thickSelect = card.querySelector('select.door-suggested-hardware-thickness, select[data-hw-thickness-select]');
            if (!thickSelect || thickSelect.selectedIndex < 0) return;
            var opt = thickSelect.options[thickSelect.selectedIndex];
            if (!opt) return;
            card.setAttribute('data-hw-thickness-value', String(opt.value || ''));
            card.setAttribute('data-hw-thickness-label', String(opt.textContent || '').trim());
        }

        function syncSwingDirectionAttrs() {
            var sdSelect = findLandingHardwareSwingSelect(root, card)
                || card.querySelector('select.door-suggested-hardware-swing-direction, select[data-hw-swing-direction-select]');
            if (!sdSelect || sdSelect.selectedIndex < 0) return;
            var opt = sdSelect.options[sdSelect.selectedIndex];
            if (!opt) return;
            var sv = String(opt.value || '').trim();
            var sl = String(opt.textContent || '').trim();
            // Dp start 27-08 — do not keep Select placeholder on the card
            if (!sv && sl && !isUnselectedHardwareChoice(sl)) sv = sl;
            if (isUnselectedHardwareChoice(sv) && isUnselectedHardwareChoice(sl)) {
                card.setAttribute('data-hw-swing-direction-value', '');
                card.setAttribute('data-hw-swing-direction-label', '');
                return;
            }
            // Dp end 27-08
            card.setAttribute('data-hw-swing-direction-value', sv);
            card.setAttribute('data-hw-swing-direction-label', sl || sv);
        }

        function syncBacksetAttrs() {
            var bsSelect = card.querySelector('select.door-suggested-hardware-backset, select[data-hw-backset-select]');
            if (!bsSelect || bsSelect.selectedIndex < 0) return;
            var opt = bsSelect.options[bsSelect.selectedIndex];
            if (!opt) return;
            card.setAttribute('data-hw-backset-value', String(opt.value || ''));
            card.setAttribute('data-hw-backset-label', String(opt.textContent || '').trim());
        }

        function syncTrackLengthAttrs() {
            var tlSelect = card.querySelector('select.door-suggested-hardware-track-length, select[data-hw-track-length-select]');
            if (!tlSelect || tlSelect.selectedIndex < 0) return;
            var opt = tlSelect.options[tlSelect.selectedIndex];
            if (!opt) return;
            card.setAttribute('data-hw-track-length-value', String(opt.value || ''));
            card.setAttribute('data-hw-track-length-label', String(opt.textContent || '').trim());
        }

        function syncConnectedDoorsAttrs() {
            var cdSelect = card.querySelector('select.door-suggested-hardware-connected-doors, select[data-hw-connected-doors-select]');
            if (!cdSelect || cdSelect.selectedIndex < 0) return;
            var opt = cdSelect.options[cdSelect.selectedIndex];
            if (!opt) return;
            card.setAttribute('data-hw-connected-doors-value', String(opt.value || ''));
            card.setAttribute('data-hw-connected-doors-label', String(opt.textContent || '').trim());
        }

        function syncUpperTrackLengthAttrs() {
            var utlSelect = card.querySelector('select.door-suggested-hardware-upper-track-length, select[data-hw-upper-track-length-select]');
            if (!utlSelect || utlSelect.selectedIndex < 0) return;
            var opt = utlSelect.options[utlSelect.selectedIndex];
            if (!opt) return;
            card.setAttribute('data-hw-upper-track-length-value', String(opt.value || ''));
            card.setAttribute('data-hw-upper-track-length-label', String(opt.textContent || '').trim());
        }

        function syncMaxDoorSizeAttrs() {
            var mdsSelect = card.querySelector('select.door-suggested-hardware-max-door-size, select[data-hw-max-door-size-select]');
            if (!mdsSelect || mdsSelect.selectedIndex < 0) return;
            var opt = mdsSelect.options[mdsSelect.selectedIndex];
            if (!opt) return;
            card.setAttribute('data-hw-max-door-size-value', String(opt.value || ''));
            card.setAttribute('data-hw-max-door-size-label', String(opt.textContent || '').trim());
        }

        function syncCarriagePackTypeAttrs() {
            var cptSelect = card.querySelector('select.door-suggested-hardware-carriage-pack-type, select[data-hw-carriage-pack-type-select]');
            if (!cptSelect || cptSelect.selectedIndex < 0) return;
            var opt = cptSelect.options[cptSelect.selectedIndex];
            if (!opt) return;
            card.setAttribute('data-hw-carriage-pack-type-value', String(opt.value || ''));
            card.setAttribute('data-hw-carriage-pack-type-label', String(opt.textContent || '').trim());
        }

        function syncStrapHingeLengthAttrs() {
            var shlSelect = card.querySelector('select.door-suggested-hardware-strap-hinge-length, select[data-hw-strap-hinge-length-select]');
            if (!shlSelect || shlSelect.selectedIndex < 0) return;
            var opt = shlSelect.options[shlSelect.selectedIndex];
            if (!opt) return;
            card.setAttribute('data-hw-strap-hinge-length-value', String(opt.value || ''));
            card.setAttribute('data-hw-strap-hinge-length-label', String(opt.textContent || '').trim());
        }

        function syncCartProperties() {
            var finishVal = String(card.getAttribute('data-hw-finish-value') || '');
            var finishLbl = String(card.getAttribute('data-hw-finish-label') || '');
            syncFunctionAttrs();
            syncCloserColorAttrs();
            syncThicknessAttrs();
            syncSwingDirectionAttrs();
            syncBacksetAttrs();
            syncTrackLengthAttrs();
            syncConnectedDoorsAttrs();
            syncUpperTrackLengthAttrs();
            syncMaxDoorSizeAttrs();
            syncCarriagePackTypeAttrs();
            syncStrapHingeLengthAttrs();
            var functionVal = String(card.getAttribute('data-hw-function-value') || '');
            var functionLbl = String(card.getAttribute('data-hw-function-label') || '');
            var closerColorVal = String(card.getAttribute('data-hw-closer-color-value') || '');
            var closerColorLbl = String(card.getAttribute('data-hw-closer-color-label') || '');
            var thicknessVal = String(card.getAttribute('data-hw-thickness-value') || '');
            var thicknessLbl = String(card.getAttribute('data-hw-thickness-label') || '');
            var swingDirectionVal = String(card.getAttribute('data-hw-swing-direction-value') || '');
            var swingDirectionLbl = String(card.getAttribute('data-hw-swing-direction-label') || '');
            var backsetVal = String(card.getAttribute('data-hw-backset-value') || '');
            var backsetLbl = String(card.getAttribute('data-hw-backset-label') || '');
            var trackLengthVal = String(card.getAttribute('data-hw-track-length-value') || '');
            var trackLengthLbl = String(card.getAttribute('data-hw-track-length-label') || '');
            var connectedDoorsVal = String(card.getAttribute('data-hw-connected-doors-value') || '');
            var connectedDoorsLbl = String(card.getAttribute('data-hw-connected-doors-label') || '');
            var upperTrackLengthVal = String(card.getAttribute('data-hw-upper-track-length-value') || '');
            var upperTrackLengthLbl = String(card.getAttribute('data-hw-upper-track-length-label') || '');
            var maxDoorSizeVal = String(card.getAttribute('data-hw-max-door-size-value') || '');
            var maxDoorSizeLbl = String(card.getAttribute('data-hw-max-door-size-label') || '');
            var carriagePackTypeVal = String(card.getAttribute('data-hw-carriage-pack-type-value') || '');
            var carriagePackTypeLbl = String(card.getAttribute('data-hw-carriage-pack-type-label') || '');
            var strapHingeLengthVal = String(card.getAttribute('data-hw-strap-hinge-length-value') || '');
            var strapHingeLengthLbl = String(card.getAttribute('data-hw-strap-hinge-length-label') || '');

            forms.forEach(function (form) {
                if (finishLbl || finishVal) ensurePropertyInput(form, 'Finish', finishLbl || finishVal);
                if (functionLbl || functionVal) ensurePropertyInput(form, 'Hardware Function', functionLbl || functionVal);
                if (closerColorLbl || closerColorVal) ensurePropertyInput(form, 'Closer Color', closerColorLbl || closerColorVal);
                if (thicknessLbl || thicknessVal) ensurePropertyInput(form, 'Hardware Door Thickness', thicknessLbl || thicknessVal);
                // Dp start 27-08 — storefront + admin use Hardware Swing Direction
                if (swingDirectionLbl || swingDirectionVal) {
                    if (!isUnselectedHardwareChoice(swingDirectionLbl) && !isUnselectedHardwareChoice(swingDirectionVal)) {
                        ensurePropertyInput(form, 'Hardware Swing Direction', swingDirectionLbl || swingDirectionVal);
                        ensurePropertyInput(form, 'Swing Direction', swingDirectionLbl || swingDirectionVal);
                    }
                }
                // Dp end 27-08
                if (backsetLbl || backsetVal) ensurePropertyInput(form, 'Hardware Backset', backsetLbl || backsetVal);
                if (trackLengthLbl || trackLengthVal) ensurePropertyInput(form, 'Track Length', trackLengthLbl || trackLengthVal);
                if (connectedDoorsLbl || connectedDoorsVal) ensurePropertyInput(form, 'Number of Connected Doors', connectedDoorsLbl || connectedDoorsVal);
                if (upperTrackLengthLbl || upperTrackLengthVal) ensurePropertyInput(form, 'Upper Track Length', upperTrackLengthLbl || upperTrackLengthVal);
                if (maxDoorSizeLbl || maxDoorSizeVal) ensurePropertyInput(form, 'Max Door Size', maxDoorSizeLbl || maxDoorSizeVal);
                if (carriagePackTypeLbl || carriagePackTypeVal) ensurePropertyInput(form, 'Carriage Pack Type', carriagePackTypeLbl || carriagePackTypeVal);
                if (strapHingeLengthLbl || strapHingeLengthVal) ensurePropertyInput(form, 'Strap Hinge Length', strapHingeLengthLbl || strapHingeLengthVal);
            });
        }

        var firstFinish = window.__landingHardwareFirstFinish || '';
        var firstFinishLabel = window.__landingHardwareFirstFinishLabel || '';
        var selectedSwatch = card.querySelector('.door-suggested-hardware-swatch--selected')
            || card.querySelector('.door-suggested-hardware-swatch');
        if (selectedSwatch) {
            var fv = selectedSwatch.getAttribute('data-finish-value') || firstFinish || '';
            var fl = selectedSwatch.getAttribute('data-finish-label') || selectedSwatch.getAttribute('title') || selectedSwatch.getAttribute('aria-label') || firstFinishLabel || fv;
            if (finishLabel) finishLabel.textContent = fl;
            card.setAttribute('data-hw-finish-value', fv);
            card.setAttribute('data-hw-finish-label', fl);
            if (!selectedSwatch.classList.contains('door-suggested-hardware-swatch--selected')) {
                selectedSwatch.classList.add('door-suggested-hardware-swatch--selected');
            }
            callLandingHardwareFinishImageUpdate(selectedSwatch);
        } else if (firstFinish && finishLabel) {
            finishLabel.textContent = firstFinishLabel || firstFinish;
            card.setAttribute('data-hw-finish-value', firstFinish);
            card.setAttribute('data-hw-finish-label', firstFinishLabel || firstFinish);
        }

        card.querySelectorAll('.door-suggested-hardware-swatch').forEach(function (sw) {
            if (sw.getAttribute('data-hw-swatch-bound') === '1') return;
            sw.setAttribute('data-hw-swatch-bound', '1');
            sw.addEventListener('click', function () {
                card.querySelectorAll('.door-suggested-hardware-swatch').forEach(function (s) {
                    s.classList.remove('door-suggested-hardware-swatch--selected');
                });
                sw.classList.add('door-suggested-hardware-swatch--selected');
                var fv = sw.getAttribute('data-finish-value') || '';
                var fl = sw.getAttribute('data-finish-label') || sw.getAttribute('title') || sw.getAttribute('aria-label') || fv;
                if (finishLabel) finishLabel.textContent = fl;
                card.setAttribute('data-hw-finish-value', fv);
                card.setAttribute('data-hw-finish-label', fl);
                callLandingHardwareFinishImageUpdate(sw);
                syncCartProperties();
            });
        });

        var fnSelect = card.querySelector('select.door-suggested-hardware-function, select[data-hw-function-select]');
        if (fnSelect) {
            if (window.__landingHardwareFirstFunction) {
                fnSelect.value = String(window.__landingHardwareFirstFunction);
            }
            fnSelect.addEventListener('change', function () {
                syncFunctionAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(fnSelect);
            syncFunctionAttrs();
        }

        var ccSelect = card.querySelector('select.door-suggested-hardware-closer-color, select[data-hw-closer-color-select]');
        if (ccSelect) {
            // Dp start 17-08 — hide Silver closer color only for HC-100
            hideCloserSilverOptionForSpecificSku(ccSelect, card);
            // Dp end 17-08
            if (window.__landingHardwareFirstCloserColor) {
                ccSelect.value = String(window.__landingHardwareFirstCloserColor);
            }
            ccSelect.addEventListener('change', function () {
                syncCloserColorAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(ccSelect);
            syncCloserColorAttrs();
        }

        var thickSelect = card.querySelector('select.door-suggested-hardware-thickness, select[data-hw-thickness-select]');
        if (thickSelect) {
            if (window.__landingHardwareFirstThickness) {
                thickSelect.value = String(window.__landingHardwareFirstThickness);
            }
            thickSelect.addEventListener('change', function () {
                syncThicknessAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(thickSelect);
            syncThicknessAttrs();
        }

        var sdSelect = findLandingHardwareSwingSelect(root, card)
            || card.querySelector('select.door-suggested-hardware-swing-direction, select[data-hw-swing-direction-select]');
        if (sdSelect) {
            if (window.__landingHardwareFirstSwingDirection) {
                sdSelect.value = String(window.__landingHardwareFirstSwingDirection);
            }
            sdSelect.addEventListener('change', function () {
                syncSwingDirectionAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(sdSelect);
            syncSwingDirectionAttrs();
        }

        var bsSelect = card.querySelector('select.door-suggested-hardware-backset, select[data-hw-backset-select]');
        if (bsSelect) {
            // --- Dp start 15-07 ---
            filterBacksetSelectElement(bsSelect, card);
            // --- Dp end 15-07 ---
            if (window.__landingHardwareFirstBackset) {
                bsSelect.value = String(window.__landingHardwareFirstBackset);
            }
            bsSelect.addEventListener('change', function () {
                syncBacksetAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(bsSelect);
            syncBacksetAttrs();
        }

        var tlSelect = card.querySelector('select.door-suggested-hardware-track-length, select[data-hw-track-length-select]');
        if (tlSelect) {
            if (window.__landingHardwareFirstTrackLength) {
                tlSelect.value = String(window.__landingHardwareFirstTrackLength);
            }
            tlSelect.addEventListener('change', function () {
                syncTrackLengthAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(tlSelect);
            syncTrackLengthAttrs();
        }

        var cdSelect = card.querySelector('select.door-suggested-hardware-connected-doors, select[data-hw-connected-doors-select]');
        if (cdSelect) {
            if (window.__landingHardwareFirstConnectedDoors) {
                cdSelect.value = String(window.__landingHardwareFirstConnectedDoors);
            }
            cdSelect.addEventListener('change', function () {
                syncConnectedDoorsAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(cdSelect);
            syncConnectedDoorsAttrs();
        }

        var utlSelect = card.querySelector('select.door-suggested-hardware-upper-track-length, select[data-hw-upper-track-length-select]');
        if (utlSelect) {
            if (window.__landingHardwareFirstUpperTrackLength) {
                utlSelect.value = String(window.__landingHardwareFirstUpperTrackLength);
            }
            utlSelect.addEventListener('change', function () {
                syncUpperTrackLengthAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(utlSelect);
            syncUpperTrackLengthAttrs();
        }

        var mdsSelect = card.querySelector('select.door-suggested-hardware-max-door-size, select[data-hw-max-door-size-select]');
        if (mdsSelect) {
            if (window.__landingHardwareFirstMaxDoorSize) {
                mdsSelect.value = String(window.__landingHardwareFirstMaxDoorSize);
            }
            mdsSelect.addEventListener('change', function () {
                syncMaxDoorSizeAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(mdsSelect);
            syncMaxDoorSizeAttrs();
        }

        var cptSelect = card.querySelector('select.door-suggested-hardware-carriage-pack-type, select[data-hw-carriage-pack-type-select]');
        if (cptSelect) {
            if (window.__landingHardwareFirstCarriagePackType) {
                cptSelect.value = String(window.__landingHardwareFirstCarriagePackType);
            }
            cptSelect.addEventListener('change', function () {
                syncCarriagePackTypeAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(cptSelect);
            syncCarriagePackTypeAttrs();
        }

        var shlSelect = card.querySelector('select.door-suggested-hardware-strap-hinge-length, select[data-hw-strap-hinge-length-select]');
        if (shlSelect) {
            if (window.__landingHardwareFirstStrapHingeLength) {
                shlSelect.value = String(window.__landingHardwareFirstStrapHingeLength);
            }
            shlSelect.addEventListener('change', function () {
                syncStrapHingeLengthAttrs();
                syncCartProperties();
            });
            enhanceDoorSelectWithDivDropdown(shlSelect);
            syncStrapHingeLengthAttrs();
        }

        forms.forEach(function (form) {
            form.addEventListener('submit', syncCartProperties);
        });

        syncCartProperties();
    }

    function bootMillworkLengthConfig() {
        var lengthRoots = document.querySelectorAll('[data-millwork-length-config="1"], [data-millwork-baluster-length-config="1"], [data-millwork-custom-length-config="1"]');
        if (!lengthRoots.length) return;
        lengthRoots.forEach(function (root) {
            var selects = root.querySelectorAll('[data-millwork-length-select], [data-millwork-baluster-length-select], [data-millwork-custom-length-select], [data-millwork-custom-thickness-select]');
            selects.forEach(function (lengthSelect) {
                if (lengthSelect && lengthSelect.getAttribute('data-door-div-select') !== '1') {
                    enhanceDoorSelectWithDivDropdown(lengthSelect);
                }
            });
        });
    }

    function bootLandingHardwareConfig() {
        var root = document.querySelector('[data-landing-hardware-config="1"]');
        if (!root) return;
        var card = root.querySelector('.door-suggested-hardware-card');
        /* MERGE: hardware_pocket_door_kit max_door_size filter — start */
        try { hydrateLandingMaxDoorSizeAllowAttrs(root, card); } catch (eHydrateBoot) { }
        /* MERGE: hardware_pocket_door_kit max_door_size filter — end */
        if (card) bindLandingHardwareCard(card);

        var fnSelect = root.querySelector('select.door-suggested-hardware-function, select[data-hw-function-select]');
        if (fnSelect && fnSelect.getAttribute('data-door-div-select') !== '1') {
            enhanceDoorSelectWithDivDropdown(fnSelect);
        }

        var ccSelect = root.querySelector('select.door-suggested-hardware-closer-color, select[data-hw-closer-color-select]');
        if (ccSelect && ccSelect.getAttribute('data-door-div-select') !== '1') {
            // Dp start 17-08
            hideCloserSilverOptionForSpecificSku(ccSelect, card);
            // Dp end 17-08
            enhanceDoorSelectWithDivDropdown(ccSelect);
        }

        var thickSelect = root.querySelector('select.door-suggested-hardware-thickness, select[data-hw-thickness-select]');
        if (thickSelect && thickSelect.getAttribute('data-door-div-select') !== '1') {
            enhanceDoorSelectWithDivDropdown(thickSelect);
        }

        var sdSelect = findLandingHardwareSwingSelect(root, card)
            || root.querySelector('select.door-suggested-hardware-swing-direction, select[data-hw-swing-direction-select]');
        if (sdSelect && sdSelect.getAttribute('data-door-div-select') !== '1') {
            enhanceDoorSelectWithDivDropdown(sdSelect);
        }

        var bsSelect = root.querySelector('select.door-suggested-hardware-backset, select[data-hw-backset-select]');
        if (bsSelect) {
            // --- Dp start 15-07 ---
            filterBacksetSelectElement(bsSelect, card);
            // --- Dp end 15-07 ---
            if (bsSelect.getAttribute('data-door-div-select') !== '1') {
                enhanceDoorSelectWithDivDropdown(bsSelect);
            }
            // Ensure card attrs match filtered/selected Door Backset after boot
            if (card && bsSelect.selectedIndex >= 0) {
                var bsOpt = bsSelect.options[bsSelect.selectedIndex];
                if (bsOpt) {
                    var bsVal = String(bsOpt.value || '').trim();
                    var bsLbl = String(bsOpt.textContent || '').trim();
                    if (!isUnselectedHardwareChoice(bsVal) || !isUnselectedHardwareChoice(bsLbl)) {
                        card.setAttribute('data-hw-backset-value', bsVal || bsLbl);
                        card.setAttribute('data-hw-backset-label', bsLbl || bsVal);
                    }
                }
            }
        }

        var tlSelect = root.querySelector('select.door-suggested-hardware-track-length, select[data-hw-track-length-select]');
        if (tlSelect && tlSelect.getAttribute('data-door-div-select') !== '1') {
            enhanceDoorSelectWithDivDropdown(tlSelect);
        }

        var cdSelect = root.querySelector('select.door-suggested-hardware-connected-doors, select[data-hw-connected-doors-select]');
        if (cdSelect && cdSelect.getAttribute('data-door-div-select') !== '1') {
            enhanceDoorSelectWithDivDropdown(cdSelect);
        }

        var utlSelect = root.querySelector('select.door-suggested-hardware-upper-track-length, select[data-hw-upper-track-length-select]');
        if (utlSelect && utlSelect.getAttribute('data-door-div-select') !== '1') {
            enhanceDoorSelectWithDivDropdown(utlSelect);
        }

        var mdsSelect = root.querySelector('select.door-suggested-hardware-max-door-size, select[data-hw-max-door-size-select]');
        if (mdsSelect) {
            if (mdsSelect.getAttribute('data-door-div-select') !== '1') {
                enhanceDoorSelectWithDivDropdown(mdsSelect);
            }
        }

        var cptSelect = root.querySelector('select.door-suggested-hardware-carriage-pack-type, select[data-hw-carriage-pack-type-select]');
        if (cptSelect && cptSelect.getAttribute('data-door-div-select') !== '1') {
            enhanceDoorSelectWithDivDropdown(cptSelect);
        }

        var shlSelect = root.querySelector('select.door-suggested-hardware-strap-hinge-length, select[data-hw-strap-hinge-length-select]');
        if (shlSelect && shlSelect.getAttribute('data-door-div-select') !== '1') {
            enhanceDoorSelectWithDivDropdown(shlSelect);
        }
    }

    window.__landingHardwareEnhanceSelect = enhanceDoorSelectWithDivDropdown;
    window.__bootLandingHardwareConfig = bootLandingHardwareConfig;
    // --- Dp start 15-07 ---
    window.__filterLandingHardwareBacksetSelect = filterBacksetSelectElement;
    // --- Dp end 15-07 ---
    window.__bootMillworkLengthConfig = bootMillworkLengthConfig;
    window.__enhanceAllDoorConfiguratorSelects = enhanceAllDoorConfiguratorSelects;

    var DOOR_SEAL_KIT_MATCHING_VALUE = 'matching_wood_stops_and_seals';
    /** Must match door_sweep schema option value for the matching-wood sweep choice. */
    var DOOR_SWEEP_MATCHING_VALUE = 'matching_wood_door_sweep';
    var PRIMING_VALUE_PRICE_FIELD = {
        primed_white: 'white',
        primed_grey: 'grey',
        primed_gray: 'grey'
    };
    var doorSealKitCatalogCache = null;
    var doorSweepsCatalogCache = null;
    var primingServicesCatalogCache = null;
    var millworkPricingRecordsCache = null;
    var millworkWoodCatalogCache = null;
    var appliedMoldingPricingMapCache = null;
    var millworkPricingRecordsParseError = null;

    function normWoodTypeSlug(s) {
        return String(s == null ? '' : s).toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_').trim();
    }

    function normPrimingValueKey(s) {
        return String(s == null ? '' : s).trim().toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_');
    }

    function normCollectionSlug(s) {
        return String(s == null ? '' : s)
            .trim()
            .toLowerCase()
            .replace(/[\s_]+/g, '-')
            .replace(/-+/g, '-');
    }

    function readDoorSealKitCatalog() {
        if (doorSealKitCatalogCache) return doorSealKitCatalogCache;
        doorSealKitCatalogCache = readJsonScriptArray('door-seal-kit-catalog-json');
        return doorSealKitCatalogCache;
    }

    function readDoorSweepsCatalog() {
        if (doorSweepsCatalogCache) return doorSweepsCatalogCache;
        doorSweepsCatalogCache = readJsonScriptArray('door-sweeps-catalog-json');
        return doorSweepsCatalogCache;
    }

    function readPrimingServicesCatalog() {
        if (primingServicesCatalogCache) return primingServicesCatalogCache;
        primingServicesCatalogCache = readJsonScriptArray('door-priming-services-catalog-json');
        return primingServicesCatalogCache;
    }

    function readMillworkPricingRecords() {
        var el = document.getElementById('door-millwork-product-pricing-json');
        if (!el) {
            if (Array.isArray(window.millwork_pricing_records) && window.millwork_pricing_records.length) {
                return window.millwork_pricing_records;
            }
            return millworkPricingRecordsCache || [];
        }
        var raw = String(el.textContent || el.innerHTML || '').trim();
        if (!raw || raw === '[]') {
            millworkPricingRecordsCache = [];
            return [];
        }
        try {
            var parsed = JSON.parse(raw);
            millworkPricingRecordsCache = Array.isArray(parsed) ? parsed : [];
            millworkPricingRecordsParseError = null;
        } catch (eParse) {
            millworkPricingRecordsCache = [];
            millworkPricingRecordsParseError = String(eParse && eParse.message ? eParse.message : eParse);
        }
        return millworkPricingRecordsCache;
    }

    function readAppliedMoldingPricingMap() {
        var el = document.getElementById('door-applied-molding-pricing-json');
        if (!el) return appliedMoldingPricingMapCache || {};
        var raw = String(el.textContent || el.innerHTML || '').trim();
        if (!raw || raw === '{}') {
            appliedMoldingPricingMapCache = {};
            return appliedMoldingPricingMapCache;
        }
        try {
            var parsed = JSON.parse(raw);
            appliedMoldingPricingMapCache = parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
        } catch (eMap) {
            appliedMoldingPricingMapCache = {};
        }
        return appliedMoldingPricingMapCache;
    }

    function readMillworkWoodCatalog() {
        if (millworkWoodCatalogCache) return millworkWoodCatalogCache;
        millworkWoodCatalogCache = readJsonScriptArray('door-millwork-wood-catalog-json');
        return millworkWoodCatalogCache;
    }

    function skuComparable(v) {
        return String(v == null ? '' : v).trim().toLowerCase();
    }

    function skuStrict(v) {
        return skuComparable(v).replace(/[^a-z0-9]/g, '');
    }

    /** sm1 -> sm-1 (Shopify metaobject handles often use sm-1-1 while choice value is sm1). */
    function guessMillworkHandleFromChoice(choice) {
        var c = skuComparable(choice);
        if (!c || c.length < 3) return '';
        var prefix = c.slice(0, 2);
        var suffix = c.slice(2);
        if (!suffix || !/^\d+$/.test(suffix)) return '';
        return prefix + '-' + suffix;
    }

    function millworkPricingRowMatchesChoice(choice, row) {
        if (!row || !choice) return false;
        var want = skuComparable(choice);
        var wantStrict = skuStrict(choice);
        if (!want) return false;
        var rowSku = skuComparable(row.sku);
        var rowHandle = skuComparable(row.handle);
        var rowDisplay = skuComparable(row.display_name);
        if (rowSku && rowSku === want) return true;
        if (rowHandle && rowHandle === want) return true;
        if (rowDisplay && rowDisplay === want) return true;
        if (rowSku && skuStrict(rowSku) === wantStrict) return true;
        if (rowHandle && skuStrict(rowHandle) === wantStrict) return true;
        if (rowDisplay && skuStrict(rowDisplay) === wantStrict) return true;
        var guess = guessMillworkHandleFromChoice(choice);
        if (!guess || !rowHandle) return false;
        if (rowHandle === guess) return true;
        if (rowHandle.length > guess.length && rowHandle.indexOf(guess) === 0 && rowHandle.charAt(guess.length) === '-') {
            return true;
        }
        return false;
    }

    function normProfileKey(v) {
        return String(v == null ? '' : v).trim().toLowerCase().replace(/[\s-]+/g, '_');
    }

    function isElementVisibleForPricing(el) {
        if (!el) return false;
        if (el.classList && el.classList.contains('door-hidden')) return false;
        if (el.getAttribute && el.getAttribute('hidden') != null) return false;
        if (el.style && el.style.display === 'none') return false;
        try {
            if (el.offsetParent !== null) return true;
            var r = el.getBoundingClientRect();
            return r.width > 0 && r.height > 0;
        } catch (eVis) {
            return true;
        }
    }

    /** Tier price applies when applied molding is selected via stile (merged) or legacy accordion. */
    function isAppliedMoldingPricingActive(config) {
        config = config || {};
        var stileVal = getOptionValueFromDom('stile_and_rail_profile');
        if (!stileVal && config.stile_and_rail_profile != null) {
            stileVal = String(config.stile_and_rail_profile).trim();
        }
        var stileNorm = normProfileKey(stileVal);
        // Merged into stile_and_rail_profile — no Applied Molding accordion needed.
        if (
            stileNorm === 'rm5_applied_molding'
            || stileNorm === 'rm5'
            || stileNorm === 'rm_5'
            || stileNorm === 'applied_molding_choice'
            || stileNorm === 'applied_molding'
            || (stileNorm.indexOf('applied_molding') !== -1)
        ) {
            return true;
        }

        var moldingVal = getRawAppliedMoldingValue(config);
        if (!moldingVal) return false;
        var root = document.getElementById('door-configurator-options') || document;
        var wraps = root.querySelectorAll(
            '.door-option-wrap[data-option-id="applied_molding"], .door-option-wrap[data-option-id="applied_molding_choice"]'
        );
        if (wraps.length) {
            var anyWrapVisible = false;
            for (var wi = 0; wi < wraps.length; wi++) {
                if (isElementVisibleForPricing(wraps[wi])) {
                    anyWrapVisible = true;
                    break;
                }
            }
            if (!anyWrapVisible) return false;
        }
        var checked = root.querySelector(
            'input[type="radio"][data-option-id="applied_molding"]:checked,' +
            'input[type="radio"][data-option-id="applied_molding_choice"]:checked'
        );
        if (checked) {
            var card = checked.closest ? checked.closest('.common-check-option') : null;
            if (card && !isElementVisibleForPricing(card)) return false;
            var wrap = checked.closest ? checked.closest('.door-option-wrap[data-option-id]') : null;
            if (wrap && !isElementVisibleForPricing(wrap)) return false;
        }
        return true;
    }

    /** @deprecated alias — use isAppliedMoldingPricingActive */
    function isAppliedMoldingStileActive(config) {
        return isAppliedMoldingPricingActive(config);
    }

    function getRawAppliedMoldingValue(config) {
        config = config || {};
        var fromDom = getOptionValueFromDom('applied_molding') || getOptionValueFromDom('applied_molding_choice');
        if (fromDom) return fromDom;
        var val = config.applied_molding != null ? String(config.applied_molding).trim() : '';
        if (!val && config.applied_molding_choice != null) {
            val = String(config.applied_molding_choice).trim();
        }
        if (val) return val;

        // Merged into stile_and_rail_profile (e.g. rm5_applied_molding).
        var stileVal = getOptionValueFromDom('stile_and_rail_profile');
        if (!stileVal && config.stile_and_rail_profile != null) {
            stileVal = String(config.stile_and_rail_profile).trim();
        }
        var stileNorm = normProfileKey(stileVal);
        if (!stileNorm) return '';
        if (stileNorm === 'rm5_applied_molding' || stileNorm === 'rm5' || stileNorm === 'rm_5') {
            return 'rm5_applied_molding';
        }
        if (
            stileNorm === 'applied_molding_choice'
            || stileNorm === 'applied_molding'
            || stileNorm.indexOf('applied_molding') !== -1
        ) {
            return stileNorm;
        }
        return '';
    }

    function parseWoodPricesByTier(row) {
        if (!row) return {};
        var map = row.wood_prices_by_tier;
        if (typeof map === 'string') {
            try { map = JSON.parse(map); } catch (eMap) { map = {}; }
        }
        if (map && map.wood_prices_by_tier) map = map.wood_prices_by_tier;
        return map && typeof map === 'object' ? map : {};
    }

    function isAppliedMoldingOptionId(id) {
        var n = String(id || '').toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_');
        return n === 'applied_molding' || n === 'applied_molding_choice';
    }

    function isStileOrAppliedMoldingOptionId(id) {
        var n = String(id || '').toLowerCase().replace(/-/g, '_').replace(/\s+/g, '_');
        return n === 'stile_and_rail_profile' || isAppliedMoldingOptionId(id);
    }

    function readDoorConfigSchemaArray() {
        try {
            if (Array.isArray(window.__doorConfigSchema)) return window.__doorConfigSchema;
            var el = document.getElementById('door-configurator-schema');
            if (!el) return [];
            var parsed = JSON.parse(String(el.textContent || el.innerHTML || '[]').trim());
            return Array.isArray(parsed) ? parsed : [];
        } catch (eSchema) {
            return [];
        }
    }

    function findMillworkPricingRowFromSchema(sku) {
        var want = skuComparable(sku);
        var wantStrict = skuStrict(sku);
        if (!want && !wantStrict) return null;
        var schema = readDoorConfigSchemaArray();
        for (var i = 0; i < schema.length; i++) {
            var opt = schema[i];
            // Applied molding pricing may live on stile_and_rail_profile after the merge.
            if (!opt || !isStileOrAppliedMoldingOptionId(opt.id)) continue;
            var choices = Array.isArray(opt.options) ? opt.options : [];
            for (var j = 0; j < choices.length; j++) {
                var ch = choices[j] || {};
                var chVal = skuComparable(ch.value);
                var chNorm = normProfileKey(ch.value);
                var wantNorm = normProfileKey(sku);
                var valueMatch = chVal === want
                    || skuStrict(ch.value) === wantStrict
                    || chNorm === wantNorm
                    || (wantNorm === 'rm5_applied_molding' && (chNorm === 'rm5' || chNorm === 'rm_5' || chNorm === 'applied_molding_choice'));
                if (!valueMatch) continue;
                var tierMap = ch.wood_prices_by_tier;
                if (!tierMap || typeof tierMap !== 'object') continue;
                return {
                    sku: ch.value,
                    handle: ch.value,
                    display_name: ch.label || ch.title || ch.value,
                    wood_prices_by_tier: tierMap
                };
            }
        }
        return null;
    }

    function findMillworkPricingRowBySku(sku) {
        var want = skuComparable(sku);
        var wantStrict = skuStrict(sku);
        if (!want && !wantStrict) return null;

        var fromSchema = findMillworkPricingRowFromSchema(sku);
        if (fromSchema) {
            fromSchema._lookupSource = 'door_config_schema';
            return fromSchema;
        }

        var amMap = readAppliedMoldingPricingMap();
        if (amMap[want]) {
            amMap[want]._lookupSource = 'applied_molding_map';
            return amMap[want];
        }
        if (wantStrict && amMap[wantStrict]) {
            amMap[wantStrict]._lookupSource = 'applied_molding_map';
            return amMap[wantStrict];
        }
        var amKeys = Object.keys(amMap);
        for (var am = 0; am < amKeys.length; am++) {
            var amKey = amKeys[am];
            var amRow = amMap[amKey];
            if (!amRow) continue;
            if (millworkPricingRowMatchesChoice(sku, amRow) || skuComparable(amKey) === want || skuStrict(amKey) === wantStrict) {
                amRow._lookupSource = 'applied_molding_map';
                return amRow;
            }
        }

        var records = readMillworkPricingRecords();
        for (var i = 0; i < records.length; i++) {
            var row = records[i] || {};
            if (millworkPricingRowMatchesChoice(sku, row)) {
                row._lookupSource = 'pricing_catalog';
                return row;
            }
        }
        return null;
    }

    function getSelectedWoodTypeValue(config) {
        config = config || {};
        if (config.millwork_wood != null && String(config.millwork_wood).trim()) {
            return String(config.millwork_wood).trim();
        }
        if (config.wood_type != null && String(config.wood_type).trim()) {
            return String(config.wood_type).trim();
        }
        return getOptionValueFromDom('wood_type');
    }

    function getSelectedAppliedMoldingValue(config) {
        if (!isAppliedMoldingPricingActive(config)) return '';
        return getRawAppliedMoldingValue(config);
    }

    function resolveWoodTierId(woodTypeRaw) {
        var slug = normWoodTypeSlug(woodTypeRaw);
        if (!slug) return '';
        var catalog = readMillworkWoodCatalog();
        for (var i = 0; i < catalog.length; i++) {
            var entry = catalog[i] || {};
            var speciesKey = normWoodTypeSlug(entry.species_key);
            var displayName = normWoodTypeSlug(entry.display_name);
            if ((speciesKey && speciesKey === slug) || (displayName && displayName === slug)) {
                return String(entry.tier_id || '').trim();
            }
        }
        return '';
    }

    function getAppliedMoldingTierAddonPrice(config) {
        var woodType = getSelectedWoodTypeValue(config);
        var moldingSku = getSelectedAppliedMoldingValue(config);
        if (!moldingSku) {
            return { addon: 0, woodType: woodType, tierId: '', moldingSku: '', rowFound: false, tierPrice: 0 };
        }
        if (!woodType) {
            return { addon: 0, woodType: '', tierId: '', moldingSku: moldingSku, rowFound: false, tierPrice: 0 };
        }
        var tierId = resolveWoodTierId(woodType);
        if (!tierId) {
            return { addon: 0, woodType: woodType, tierId: '', moldingSku: moldingSku, rowFound: false, tierPrice: 0 };
        }
        var row = findMillworkPricingRowBySku(moldingSku);
        if (!row) {
            return {
                addon: 0,
                woodType: woodType,
                tierId: tierId,
                moldingSku: moldingSku,
                rowFound: false,
                tierPrice: 0,
                pricingRecordsCount: readMillworkPricingRecords().length,
                appliedMoldingMapKeys: Object.keys(readAppliedMoldingPricingMap()),
                pricingParseError: millworkPricingRecordsParseError
            };
        }
        var tierMap = parseWoodPricesByTier(row);
        var price = parseFloat(tierMap[tierId]);
        var addon = isNaN(price) ? 0 : price;
        return {
            addon: addon,
            woodType: woodType,
            tierId: tierId,
            moldingSku: moldingSku,
            rowFound: true,
            tierPrice: addon,
            tierMap: tierMap,
            matchedSku: row.sku || row.handle || moldingSku,
            pricingRecordsCount: readMillworkPricingRecords().length,
            appliedMoldingMapKeys: Object.keys(readAppliedMoldingPricingMap()),
            lookupSource: row._lookupSource || 'unknown'
        };
    }

    function syncAppliedMoldingTierAddonPrice(config) {
        var result = getAppliedMoldingTierAddonPrice(config);
        var addon = result && typeof result.addon === 'number' ? result.addon : 0;
        window.__doorAddon_applied_molding_tier = addon;
        return addon;
    }

    /* MERGE: seo_pdp_url — start (getCollectionHandleFromUrl: path + ?config= + data-route-collection) */
    /* MERGE: pdp_config_id — skip numeric ?config= (collection.config_id); use PDP_ROUTE_COLLECTION */
    function getCollectionHandleFromUrl() {
        try {
            var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
            if (match) return normCollectionSlug(decodeURIComponent(match[1]));
        } catch (ePath) { }
        try {
            var params = new URLSearchParams(window.location.search || '');
            var fromQuery = params.get('config') || params.get('collection') || params.get('col');
            if (fromQuery && !/^\d+$/.test(String(fromQuery))) {
                return normCollectionSlug(fromQuery);
            }
        } catch (eQuery) { }
        try {
            if (window.PDP_ROUTE_COLLECTION) return normCollectionSlug(window.PDP_ROUTE_COLLECTION);
            var main = document.getElementById('door-configurator')
                || document.getElementById('landing-product-configurator');
            if (main) {
                var route = main.getAttribute('data-route-collection') || '';
                if (route) return normCollectionSlug(route);
            }
        } catch (eRoute) { }
        return '';
    }
    /* MERGE: seo_pdp_url — end */

    function getOptionValueFromDom(optionId) {
        var root = document.getElementById('door-configurator-options') || document;
        var checked = root.querySelector('input[type="radio"][data-option-id="' + optionId + '"]:checked');
        if (checked && checked.value) return String(checked.value).trim();
        var sel = root.querySelector('select[data-option-id="' + optionId + '"]');
        if (sel && sel.value) return String(sel.value).trim();
        return '';
    }

    function getSelectedWoodTypeStormPorchValue(config) {
        config = config || {};
        if (config.wood_type_storm_porch != null && String(config.wood_type_storm_porch).trim()) {
            return String(config.wood_type_storm_porch).trim();
        }
        return getOptionValueFromDom('wood_type_storm_porch');
    }

    function findDoorSealKitRowForWood(woodTypeRaw) {
        var woodSlug = normWoodTypeSlug(woodTypeRaw);
        if (!woodSlug) return null;
        var catalog = readDoorSealKitCatalog();
        for (var i = 0; i < catalog.length; i++) {
            var row = catalog[i];
            if (!row) continue;
            if (normWoodTypeSlug(row.wood_name) === woodSlug) return row;
        }
        return null;
    }

    function getDoorSealKitMatchingAddonPrice(config) {
        config = config || {};
        var sealVal = config.door_seal_kit != null ? String(config.door_seal_kit).trim() : '';
        if (!sealVal) sealVal = getOptionValueFromDom('door_seal_kit');
        if (sealVal !== DOOR_SEAL_KIT_MATCHING_VALUE) return 0;
        var match = findDoorSealKitRowForWood(getSelectedWoodTypeStormPorchValue(config));
        if (!match || match.price == null) return 0;
        var price = parseFloat(match.price);
        return isNaN(price) ? 0 : price;
    }

    function syncDoorSealKitMatchingAddonPrice(config) {
        var addon = getDoorSealKitMatchingAddonPrice(config);
        window.__doorAddon_door_seal_kit_matching = addon;
        return addon;
    }

    function findDoorSweepsRowForWood(woodTypeRaw) {
        var woodSlug = normWoodTypeSlug(woodTypeRaw);
        if (!woodSlug) return null;
        var catalog = readDoorSweepsCatalog();
        for (var si = 0; si < catalog.length; si++) {
            var row = catalog[si];
            if (!row) continue;
            if (normWoodTypeSlug(row.wood_name) === woodSlug) return row;
        }
        return null;
    }

    function getDoorSweepsMatchingAddonPrice(config) {
        config = config || {};
        var sweepVal = config.door_sweep != null ? String(config.door_sweep).trim() : '';
        if (!sweepVal) sweepVal = getOptionValueFromDom('door_sweep');
        if (normPrimingValueKey(sweepVal) !== normPrimingValueKey(DOOR_SWEEP_MATCHING_VALUE)) return 0;
        var match = findDoorSweepsRowForWood(getSelectedWoodTypeStormPorchValue(config));
        if (!match || match.price == null) return 0;
        var price = parseFloat(match.price);
        return isNaN(price) ? 0 : price;
    }

    function syncDoorSweepsMatchingAddonPrice(config) {
        var addon = getDoorSweepsMatchingAddonPrice(config);
        window.__doorAddon_door_sweeps_matching = addon;
        return addon;
    }

    function getSelectedPrimingValue(config) {
        config = config || {};
        if (config.priming != null && String(config.priming).trim()) return String(config.priming).trim();
        return getOptionValueFromDom('priming');
    }

    function findPrimingServicesRowByCollectionHandle(collectionHandle, catalog) {
        var slug = normCollectionSlug(collectionHandle);
        if (!slug) return null;
        catalog = catalog || readPrimingServicesCatalog();
        for (var pi = 0; pi < catalog.length; pi++) {
            var row = catalog[pi];
            if (!row) continue;
            var dn = normCollectionSlug(row.display_name || row.handle || '');
            if (dn === slug) return row;
        }
        return null;
    }

    function findPrimingServicesRowByPrehungDoorType(doorTypeKey, catalog) {
        var doorSlug = normPrimingValueKey(doorTypeKey);
        console.log("doorSlug", doorSlug);
        if (!doorSlug) return null;
        catalog = catalog || readPrimingServicesCatalog();
        for (var pj = 0; pj < catalog.length; pj++) {
            var row2 = catalog[pj];
            if (!row2) continue;
            if (row2.prehung != null && normPrimingValueKey(row2.prehung) === doorSlug) return row2;
            var dn2 = normCollectionSlug(row2.display_name || row2.handle || '');
            if (doorSlug === 'double_door' && dn2.indexOf('double') !== -1) return row2;
            if (doorSlug === 'single_door' && dn2.indexOf('single') !== -1) return row2;
        }
        return null;
    }

    function getSelectedDoorSetupTypeForPriming(config) {
        config = config || {};
        var keys = Object.keys(config);
        for (var ki = 0; ki < keys.length; ki++) {
            var val = config[keys[ki]];
            var list = Array.isArray(val) ? val : (val != null && val !== '' ? [val] : []);
            for (var li = 0; li < list.length; li++) {
                var norm = normPrimingValueKey(list[li]);
                if (norm === 'single_door' || norm === 'double_door') return norm;
            }
        }
        return '';
    }

    function getCurrentCollectionHandleForPrimingServices() {
        var fromUrl = getCollectionHandleFromUrl();
        if (fromUrl) return fromUrl;
        try {
            var main = document.getElementById('door-configurator');
            if (!main) return '';
            var routeCol = main.getAttribute('data-route-collection') || '';
            if (routeCol) return normCollectionSlug(routeCol);
            var handlesJson = main.getAttribute('data-product-collection-handles') || '[]';
            var handles = JSON.parse(handlesJson);
            if (!Array.isArray(handles) || !handles.length) return '';
            var catalog = readPrimingServicesCatalog();
            for (var hi = 0; hi < handles.length; hi++) {
                var h = normCollectionSlug(handles[hi]);
                if (findPrimingServicesRowByCollectionHandle(h, catalog)) return h;
            }
            return normCollectionSlug(handles[0]);
        } catch (eCol) { }
        return '';
    }

    function getPrimingServicesAddonPrice(config) {
        config = config || {};
        var primingVal = getSelectedPrimingValue(config);
        var priceField = PRIMING_VALUE_PRICE_FIELD[normPrimingValueKey(primingVal)];
        if (!priceField) return 0;
        var catalog = readPrimingServicesCatalog();
        var collectionHandle = getCurrentCollectionHandleForPrimingServices();
        var row = findPrimingServicesRowByCollectionHandle(collectionHandle, catalog);
        if (!row) {
            var doorType = getSelectedDoorSetupTypeForPriming(config);
            if (doorType) row = findPrimingServicesRowByPrehungDoorType(doorType, catalog);
        }
        if (!row || row[priceField] == null) return 0;
        var price = parseFloat(row[priceField]);
        return isNaN(price) ? 0 : price;
    }

    function syncPrimingServicesAddonPrice(config) {
        var addon = getPrimingServicesAddonPrice(config);
        window.__doorAddon_priming_services = addon;
        return addon;
    }

    function applyCatalogMetaobjectAddons(config) {
        var sealKit = 0;
        var doorSweeps = 0;
        var priming = 0;
        var appliedMolding = 0;
        try { sealKit = syncDoorSealKitMatchingAddonPrice(config); } catch (eSeal) {
            window.__doorAddon_door_seal_kit_matching = 0;
        }
        try { doorSweeps = syncDoorSweepsMatchingAddonPrice(config); } catch (eSweep) {
            window.__doorAddon_door_sweeps_matching = 0;
        }
        try { priming = syncPrimingServicesAddonPrice(config); } catch (ePrim) {
            window.__doorAddon_priming_services = 0;
        }
        try { appliedMolding = syncAppliedMoldingTierAddonPrice(config); } catch (eAm) {
            window.__doorAddon_applied_molding_tier = 0;
        }
        return {
            sealKit: sealKit,
            doorSweeps: doorSweeps,
            priming: priming,
            appliedMolding: appliedMolding,
            total: sealKit + doorSweeps + priming + appliedMolding
        };
    }

    function ensureDoorPriceBoxVisible() {
        if (window.__doorSelectionLogOnly) return;
        try {
            var priceBox = document.querySelector('#door-configurator .door-price-box');
            if (priceBox) {
                priceBox.style.display = '';
                priceBox.removeAttribute('hidden');
            }
            var addBtn = document.getElementById('door-add-to-cart-btn');
            if (addBtn) addBtn.style.display = '';
        } catch (eBox) { }
    }

    // ---------------------------------------------------------------------------
    // HubSpot deal sync (moved from door-conf2.js)
    // ---------------------------------------------------------------------------
    var hubspotDeps = null;

    function hsNormVal(v) {
        return String(v == null ? '' : v).toLowerCase().replace(/-/g, '_').trim();
    }

    function hsAnyConfigValueEquals(config, target) {
        if (!config) return false;
        target = hsNormVal(target);
        return Object.keys(config).some(function (k) {
            if (!k || k.charAt(0) === '_') return false;
            var val = config[k];
            if (Array.isArray(val)) return val.some(function (x) { return hsNormVal(x) === target; });
            return hsNormVal(val) === target;
        });
    }

    var HS_MEASURE_RULES = [
        {
            setup: 'slab_only', measure: 'exact_door_size',
            ids: ['exact-door-width-int', 'exact-door-width-frac', 'door_height', 'door_height_fraction', 'exact-door-thickness-frac']
        },
        {
            setup: 'pre_hung_on_jamb', measure: 'exact_door_size',
            ids: ['exact-door-width-int', 'exact-door-width-frac', 'door_height', 'door_height_fraction', 'exact-door-thickness-frac', 'exact-pre-hung-frac']
        }
    ];

    function hsMeasureSelect(id) {
        var sel = document.getElementById(id);
        if (!sel || sel.tagName !== 'SELECT') return null;
        return sel;
    }

    function hsMeasureDisplay(sel) {
        if (!sel) return '';
        var op = sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
        if (op && String(op.value) !== '') return String(op.textContent || op.value || '').trim();
        return '';
    }

    function hsMeasureLabel(sel, id) {
        var row = sel && sel.closest ? sel.closest('.door-measure-dimension-row') : null;
        var t = row ? row.querySelector('.door-measure-dimension-title') : null;
        var title = t ? String(t.textContent || '').trim() : '';
        var isFrac = /frac/i.test(id);
        return title ? (title + (isFrac ? ' (fraction)' : '')) : id;
    }

    function buildHubspotExtraSummaryParts(config) {
        var parts = [];
        try {
            var bevel = document.querySelector('input[type="checkbox"][data-option-id="glass_bevel"]');
            if (bevel) parts.push('Beveled Glass: ' + (bevel.checked ? 'Add Beveled Glass' : 'No Beveled Glass'));
        } catch (eB) { }
        try {
            var getHw = hubspotDeps && hubspotDeps.getHardwareSelectionsForConfig;
            var hwRows = getHw ? getHw() : [];
            hwRows.forEach(function (row, idx) {
                if (!row) return;
                var t = '';
                try {
                    if (typeof window.DoorConf2FormatHardwareSummaryLine === 'function') {
                        t = window.DoorConf2FormatHardwareSummaryLine(row);
                    }
                } catch (eFmtHw) { t = ''; }
                if (!t) {
                    t = String(row.title || row.product_id || '');
                    if (row.finish_label) t += ' — ' + row.finish_label;
                    if (row.function_label) t += ' — ' + row.function_label;
                    if (row.backset_label) t += ' — Hardware Backset: ' + row.backset_label;
                    if (row.thickness_label) t += ' — Door Thickness: ' + row.thickness_label;
                    if (row.qty && row.qty > 1) t += ' (×' + row.qty + ')';
                }
                if (t) parts.push((idx === 0 ? 'Hardware' : 'Hardware ' + (idx + 1)) + ': ' + t);
            });
        } catch (eH) { }
        try {
            var measureType = hsNormVal(config && config.measurement_type);
            for (var i = 0; i < HS_MEASURE_RULES.length; i++) {
                var r = HS_MEASURE_RULES[i];
                if (r.measure === measureType && hsAnyConfigValueEquals(config, r.setup)) {
                    r.ids.forEach(function (id) {
                        var sel = hsMeasureSelect(id);
                        var val = hsMeasureDisplay(sel);
                        if (val) parts.push(hsMeasureLabel(sel, id) + ': ' + val);
                    });
                    break;
                }
            }
        } catch (eM) { }
        return parts;
    }

    function buildHubspotQuoteDescription(config, container) {
        config = config || {};
        var rows = config._selected_summary;
        var lines = [];
        if (Array.isArray(rows)) {
            rows.forEach(function (row) {
                if (typeof row === 'string') {
                    var s = String(row).trim();
                    if (s) lines.push(s);
                    return;
                }
                if (!row || typeof row !== 'object') return;
                var lab = String(row.label || '').trim();
                var val = String(row.value != null ? row.value : (row.display || '')).trim();
                if (lab && val) lines.push(lab + ' : ' + val);
                else if (val) lines.push(val);
            });
        }
        if (lines.length) return lines.join('\n');
        try {
            if (window.DoorDescription && typeof window.DoorDescription.build === 'function') {
                var pType = '';
                var title = '';
                if (container) {
                    pType = String(container.getAttribute('data-product-type') || '').trim();
                    title = String(container.getAttribute('data-product-name') || '').trim();
                }
                if (!pType) pType = String(config._product_type || '').trim();
                if (!title) title = String(config._product_title || '').trim();
                var built = window.DoorDescription.build({
                    config: config,
                    schema: window.__doorConfigSchema,
                    productTitle: title,
                    productType: pType
                });
                if (built) return String(built).trim();
            }
        } catch (eDesc) { }
        return '';
    }

    function buildHubspotSummary(baseParts, config, qty) {
        var parts = (baseParts || []).slice().concat(buildHubspotExtraSummaryParts(config));
        if (qty != null) parts.push('Quantity: ' + qty);
        return parts.join('; ');
    }

    function getDoorQuantityInput() {
        var byId = document.getElementById('door-config-quantity');
        if (byId) return byId;
        var landingQty = document.getElementById('landing-config-quantity');
        if (landingQty) return landingQty;
        var landingRoot = document.getElementById('landing-product-configurator');
        if (landingRoot) {
            var landingWrapQty = landingRoot.querySelector('.landing-product-qty-row input[name="quantity"]');
            if (landingWrapQty) return landingWrapQty;
        }
        var container = document.getElementById('door-configurator');
        if (!container) return null;
        return container.querySelector('.door-add-to-cart-wrap input[name="quantity"]');
    }

    function getHubspotContainerEl() {
        return document.getElementById('door-configurator')
            || document.getElementById('landing-product-configurator');
    }

    function getDoorQuantity() {
        var qtyInput = getDoorQuantityInput();
        if (qtyInput) {
            var qtyVal = parseInt(qtyInput.value, 10);
            if (!isNaN(qtyVal) && qtyVal >= 1) return qtyVal;
        }
        try {
            var getCfg = hubspotDeps && hubspotDeps.getCurrentConfig;
            var config = getCfg ? getCfg() : null;
            if (config && config._quantity != null) {
                var stored = parseInt(config._quantity, 10);
                if (!isNaN(stored) && stored >= 1) return stored;
            }
        } catch (eQty) { }
        return 1;
    }

    function getHubspotAppliedLineTotal(container, qty) {
        qty = Math.max(1, parseInt(qty, 10) || 1);
        var readPrice = hubspotDeps && hubspotDeps.readDoorEstimatedPriceFromDom;
        var unitApplied = readPrice ? readPrice() : 0;
        if (unitApplied <= 0 && container) {
            var basePrice = parseFloat(container.getAttribute('data-base-price')) || 0;
            var getCfg = hubspotDeps && hubspotDeps.getCurrentConfig;
            var calcPrice = hubspotDeps && hubspotDeps.calculateDoorPrice;
            var config = getCfg ? getCfg() : {};
            var priced = calcPrice ? calcPrice(basePrice, config) : null;
            unitApplied = priced && priced.price != null ? parseFloat(priced.price) : basePrice;
            if (isNaN(unitApplied)) unitApplied = 0;
        }
        return Math.round(unitApplied * qty * 100) / 100;
    }

    function formatHubspotApiError(data) {
        if (!data) return 'Unknown HubSpot error';
        if (data.error) return String(data.error);
        if (data.detail && data.detail.message) return String(data.detail.message);
        if (typeof data.detail === 'string') return data.detail;
        try {
            var raw = JSON.stringify(data.detail || data);
            return raw.length > 320 ? raw.substring(0, 320) + '…' : raw;
        } catch (eFmt) {
            return 'HubSpot request failed';
        }
    }

    function parseHubspotFetchResponse(res) {
        return res.json()
            .then(function (data) {
                return { ok: res.ok, status: res.status, data: data };
            })
            .catch(function () {
                return { ok: false, status: res.status, data: null };
            });
    }

    function getSavedProjectNameFromFolder(folderSelect, newFolderInput, folderValue) {
        if (folderValue === '__new__') {
            return newFolderInput && newFolderInput.value ? newFolderInput.value.trim() : '';
        }
        if (folderSelect && folderSelect.options && folderSelect.selectedIndex >= 0) {
            return (folderSelect.options[folderSelect.selectedIndex].text || '').trim();
        }
        return '';
    }

    function resolveHubspotProductTitle(container, config, explicitName) {
        var title = String(explicitName || '').trim();
        if (title) return title;
        if (container) {
            title = String(container.getAttribute('data-product-name') || '').trim();
        }
        config = config || {};
        if (!title && config._product_title) title = String(config._product_title).trim();
        if (!title && container) {
            var titleEl = container.querySelector('.landing-product__title, [data-product-title]');
            if (titleEl) title = String(titleEl.textContent || '').trim();
        }
        if (!title && config._hardware_selections && config._hardware_selections[0]) {
            title = String(config._hardware_selections[0].title || '').trim();
        }
        if (!title && container) {
            var sku = String(container.getAttribute('data-product-sku') || '').trim();
            if (sku) title = sku;
        }
        if (!title && container) {
            var pt = String(container.getAttribute('data-product-type') || '').trim();
            if (pt) title = pt + ' product';
        }
        return title || 'Product project';
    }

    /* MERGE: hubspot_line_item_upsert_by_config_id — start */
    // On config update (?config_id=), reuse the same HubSpot line item (cache line_item_id + send config_id)
    // instead of creating a duplicate product on the deal.
    function syncHubspotAfterSave(opts) {
        opts = opts || {};
        var endpoint = hubspotDeps && hubspotDeps.hubspotDealEndpoint;
        if (!endpoint || !opts.savedProjectName) return false;

        var container = opts.container;
        var email = opts.email || '';
        var savedProjectName = opts.savedProjectName;
        var messageEl = opts.messageEl;
        var saveButton = opts.saveButton;
        var originalSaveText = opts.originalSaveText;
        var successMessageHtml = opts.successMessageHtml || '';
        var onComplete = typeof opts.onComplete === 'function' ? opts.onComplete : null;
        var getQueryParam = opts.getQueryParam || function () { return ''; };
        var hubspotExtraHtml = '';

        var firstName = (container && container.getAttribute('data-customer-first-name') || '').trim();
        var lastName = (container && container.getAttribute('data-customer-last-name') || '').trim();
        var cacheKey = '';
        var lineItemCacheKey = '';
        var cachedHubspotDealId = '';
        var cachedLineItemId = '';
        var isUpdate = !!opts.isUpdate;
        var editId = opts.editId || '';
        var data = opts.data || {};
        // Prefer explicit edit id / URL config_id so updates always carry a stable key.
        if (!editId && container) {
            editId = container.getAttribute('data-edit-config-id') || '';
        }
        if (!editId && typeof getQueryParam === 'function') {
            editId = getQueryParam('config_id') || '';
        }
        var resolvedConfigId = isUpdate
            ? String(editId || (data.id != null ? data.id : '') || '')
            : String(data.id != null ? data.id : (editId || ''));
        var resolvedFolderId = '';
        if (opts.folderId != null && opts.folderId !== '') {
            resolvedFolderId = String(opts.folderId);
        } else if (data.folder_id != null && data.folder_id !== '') {
            resolvedFolderId = String(data.folder_id);
        }

        try {
            cacheKey = 'door_hubspot_deal_save__' + email + '__' + encodeURIComponent(savedProjectName);
            cachedHubspotDealId = localStorage.getItem(cacheKey) || '';
            if (resolvedConfigId) {
                lineItemCacheKey = 'door_hubspot_line_item__' + email + '__' + String(resolvedConfigId);
                cachedLineItemId = localStorage.getItem(lineItemCacheKey) || '';
            }
        } catch (eCache) { }

        var hubspotLineProps = Object.assign({}, opts.props || {});
        if (resolvedConfigId) hubspotLineProps['Config ID'] = resolvedConfigId;

        var productTypeHs = container ? (container.getAttribute('data-product-type') || '').trim() : '';
        var quoteDescription = '';
        try {
            quoteDescription = buildHubspotQuoteDescription(opts.configForStorage || opts.config, container);
        } catch (eQd) { }

        var hubspotPayload = {
            deal_id: cachedHubspotDealId,
            line_item_id: cachedLineItemId,
            product_id: opts.productId || '',
            product_handle: opts.productHandle || '',
            product_title: resolveHubspotProductTitle(container, opts.configForStorage || opts.config, opts.productName),
            product_sku: opts.productSku || '',
            product_type: productTypeHs,
            options: opts.configForStorage || opts.config || {},
            options_summary: buildHubspotSummary(opts.summaryParts || [], opts.config, opts.qtySave),
            quote_description: quoteDescription,
            line_item_properties: hubspotLineProps,
            quantity: opts.qtySave,
            base_price: opts.basePrice,
            applied_price: opts.appliedLineTotal,
            currency: opts.currency,
            customer_email: email,
            customer_first_name: firstName,
            customer_last_name: lastName,
            call_requested: '--',
            saved_project_name: savedProjectName,
            config_id: resolvedConfigId,
            folder_id: resolvedFolderId
        };
        if (!cachedHubspotDealId) delete hubspotPayload.deal_id;
        if (!cachedLineItemId) delete hubspotPayload.line_item_id;
        if (!resolvedConfigId) delete hubspotPayload.config_id;
        if (!resolvedFolderId) delete hubspotPayload.folder_id;

        fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(hubspotPayload)
        })
            .then(parseHubspotFetchResponse)
            .then(function (result) {
                var hbData = result.data;
                if (!result.ok || !hbData || !hbData.success) {
                    if (cacheKey) {
                        try { localStorage.removeItem(cacheKey); } catch (eClr) { }
                    }
                    if (lineItemCacheKey) {
                        try { localStorage.removeItem(lineItemCacheKey); } catch (eClrLi) { }
                    }
                    if (typeof console !== 'undefined' && console.error) {
                        console.error('HubSpot save deal failed', result.status, hbData);
                    }
                    hubspotExtraHtml = '<div style="margin-top:0.5rem;color:#b91c1c;">Could not update HubSpot deal: ' + formatHubspotApiError(hbData) + '</div>';
                    return;
                }
                if (hbData.dealId && cacheKey) {
                    try { localStorage.setItem(cacheKey, hbData.dealId); } catch (eStore) { }
                }
                if (hbData.lineItemId && resolvedConfigId) {
                    try {
                        var liKey = lineItemCacheKey || ('door_hubspot_line_item__' + email + '__' + String(resolvedConfigId));
                        localStorage.setItem(liKey, String(hbData.lineItemId));
                    } catch (eStoreLi) { }
                }
            })
            .catch(function (err) {
                if (typeof console !== 'undefined' && console.error) {
                    console.error('HubSpot save deal network error', err);
                }
                hubspotExtraHtml = '<div style="margin-top:0.5rem;color:#b91c1c;">Could not update HubSpot deal (network error).</div>';
            })
            .finally(function () {
                // Show success only after HubSpot finishes — avoids "Saving..." + success at once.
                if (onComplete) {
                    onComplete(hubspotExtraHtml);
                    return;
                }
                if (messageEl && successMessageHtml) {
                    messageEl.classList.remove('is-error');
                    messageEl.classList.add('is-success');
                    messageEl.style.display = 'block';
                    messageEl.style.color = '#166534';
                    messageEl.innerHTML = successMessageHtml + hubspotExtraHtml;
                    try {
                        var returnedNote = document.getElementById('door-returned-from-login-note');
                        if (returnedNote) returnedNote.style.display = 'none';
                    } catch (eHideNote2) { }
                } else if (messageEl && hubspotExtraHtml) {
                    messageEl.classList.remove('is-success');
                    messageEl.classList.add('is-error');
                    messageEl.style.display = 'block';
                    messageEl.innerHTML = (messageEl.innerHTML || '') + hubspotExtraHtml;
                }
                if (saveButton) {
                    saveButton.disabled = false;
                    saveButton.textContent = originalSaveText;
                }
            });

        return true;
    }
    /* MERGE: hubspot_line_item_upsert_by_config_id — end */

    var DOOR_QUOTE_CART_KEY = 'door_quote_cart_v1';

    function readDoorQuoteCart() {
        try {
            var raw = localStorage.getItem(DOOR_QUOTE_CART_KEY);
            if (!raw) return { items: [] };
            var parsed = JSON.parse(raw);
            if (!parsed || !Array.isArray(parsed.items)) return { items: [] };
            return parsed;
        } catch (eReadCart) {
            return { items: [] };
        }
    }

    function writeDoorQuoteCart(cart) {
        try {
            var payload = {
                items: (cart && Array.isArray(cart.items)) ? cart.items : [],
                updated_at: new Date().toISOString()
            };
            if (cart && cart.preferred_folder_id != null && cart.preferred_folder_id !== '') {
                payload.preferred_folder_id = cart.preferred_folder_id;
            }
            if (cart && cart.preferred_folder_name) {
                payload.preferred_folder_name = cart.preferred_folder_name;
            }
            if (cart && Array.isArray(cart.removed_source_config_ids) && cart.removed_source_config_ids.length) {
                payload.removed_source_config_ids = cart.removed_source_config_ids;
            }
            localStorage.setItem(DOOR_QUOTE_CART_KEY, JSON.stringify(payload));
            try {
                window.dispatchEvent(new CustomEvent('door-quote-cart-updated', {
                    detail: { count: (cart && Array.isArray(cart.items)) ? cart.items.length : 0 }
                }));
            } catch (eEvt) { }
            return true;
        } catch (eWriteCart) {
            return false;
        }
    }

    function addItemToDoorQuoteCart(item) {
        var cart = readDoorQuoteCart();
        var entry = Object.assign({}, item || {});
        // Deep-clone options/summary so later configurator changes cannot mutate cart lines.
        try {
            if (entry.options && typeof entry.options === 'object') {
                entry.options = JSON.parse(JSON.stringify(entry.options));
            }
            if (Array.isArray(entry.selected_summary)) {
                entry.selected_summary = JSON.parse(JSON.stringify(entry.selected_summary));
            }
        } catch (eClone) { }
        entry.id = 'q_' + Date.now() + '_' + Math.floor(Math.random() * 1000000);
        entry.quantity = Math.max(1, parseInt(entry.quantity, 10) || 1);
        entry.added_at = new Date().toISOString();
        cart.items.push(entry);
        if (!writeDoorQuoteCart(cart)) {
            return null;
        }
        return entry;
    }

    function buildFallbackQuoteCapture(container) {
        var getCfg = hubspotDeps && hubspotDeps.getCurrentConfig;
        var config = {};
        try { config = getCfg ? (getCfg() || {}) : {}; } catch (eCfg) { config = {}; }
        var qty = 1;
        try { qty = getDoorQuantity(); } catch (eQty) { qty = 1; }
        var basePrice = parseFloat(container && container.getAttribute('data-base-price')) || 0;
        var applied = basePrice;
        try {
            applied = getHubspotAppliedLineTotal(container, qty) || basePrice;
            if (qty > 1) applied = applied / qty;
        } catch (ePrice) { }
        var configForStorage = Object.assign({}, config, {
            _quantity: qty,
            _product_sku: (container && container.getAttribute('data-product-sku') || '').trim(),
            _product_type: (container && container.getAttribute('data-product-type') || '').trim(),
            _product_title: (container && container.getAttribute('data-product-name') || ''),
            _product_image_url: (container && container.getAttribute('data-product-image') || ''),
            _product_handle: (container && container.getAttribute('data-product-handle') || ''),
            _applied_unit_price: applied
        });
        return {
            productId: container ? container.getAttribute('data-product-id') : '',
            productName: container ? (container.getAttribute('data-product-name') || '') : '',
            productImage: container ? (container.getAttribute('data-product-image') || '') : '',
            productHandle: container ? (container.getAttribute('data-product-handle') || '') : '',
            variantId: container ? (container.getAttribute('data-variant-id') || '') : '',
            productSku: container ? (container.getAttribute('data-product-sku') || '').trim() : '',
            basePrice: basePrice,
            qtySave: qty,
            configForStorage: configForStorage,
            computedPrice: applied
        };
    }

    function captureQuoteCartItem(container) {
        if (!container) container = getHubspotContainerEl();
        if (!container) return null;

        var emailInput = document.getElementById('door-customer-email');
        var email = (container.getAttribute('data-customer-email') || '').trim() ||
            (emailInput && emailInput.value ? emailInput.value.trim() : '');

        var built = null;
        try {
            var buildStorage = hubspotDeps && hubspotDeps.buildDoorConfigForStorage;
            if (typeof buildStorage === 'function') {
                built = buildStorage(container);
            }
        } catch (eBuildClick) {
            if (typeof console !== 'undefined' && console.error) {
                console.error('[door] quote capture builder threw', eBuildClick);
            }
            built = null;
        }
        if (!built || !built.configForStorage) {
            built = buildFallbackQuoteCapture(container);
        }
        if (!built || !built.configForStorage) return null;

        // Same snapshot shape as Save Design (options + addons + pricing), stored in browser cart only.
        return {
            customer_email: email || '',
            base_product_id: built.productId || '',
            product_title: built.productName || '',
            product_image_url: built.productImage || '',
            product_handle: built.productHandle || '',
            product_type: (built.configForStorage && built.configForStorage._product_type) || (container.getAttribute('data-product-type') || ''),
            product_sku: built.productSku || '',
            variant_id: built.variantId || '',
            options: built.configForStorage,
            selected_summary: (built.configForStorage && built.configForStorage._selected_summary) || [],
            base_price: built.basePrice,
            computed_price: built.computedPrice,
            applied_unit_price: built.computedPrice,
            quantity: built.qtySave || 1
        };
    }

    function resetAddToQuoteButtonUi() {
        var guestBtn = document.getElementById('door-guest-add-to-quote');
        if (guestBtn) {
            guestBtn.disabled = false;
            guestBtn.textContent = guestBtn.getAttribute('data-default-label') || 'Add to Quote';
        }
        var hubspotButton = document.getElementById('door-send-to-hubspot-button');
        if (hubspotButton) {
            hubspotButton.disabled = false;
            hubspotButton.textContent = hubspotButton.getAttribute('data-default-label') || 'Add to Quote';
        }
    }

    function bindAddToQuoteBackNavReset() {
        if (window.__doorAddToQuoteBackNavBound) return;
        window.__doorAddToQuoteBackNavBound = true;
        // Browser Back restores the frozen page (bfcache) with disabled/"Adding..." still set.
        window.addEventListener('pageshow', function () {
            resetAddToQuoteButtonUi();
        });
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') resetAddToQuoteButtonUi();
        });
    }

    /**
     * Theme sticky CTA is often <a href="#" class="btn btn--primary common-btn">Add to Quote</a>
     * which only jumps to page top. Proxy those clicks to the real Add to Quote buttons.
     */
    function bindStickyAddToQuoteProxy() {
        if (window.__doorStickyAddToQuoteProxyBound) return;
        window.__doorStickyAddToQuoteProxyBound = true;

        function isRealAddToQuoteControl(el) {
            if (!el || !el.id) return false;
            return el.id === 'door-send-to-hubspot-button' || el.id === 'door-guest-add-to-quote';
        }

        function isStickyAddToQuoteProxy(el) {
            if (!el || isRealAddToQuoteControl(el)) return false;
            var text = String(el.textContent || '').replace(/\s+/g, ' ').trim();
            if (!/^add to quote$/i.test(text)) return false;
            if (el.tagName === 'A') {
                var href = String(el.getAttribute('href') || '').trim();
                if (href === '' || href === '#' || href === '#!' || /^javascript:/i.test(href)) return true;
                if (el.classList && (el.classList.contains('btn--primary') || el.classList.contains('btn'))) return true;
            }
            if (el.tagName === 'BUTTON' && el.classList && el.classList.contains('btn--primary')) return true;
            return false;
        }

        function isEffectivelyVisible(el) {
            if (!el) return false;
            if (el.closest && el.closest('.door-hidden')) return false;
            var style = window.getComputedStyle(el);
            if (style.display === 'none' || style.visibility === 'hidden') return false;
            return true;
        }

        function clickRealAddToQuote() {
            var hub = document.getElementById('door-send-to-hubspot-button');
            var guest = document.getElementById('door-guest-add-to-quote');
            if (hub && isEffectivelyVisible(hub)) {
                hub.click();
                return true;
            }
            if (guest && isEffectivelyVisible(guest)) {
                guest.click();
                return true;
            }
            if (hub) {
                hub.click();
                return true;
            }
            if (guest) {
                guest.click();
                return true;
            }
            return false;
        }

        document.addEventListener('click', function (e) {
            var t = e.target;
            if (!t || !t.closest) return;
            var el = t.closest('a, button');
            if (!isStickyAddToQuoteProxy(el)) return;
            e.preventDefault();
            e.stopPropagation();
            clickRealAddToQuote();
        }, true);
    }

    function bindHubspotCallbackButton() {
        var quotePageUrl = (hubspotDeps && hubspotDeps.quotePageUrl) || '/pages/request-a-quote';

        bindAddToQuoteBackNavReset();
        bindStickyAddToQuoteProxy();

        var hubspotButton = document.getElementById('door-send-to-hubspot-button');
        if (hubspotButton && hubspotButton.getAttribute('data-hubspot-bound') !== '1') {
            hubspotButton.setAttribute('data-hubspot-bound', '1');
            if (!hubspotButton.getAttribute('data-default-label')) {
                hubspotButton.setAttribute('data-default-label', hubspotButton.textContent || 'Add to Quote');
            }
            hubspotButton.addEventListener('click', function () {
                var container = getHubspotContainerEl();
                var messageEl = document.getElementById('door-hubspot-message');
                if (!container) {
                    if (messageEl) {
                        messageEl.style.display = 'block';
                        messageEl.textContent = 'Configurator not found on this page.';
                        messageEl.style.color = '#b91c1c';
                    }
                    return;
                }

                if (window.DoorConf2Validate
                    && typeof window.DoorConf2Validate.validateSdlProfileBeforeSubmit === 'function'
                    && !window.DoorConf2Validate.validateSdlProfileBeforeSubmit(messageEl)) {
                    return;
                }

                var cartItem = captureQuoteCartItem(container);
                if (!cartItem) {
                    if (messageEl) {
                        messageEl.style.display = 'block';
                        messageEl.textContent = 'Could not capture the current design. Please try again.';
                        messageEl.style.color = '#b91c1c';
                    }
                    return;
                }

                hubspotButton.disabled = true;
                var originalText = hubspotButton.getAttribute('data-default-label') || hubspotButton.textContent || 'Add to Quote';
                hubspotButton.textContent = 'Adding...';
                if (messageEl) {
                    messageEl.style.display = 'none';
                    messageEl.textContent = '';
                }
                // Don't leave a prior Save success visible while Add to Quote is still running.
                var saveMsgEl = document.getElementById('door-save-config-message');
                if (saveMsgEl) {
                    saveMsgEl.classList.remove('is-success', 'is-error');
                    saveMsgEl.style.display = 'none';
                    saveMsgEl.textContent = '';
                }

                var saved = addItemToDoorQuoteCart(cartItem);
                if (!saved) {
                    hubspotButton.disabled = false;
                    hubspotButton.textContent = originalText;
                    if (messageEl) {
                        messageEl.style.display = 'block';
                        messageEl.style.color = '#b91c1c';
                        messageEl.textContent = 'Could not save this design to your quote cart. Please check browser storage settings.';
                    }
                    return;
                }

                try {
                    var qtyAtq = Math.max(1, parseInt(saved.quantity, 10) || 1);
                    var unitAtq = Number(saved.applied_unit_price != null ? saved.applied_unit_price : saved.computed_price != null ? saved.computed_price : saved.base_price) || 0;
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ ecommerce: null });
                    window.dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce: {
                            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
                            value: Math.round(unitAtq * qtyAtq * 100) / 100,
                            items: [{
                                item_id: String(saved.product_sku || saved.variant_id || saved.base_product_id || ''),
                                item_name: saved.product_title || 'Door configuration',
                                price: Math.round(unitAtq * 100) / 100,
                                quantity: qtyAtq
                            }]
                        }
                    });
                    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
                        Shopify.analytics.publish('add_to_quote', {
                            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
                            value: Math.round(unitAtq * qtyAtq * 100) / 100,
                            item_id: String(saved.product_sku || saved.variant_id || saved.base_product_id || ''),
                            item_name: saved.product_title || 'Door configuration',
                            price: Math.round(unitAtq * 100) / 100,
                            quantity: qtyAtq
                        });
                    }
                } catch (eAtq) { }

                // Adding finished — show success only after cart write completes, then go to quote page.
                showAddToQuoteCompletedMessage(saveMsgEl || messageEl);
                hubspotButton.textContent = originalText;

                var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
                    ? window.Shopify.routes.root
                    : '/';
                var path = quotePageUrl.indexOf('/') === 0 ? quotePageUrl : '/' + quotePageUrl;
                var dest = (root && root !== '/') ? root.replace(/\/$/, '') + path : path;
                try { sessionStorage.setItem('vd_quote_page_from_add', '1'); } catch (eFlag) {}
                window.setTimeout(function () {
                    window.location.href = dest;
                }, 450);
            });
        }

        bindGuestAddToQuoteButton();
        resetAddToQuoteButtonUi();
    }

    function bindGuestAddToQuoteButton() {
        var guestBtn = document.getElementById('door-guest-add-to-quote');
        if (!guestBtn || guestBtn.getAttribute('data-guest-quote-bound') === '1') return;
        guestBtn.setAttribute('data-guest-quote-bound', '1');
        if (!guestBtn.getAttribute('data-default-label')) {
            guestBtn.setAttribute('data-default-label', guestBtn.textContent || 'Add to Quote');
        }

        guestBtn.addEventListener('click', function () {
            var container = getHubspotContainerEl();
            var messageEl = document.getElementById('door-guest-quote-message');
            if (!container) {
                if (messageEl) {
                    messageEl.style.display = 'block';
                    messageEl.textContent = 'Configurator not found on this page.';
                    messageEl.style.color = '#b91c1c';
                }
                return;
            }

            if (window.DoorConf2Validate
                && typeof window.DoorConf2Validate.validateSdlProfileBeforeSubmit === 'function'
                && !window.DoorConf2Validate.validateSdlProfileBeforeSubmit(messageEl)) {
                return;
            }

            var cartItem = captureQuoteCartItem(container);
            if (!cartItem) {
                if (messageEl) {
                    messageEl.style.display = 'block';
                    messageEl.textContent = 'Could not capture the current design. Please try again.';
                    messageEl.style.color = '#b91c1c';
                }
                return;
            }

            guestBtn.disabled = true;
            var originalText = guestBtn.getAttribute('data-default-label') || guestBtn.textContent || 'Add to Quote';
            guestBtn.textContent = 'Adding...';
            if (messageEl) {
                messageEl.style.display = 'none';
                messageEl.textContent = '';
            }

            var saved = addItemToDoorQuoteCart(cartItem);
            if (!saved) {
                guestBtn.disabled = false;
                guestBtn.textContent = originalText;
                if (messageEl) {
                    messageEl.style.display = 'block';
                    messageEl.style.color = '#b91c1c';
                    messageEl.textContent = 'Could not save this design to your quote cart. Please check browser storage settings.';
                }
                return;
            }

            try {
                var qtyGuest = Math.max(1, parseInt(saved.quantity, 10) || 1);
                var unitGuest = Number(saved.applied_unit_price != null ? saved.applied_unit_price : saved.computed_price != null ? saved.computed_price : saved.base_price) || 0;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'add_to_cart',
                    ecommerce: {
                        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
                        value: Math.round(unitGuest * qtyGuest * 100) / 100,
                        items: [{
                            item_id: String(saved.product_sku || saved.variant_id || saved.base_product_id || ''),
                            item_name: saved.product_title || 'Door configuration',
                            price: Math.round(unitGuest * 100) / 100,
                            quantity: qtyGuest
                        }]
                    }
                });
                if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
                    Shopify.analytics.publish('add_to_quote', {
                        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
                        value: Math.round(unitGuest * qtyGuest * 100) / 100,
                        item_id: String(saved.product_sku || saved.variant_id || saved.base_product_id || ''),
                        item_name: saved.product_title || 'Door configuration',
                        price: Math.round(unitGuest * 100) / 100,
                        quantity: qtyGuest
                    });
                }
            } catch (eGuestAtq) { }

            // Adding finished — show success only after cart write completes, then go to quote page.
            showAddToQuoteCompletedMessage(messageEl);
            guestBtn.textContent = originalText;

            // Guest: full snapshot is already in localStorage — go to quote cart (no login yet).
            // Request Quote on the cart page will gate login + profile completion.
            var quotePath = '/pages/request-a-quote';
            try {
                var depQuote = hubspotDeps && hubspotDeps.quotePageUrl;
                var cfgEl = document.getElementById('door-configurator')
                    || document.getElementById('landing-product-configurator')
                    || document.querySelector('[data-landing-save-block="1"]');
                var cfgQuote = String((depQuote || (cfgEl && cfgEl.getAttribute('data-quote-page-url')) || '')).trim();
                if (cfgQuote) quotePath = cfgQuote.indexOf('/') === 0 ? cfgQuote : '/' + cfgQuote;
            } catch (eQuotePath) { }
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
                ? window.Shopify.routes.root
                : '/';
            var path = quotePath.indexOf('/') === 0 ? quotePath : '/' + quotePath;
            var dest = (root && root !== '/') ? root.replace(/\/$/, '') + path : path;
            try { sessionStorage.setItem('vd_quote_page_from_add', '1'); } catch (eFlag) {}
            window.setTimeout(function () {
                window.location.href = dest;
            }, 450);
        });
    }

    function showAddToQuoteCompletedMessage(messageEl) {
        if (!messageEl) return;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
            ? window.Shopify.routes.root
            : '/';
        var path = '/pages/my-saved-doors';
        var myDoorsUrl = (root && root !== '/') ? root.replace(/\/$/, '') + path : path;
        var container = getHubspotContainerEl();
        var isUpdate = !!(container && (
            container.getAttribute('data-edit-config-id')
            || /[?&]config_id=\d+/.test(String((window.location && window.location.search) || ''))
        ));
        var msg = isUpdate
            ? 'Project updated. Our team will follow up if needed.'
            : 'Added to your quote. Our team will follow up if needed.';
        messageEl.classList.remove('is-error');
        messageEl.classList.add('is-success');
        messageEl.style.display = 'block';
        messageEl.style.color = '#166534';
        // TEMP: hide "View my saved doors" link from success message
        messageEl.innerHTML = msg;
        // messageEl.innerHTML = msg + ' <a href="' + myDoorsUrl + '" style="font-weight:600;">View my saved doors</a>';
    }

    function bootHubspotIntegration(deps) {
        hubspotDeps = deps || {};
        hubspotDeps.hubspotDealEndpoint = (hubspotDeps.apiBase || 'https://api.vintagedoors.com') + '/hubspot/api/hubspot-create-deal.php';
        bindHubspotCallbackButton();
        return {
            syncAfterSave: syncHubspotAfterSave,
            getDoorQuantity: getDoorQuantity,
            getDoorQuantityInput: getDoorQuantityInput,
            getAppliedLineTotal: getHubspotAppliedLineTotal,
            buildSummary: buildHubspotSummary,
            getSavedProjectNameFromFolder: getSavedProjectNameFromFolder
        };
    }

    /* MERGE: product_wise_edge_profile_sdl — start */
    function normProductWiseChoiceKey(s) {
        return String(s == null ? '' : s).trim().toLowerCase().replace(/[\s-]+/g, '_');
    }

    function parseProductWiseEdgeProfileSdl(main) {
        if (!main) return null;
        var raw = main.getAttribute('data-product-wise-edge-profile-sdl');
        if (raw == null || !String(raw).trim()) return null;
        try {
            var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
            if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
            if (!Object.keys(parsed).length) return null;
            return parsed;
        } catch (eParsePweps) {
            return null;
        }
    }

    function getProductWiseEdgeProfileSdlFromMain() {
        return parseProductWiseEdgeProfileSdl(document.getElementById('door-configurator'));
    }

    function getProductWiseAllowedValues(config, optionKey) {
        if (!config || !optionKey || !Object.prototype.hasOwnProperty.call(config, optionKey)) return null;
        var val = config[optionKey];
        if (val == null || val === '') return null;
        if (Array.isArray(val)) {
            if (!val.length) return null;
            var arr = val.map(normProductWiseChoiceKey).filter(Boolean);
            return arr.length ? arr : null;
        }
        if (typeof val === 'string' && !String(val).trim()) return null;
        var one = normProductWiseChoiceKey(val);
        return one ? [one] : null;
    }

    /* MERGE: product_wise_edge_profile_sdl stile_and_rail_profile_check — start */
    /** Empty AK / check=true / stile=["all"] => show all stile_and_rail_profile options. */
    function isProductWiseStileAndRailShowAll(config) {
        if (!config) return false;
        var check = config.stile_and_rail_profile_check;
        if (check === true || check === 1 || check === '1' || String(check).toLowerCase() === 'true') {
            return true;
        }
        var allowed = getProductWiseAllowedValues(config, 'stile_and_rail_profile');
        return !!(allowed && allowed.length === 1 && allowed[0] === 'all');
    }

    /**
     * applied_molding_choice in stile_and_rail_profile is a legacy gate flag — do not
     * treat it as its own allow key. Remaining values (quarter_bead, craftsman,
     * rm5_applied_molding, other *_applied_molding) display as individual stile options.
     * The standalone Applied Molding accordion is always hidden.
     */
    function isProductWiseStileIgnoredAllowKey(key) {
        var k = normProductWiseChoiceKey(key);
        return k === 'applied_molding_choice';
    }

    function canonicalProductWiseStileKey(key) {
        var k = normProductWiseChoiceKey(key);
        if (!k) return '';
        if (k === 'quarterbead' || k.indexOf('quarter_bead') === 0) return 'quarter_bead';
        if (k === 'craftsman' || k === 'carftsman') return 'craftsman';
        // Any applied-molding variant merged into stile (rm5_applied_molding, etc.).
        if (k === 'rm5' || k === 'rm_5' || k === 'rm5_applied_molding') return 'rm5_applied_molding';
        if (k.length > 16 && k.slice(-16) === '_applied_molding') return k;
        if (k === 'applied_molding' || k === 'applied_moldings' || k === 'applied_molding_choice') {
            return 'applied_molding';
        }
        if (k.indexOf('applied_molding') === 0) return 'applied_molding';
        return k;
    }

    function getProductWiseStileAndRailAllowedValues(config) {
        if (isProductWiseStileAndRailShowAll(config)) return null;
        var allowed = getProductWiseAllowedValues(config, 'stile_and_rail_profile');
        if (!allowed) return null;
        if (allowed.length === 1 && allowed[0] === 'all') return null;
        var filtered = [];
        for (var i = 0; i < allowed.length; i++) {
            if (isProductWiseStileIgnoredAllowKey(allowed[i])) continue;
            var canon = canonicalProductWiseStileKey(allowed[i]);
            if (!canon) continue;
            if (filtered.indexOf(canon) === -1) filtered.push(canon);
        }
        return filtered.length ? filtered : null;
    }

    function productWiseStileAllowListHasAppliedMolding(allowedStile) {
        if (!allowedStile || !allowedStile.length) return false;
        for (var i = 0; i < allowedStile.length; i++) {
            var c = canonicalProductWiseStileKey(allowedStile[i]);
            if (c === 'rm5_applied_molding' || c === 'applied_molding') return true;
            if (c && c.indexOf('applied_molding') !== -1) return true;
        }
        return false;
    }

    function productWiseStileChoiceIsAllowed(choiceVal, allowedStile) {
        if (!allowedStile || !allowedStile.length) return true;
        var choiceCanon = canonicalProductWiseStileKey(choiceVal);
        if (!choiceCanon) return false;
        for (var i = 0; i < allowedStile.length; i++) {
            if (canonicalProductWiseStileKey(allowedStile[i]) === choiceCanon) return true;
        }
        // Schema may still use "applied_molding_choice" for the merged RM5 / molding stile card.
        if (
            (choiceCanon === 'applied_molding' || choiceCanon === 'applied_molding_choice')
            && productWiseStileAllowListHasAppliedMolding(allowedStile)
        ) {
            return true;
        }
        return false;
    }
    /* MERGE: product_wise_edge_profile_sdl stile_and_rail_profile_check — end */

    /** True when sdl_profile is a boolean-like value (true/false), not a specific option name. */
    function isProductWiseSdlProfileBooleanValue(v) {
        if (v === true || v === 1 || v === '1' || String(v).toLowerCase() === 'true') return true;
        if (v === false || v === 0 || v === '0' || String(v).toLowerCase() === 'false') return true;
        return false;
    }

    /** True only when sdl_profile is explicitly true or false (not absent / empty / unset / option name). */
    function productWiseSdlProfileKeyIsActive(config) {
        if (!config || !Object.prototype.hasOwnProperty.call(config, 'sdl_profile')) return false;
        var v = config.sdl_profile;
        if (v == null || v === '') return false;
        return isProductWiseSdlProfileBooleanValue(v);
    }

    /**
     * Known SDL option tokens (longest first) for parsing compound metafield values
     * like "flat_cove" → ["flat", "cove"].
     */
    var PRODUCT_WISE_SDL_COMPOUND_TOKENS = [
        'bead_and_cove',
        'bell_ogee',
        'half_round',
        'roman_ogee',
        'flat',
        'cove'
    ];

    /**
     * Parse compound sdl_profile strings (e.g. "flat_cove") into SDL choice keys.
     * Returns null when the value is a single known SDL option or not a compound.
     */
    function splitProductWiseSdlCompound(raw) {
        if (raw == null || raw === '' || isProductWiseSdlProfileBooleanValue(raw)) return null;
        if (Array.isArray(raw)) return null;
        var k = normProductWiseChoiceKey(raw);
        if (!k) return null;
        for (var ti = 0; ti < PRODUCT_WISE_SDL_COMPOUND_TOKENS.length; ti++) {
            if (k === PRODUCT_WISE_SDL_COMPOUND_TOKENS[ti]) return null;
        }
        var parts = [];
        var rest = k;
        while (rest) {
            var matched = false;
            for (var i = 0; i < PRODUCT_WISE_SDL_COMPOUND_TOKENS.length; i++) {
                var tok = PRODUCT_WISE_SDL_COMPOUND_TOKENS[i];
                if (rest === tok || rest.indexOf(tok + '_') === 0) {
                    parts.push(tok);
                    rest = rest.slice(tok.length);
                    if (rest.charAt(0) === '_') rest = rest.slice(1);
                    matched = true;
                    break;
                }
            }
            if (!matched) return null;
        }
        return parts.length >= 2 ? parts : null;
    }

    /**
     * Map compound sdl_profile (e.g. flat_cove) to the SDL for the selected stile.
     * Index alignment with stile_and_rail_profile: [craftsman, rm5_applied_molding]
     * → flat for craftsman, cove for rm5_applied_molding.
     */
    function resolveProductWiseCompoundSdlForStile(config, selectedStileKey) {
        if (!config) return null;
        var parts = splitProductWiseSdlCompound(config.sdl_profile);
        if (!parts || !parts.length) return null;
        var stileCanon = canonicalProductWiseStileKey(selectedStileKey);
        if (!stileCanon) return parts.slice();

        var stileList = getProductWiseStileAndRailAllowedValues(config);
        if (!stileList || !stileList.length) {
            stileList = getProductWiseAllowedValues(config, 'stile_and_rail_profile');
        }
        if (stileList && stileList.length) {
            for (var i = 0; i < stileList.length && i < parts.length; i++) {
                if (canonicalProductWiseStileKey(stileList[i]) === stileCanon) {
                    return [parts[i]];
                }
            }
        }

        // Convention fallback used by C422-E style products (flat_cove).
        if (stileCanon === 'craftsman' && parts.indexOf('flat') !== -1) return ['flat'];
        if (
            (stileCanon === 'rm5_applied_molding' || stileCanon === 'applied_molding')
            && parts.indexOf('cove') !== -1
        ) {
            return ['cove'];
        }
        return parts.slice();
    }

    /**
     * When sdl_profile is a specific option (e.g. "cove") or list of options,
     * return normalized allowed values. Boolean true/false returns null (show all / hide).
     * Compound values like "flat_cove" map by selected stile when selectedStileKey is passed.
     */
    function getProductWiseSdlProfileAllowedValues(config, selectedStileKey) {
        if (!config || !Object.prototype.hasOwnProperty.call(config, 'sdl_profile')) return null;
        var v = config.sdl_profile;
        if (v == null || v === '') return null;
        if (isProductWiseSdlProfileBooleanValue(v)) return null;

        var compoundParts = splitProductWiseSdlCompound(v);
        if (compoundParts) {
            if (selectedStileKey != null && String(selectedStileKey).trim() !== '') {
                return resolveProductWiseCompoundSdlForStile(config, selectedStileKey);
            }
            // No stile yet: allow all compound parts; stile sync narrows to one.
            return compoundParts.slice();
        }

        return getProductWiseAllowedValues(config, 'sdl_profile');
    }

    /** Canonical SDL key so "Cove" / "cove_profile" match "cove". */
    function canonicalProductWiseSdlKey(key) {
        var k = normProductWiseChoiceKey(key);
        if (!k) return '';
        // Do not collapse compound metafield values (e.g. flat_cove) to "flat".
        if (splitProductWiseSdlCompound(k)) return k;
        if (k === 'halfround' || k.indexOf('half_round') === 0) return 'half_round';
        if (k === 'bellogee' || k.indexOf('bell_ogee') === 0) return 'bell_ogee';
        if (k === 'flat' || k.indexOf('flat') === 0) return 'flat';
        if (k === 'cove' || k.indexOf('cove') === 0) return 'cove';
        return k;
    }

    function resolveChoiceProductWiseEdgeProfileShouldHide(opt, choice, productWiseConfig) {
        if (!productWiseConfig || !choice || !opt) return null;
        var optId = normProductWiseChoiceKey(opt.id);
        var choiceVal = normProductWiseChoiceKey(choice.value != null ? choice.value : '');
        if (!choiceVal) return null;

        if (optId === 'stile_and_rail_profile') {
            /* MERGE: product_wise_edge_profile_sdl stile_and_rail_profile_check — start */
            var allowedStile = getProductWiseStileAndRailAllowedValues(productWiseConfig);
            /* MERGE: product_wise_edge_profile_sdl stile_and_rail_profile_check — end */
            if (!allowedStile) return null;
            // Hide when not in allow-list; applied_molding_choice is already stripped from allow-list.
            return !productWiseStileChoiceIsAllowed(choiceVal, allowedStile);
        }

        if (optId === 'applied_molding' || optId === 'applied_molding_choice') {
            /* MERGE: product_wise_applied_molding_accordion — start */
            // rm5 => only RM5; all => no product filter (collection tags decide);
            // hide => hide every choice / section gated elsewhere.
            var amMode = getProductWiseAppliedMoldingMode(productWiseConfig);
            if (amMode === 'all') return null;
            if (amMode === 'hide') return true;
            if (amMode === 'rm5') {
                // --- Dp start 31-07 — Applied Molding renaming logic support ---
                var cVNorm = String(choiceVal || '').toLowerCase().trim();
                return !(cVNorm === 'rm5' || cVNorm === 'rm_5' || cVNorm === 'rm5_applied_molding');
                // --- Dp end 31-07 — Applied Molding renaming logic support ---
            }
            /* MERGE: product_wise_applied_molding_accordion — end */
            var allowedAm = getProductWiseAllowedValues(productWiseConfig, 'applied_molding');
            if (!allowedAm) {
                allowedAm = getProductWiseAllowedValues(productWiseConfig, 'applied_molding_choice');
            }
            if (!allowedAm) return null;
            // Legacy: applied_molding:"all" must not filter to a literal "all" choice.
            if (allowedAm.length === 1 && allowedAm[0] === 'all') return null;
            // --- Dp start 31-07 — Applied Molding renaming support ---
            var baseChoiceVal = String(choiceVal || '').toLowerCase().trim().replace(/_applied_molding$/, '');
            var allowedAmNorm = allowedAm.map(function(item) {
                return String(item || '').toLowerCase().trim().replace(/_applied_molding$/, '');
            });
            return allowedAmNorm.indexOf(baseChoiceVal) === -1;
            // --- Dp end 31-07 — Applied Molding renaming support ---
        }

        /* MERGE: product_wise_edge_profile_sdl sdl_profile option filter — start */
        if (optId === 'sdl_profile') {
            var selectedStileForSdl = '';
            try {
                var mainOpts = document.getElementById('door-configurator-options');
                var checkedStile = mainOpts
                    && mainOpts.querySelector('input[type="radio"][data-option-id="stile_and_rail_profile"]:checked');
                if (checkedStile && checkedStile.value) selectedStileForSdl = checkedStile.value;
            } catch (eStileSdl) { selectedStileForSdl = ''; }
            var allowedSdl = getProductWiseSdlProfileAllowedValues(productWiseConfig, selectedStileForSdl);
            if (!allowedSdl) return null;
            var choiceCanon = canonicalProductWiseSdlKey(choiceVal);
            for (var si = 0; si < allowedSdl.length; si++) {
                if (canonicalProductWiseSdlKey(allowedSdl[si]) === choiceCanon) return false;
            }
            return true;
        }
        /* MERGE: product_wise_edge_profile_sdl sdl_profile option filter — end */

        return null;
    }

    function optionHasProductWiseEdgeProfileFilter(optId, productWiseConfig) {
        if (!productWiseConfig || !optId) return false;
        var norm = normProductWiseChoiceKey(optId);
        if (norm === 'stile_and_rail_profile') {
            /* MERGE: product_wise_edge_profile_sdl stile_and_rail_profile_check — start */
            return !!getProductWiseStileAndRailAllowedValues(productWiseConfig);
            /* MERGE: product_wise_edge_profile_sdl stile_and_rail_profile_check — end */
        }
        if (norm === 'applied_molding' || norm === 'applied_molding_choice') {
            /* MERGE: product_wise_applied_molding_accordion — start */
            var amModeHas = getProductWiseAppliedMoldingMode(productWiseConfig);
            if (amModeHas === 'rm5') return true;
            if (amModeHas === 'all' || amModeHas === 'hide') return false;
            /* MERGE: product_wise_applied_molding_accordion — end */
            return !!getProductWiseAllowedValues(productWiseConfig, 'applied_molding')
                || !!getProductWiseAllowedValues(productWiseConfig, 'applied_molding_choice');
        }
        /* MERGE: product_wise_edge_profile_sdl sdl_profile option filter — start */
        if (norm === 'sdl_profile') {
            return !!getProductWiseSdlProfileAllowedValues(productWiseConfig);
        }
        /* MERGE: product_wise_edge_profile_sdl sdl_profile option filter — end */
        return false;
    }

    /**
     * Product-wise applied_molding accordion mode (when stile Applied Molding is selected):
     *   "rm5" -> only RM5 (selected)
     *   "all" -> all molding choices allowed by collection show_when_product_tags
     *   anything else (no / empty / other) -> hide accordion always
     *   null when metafield has no applied_molding key (stile-driven show/hide only)
     * Section visibility itself always requires stile applied_molding_choice selected.
     */
    /* MERGE: product_wise_applied_molding_accordion — start */
    function getProductWiseAppliedMoldingMode(productWiseConfig) {
        if (!productWiseConfig || !Object.prototype.hasOwnProperty.call(productWiseConfig, 'applied_molding')) {
            return null;
        }
        var raw = productWiseConfig.applied_molding;
        if (raw == null) return 'hide';
        var v = normProductWiseChoiceKey(Array.isArray(raw) ? (raw[0] || '') : raw);
        if (v === 'all') return 'all';
        if (v === 'rm5' || v === 'rm_5') return 'rm5';
        return 'hide';
    }

    function shouldForceShowAppliedMoldingByProductWise(productWiseConfig) {
        // Applied Molding accordion is merged into stile_and_rail_profile — never force-show.
        return false;
    }

    function shouldHideAppliedMoldingByProductWise(productWiseConfig) {
        // Always hide standalone Applied Molding accordion.
        return true;
    }
    /* MERGE: product_wise_applied_molding_accordion — end */

    function shouldHideSdlProfileByProductWise(productWiseConfig) {
        if (!productWiseSdlProfileKeyIsActive(productWiseConfig)) return null;
        var v = productWiseConfig.sdl_profile;
        if (v === true || v === 1 || v === '1' || String(v).toLowerCase() === 'true') return false;
        if (v === false || v === 0 || v === '0' || String(v).toLowerCase() === 'false') return true;
        return null;
    }

    function shouldForceShowSdlProfileByProductWise(productWiseConfig) {
        if (!productWiseConfig || !Object.prototype.hasOwnProperty.call(productWiseConfig, 'sdl_profile')) return false;
        var v = productWiseConfig.sdl_profile;
        if (v === true || v === 1 || v === '1' || String(v).toLowerCase() === 'true') return true;
        /* MERGE: product_wise_edge_profile_sdl sdl_profile option filter — start */
        // Specific option(s) like "cove" also force-show the SDL section (then filter to only that option).
        if (getProductWiseSdlProfileAllowedValues(productWiseConfig)) return true;
        /* MERGE: product_wise_edge_profile_sdl sdl_profile option filter — end */
        return false;
    }
    /* MERGE: product_wise_edge_profile_sdl — end */

    window.DoorConf2Update = window.DoorConf2Update || {};
    window.DoorConf2Update.syncDoorSealKitMatchingAddonPrice = syncDoorSealKitMatchingAddonPrice;
    window.DoorConf2Update.syncDoorSweepsMatchingAddonPrice = syncDoorSweepsMatchingAddonPrice;
    window.DoorConf2Update.syncPrimingServicesAddonPrice = syncPrimingServicesAddonPrice;
    window.DoorConf2Update.syncAppliedMoldingTierAddonPrice = syncAppliedMoldingTierAddonPrice;
    window.DoorConf2Update.applyCatalogMetaobjectAddons = applyCatalogMetaobjectAddons;
    window.DoorConf2Update.isAppliedMoldingStileActive = isAppliedMoldingStileActive;
    window.DoorConf2Update.isAppliedMoldingPricingActive = isAppliedMoldingPricingActive;
    window.DoorConf2Update.ensureDoorPriceBoxVisible = ensureDoorPriceBoxVisible;
    window.DoorConf2Update.bootHubspotIntegration = bootHubspotIntegration;
    window.DoorConf2Update.enhanceDoorSelectWithDivDropdown = enhanceDoorSelectWithDivDropdown;
    window.DoorConf2Update.enhanceAllDoorConfiguratorSelects = enhanceAllDoorConfiguratorSelects;
    window.DoorConf2Update.syncDoorDivSelectFromNative = syncDoorDivSelectFromNative;
    window.DoorConf2Update.rebuildDoorDivSelectOptions = rebuildDoorDivSelectOptions;
    window.DoorConf2Update.patchAriaControls = patchAriaControls;
    window.DoorConf2Update.hideThemeDrawerTriggers = hideThemeDrawerTriggers;
    window.DoorConf2Update.openWoodSpeciesDrawer = openWoodSpeciesDrawer;
    window.DoorConf2Update.getWoodSpeciesModalDrawerId = getWoodSpeciesModalDrawerId;
    window.DoorConf2Update.openInsertsInfoDrawer = openInsertsInfoDrawer;
    window.DoorConf2Update.getInsertsInfoDrawerAriaControls = getInsertsInfoDrawerAriaControls;
    window.DoorConf2Update.openMeasureGuideDrawer = openMeasureGuideDrawer;
    window.DoorConf2Update.getMeasureGuideDrawerAriaControls = getMeasureGuideDrawerAriaControls;
    window.DoorConf2Update.openScreenTypesDrawer = openScreenTypesDrawer;
    window.DoorConf2Update.getScreenTypesDrawerAriaControls = getScreenTypesDrawerAriaControls;
    window.DoorConf2Update.openStormGlassDrawer = openStormGlassDrawer;
    window.DoorConf2Update.getStormGlassDrawerAriaControls = getStormGlassDrawerAriaControls;
    window.DoorConf2Update.openEdgeProfileDrawer = openEdgeProfileDrawer;
    window.DoorConf2Update.getEdgeProfileDrawerAriaControls = getEdgeProfileDrawerAriaControls;
    window.DoorConf2Update.openDoorSetupDrawer = openDoorSetupDrawer;
    window.DoorConf2Update.getDoorSetupDrawerAriaControls = getDoorSetupDrawerAriaControls;
    window.DoorConf2Update.openPanelProfileDrawer = openPanelProfileDrawer;
    window.DoorConf2Update.getPanelProfileDrawerAriaControls = getPanelProfileDrawerAriaControls;
    window.DoorConf2Update.openLocksetPrepDrawer = openLocksetPrepDrawer;
    window.DoorConf2Update.getLocksetPrepDrawerAriaControls = getLocksetPrepDrawerAriaControls;
    // Restore the saved casing pick (product + length + qty) on the config_id edit page.
    window.DoorConf2Update.restoreCasingSelection = restoreCasingSelection;
    // Read current casing pick for save / admin capture (mirrors hardware getHardwareSelectionsForConfig).
    window.DoorConf2Update.getCasingSelectionsForConfig = getCasingSelectionsForConfig;
    // Restore millwork wood / length / thickness on the config_id edit page.
    window.DoorConf2Update.restoreMillworkSelectionsFromSaved = restoreMillworkSelectionsFromSaved;
    window.DoorConf2Update.getMillworkSummaryItemsForConfig = getMillworkSummaryItemsForConfig;
    // Restore landing-hardware finish / function / closer color / swing / backset / etc.
    window.DoorConf2Update.restoreLandingHardwareSelectionsFromSaved = restoreLandingHardwareSelectionsFromSaved;
    window.DoorConf2Update.captureLandingHardwareSummaryEntries = captureLandingHardwareSummaryEntries;
    window.DoorConf2Update.mergeLandingHardwareIntoSelections = mergeLandingHardwareIntoSelections;
    window.DoorConf2Update.mergeLandingHardwareSchemaKeys = mergeLandingHardwareSchemaKeys;
    window.DoorConf2Update.buildLandingHardwareLineItemProperties = buildLandingHardwareLineItemProperties;
    window.DoorConf2Update.updateLandingProductMediaFromSwatch = updateLandingProductMediaFromSwatch;
    window.DoorConf2Update.LANDING_HARDWARE_RESTORE_FIELDS = LANDING_HARDWARE_RESTORE_FIELDS;
    window.DoorConf2Hardware = window.DoorConf2Hardware || {};
    if (!window.DoorConf2Hardware.updateLandingProductMediaFromSwatch) {
        window.DoorConf2Hardware.updateLandingProductMediaFromSwatch = updateLandingProductMediaFromSwatch;
    }
    /* MERGE: product_wise_edge_profile_sdl — start */
    window.DoorConf2Update.getProductWiseEdgeProfileSdlFromMain = getProductWiseEdgeProfileSdlFromMain;
    window.DoorConf2Update.resolveChoiceProductWiseEdgeProfileShouldHide = resolveChoiceProductWiseEdgeProfileShouldHide;
    window.DoorConf2Update.optionHasProductWiseEdgeProfileFilter = optionHasProductWiseEdgeProfileFilter;
    window.DoorConf2Update.shouldHideSdlProfileByProductWise = shouldHideSdlProfileByProductWise;
    window.DoorConf2Update.shouldForceShowSdlProfileByProductWise = shouldForceShowSdlProfileByProductWise;
    window.DoorConf2Update.getProductWiseSdlProfileAllowedValues = getProductWiseSdlProfileAllowedValues;
    /* MERGE: product_wise_edge_profile_sdl — end */
    /* MERGE: product_wise_applied_molding_accordion — start */
    window.DoorConf2Update.getProductWiseAppliedMoldingMode = getProductWiseAppliedMoldingMode;
    window.DoorConf2Update.shouldForceShowAppliedMoldingByProductWise = shouldForceShowAppliedMoldingByProductWise;
    window.DoorConf2Update.shouldHideAppliedMoldingByProductWise = shouldHideAppliedMoldingByProductWise;
    /* MERGE: product_wise_applied_molding_accordion — end */

    function bindAppliedMoldingConfiguratorRefresh() {
        if (window.__doorAppliedMoldingConfiguratorRefreshBound) return;
        window.__doorAppliedMoldingConfiguratorRefreshBound = true;
        document.addEventListener('change', function (e) {
            var t = e && e.target;
            if (!t || !t.getAttribute) return;
            var oid = String(t.getAttribute('data-option-id') || '');
            if (
                oid !== 'wood_type'
                && oid !== 'wood_type_storm_porch'
                && oid !== 'applied_molding'
                && oid !== 'applied_molding_choice'
                && oid !== 'stile_and_rail_profile'
            ) return;
            if (!t.closest || !t.closest('#door-configurator')) return;
            if (window.__doorAppliedMoldingRefreshTimer) clearTimeout(window.__doorAppliedMoldingRefreshTimer);
            window.__doorAppliedMoldingRefreshTimer = setTimeout(function () {
                window.__doorAppliedMoldingRefreshTimer = null;
                if (typeof window.__doorUpdateEstimatedPrice === 'function') {
                    window.__doorUpdateEstimatedPrice();
                }
            }, 100);
        }, true);
    }

    function boot() {
        hideThemeDrawerTriggers();
        setTimeout(hideThemeDrawerTriggers, 0);
        setTimeout(hideThemeDrawerTriggers, 300);
        setTimeout(patchAriaControls, 0);
        setTimeout(patchAriaControls, 300);
        setTimeout(patchAriaControls, 1000);
        setTimeout(patchAriaControls, 2500);
        setTimeout(bootCasingProducts, 150);
        setTimeout(bootLandingHardwareConfig, 0);
        setTimeout(bootLandingHardwareConfig, 300);
        setTimeout(bootMillworkLengthConfig, 0);
        setTimeout(bootMillworkLengthConfig, 300);
        setTimeout(bootDoorDivSelectEnhancement, 0);
        setTimeout(bootDoorDivSelectEnhancement, 300);
        setTimeout(bootDoorDivSelectEnhancement, 800);
        bindDoorDivSelectMutationObserver();
        bindWoodDrawerTipButtons();
        bindInsertsDrawerTipButtons();
        bindConfiguratorAboutDrawerButtons();
        bindConfiguratorDrawerAriaObserver();
        bindAppliedMoldingConfiguratorRefresh();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();

function scrollSelectedDoorDivOptionIntoView(divWrap) {
    if (!divWrap) return;
    var list = divWrap.querySelector('.door-div-select__list');
    if (!list) return;

    // Selected option ko find karein
    var selectedItem = list.querySelector('.door-div-select__item[aria-selected="true"]');
    if (!selectedItem) return;
    // Dropdown open hone ke baad scroll calculate karein
    setTimeout(function () {
        // Option 1: Selected item ko dropdown list ke top par scroll karein
        list.scrollTop = selectedItem.offsetTop;
        // Ya alternative (smooth scroll nearest view ke liye):
        // selectedItem.scrollIntoView({ block: 'nearest' });
    }, 10);
}